(function() {
    'use strict';

    angular
        .module('jmrsignApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'angular.filter',
            'ui.mask',
            'jtt_imagesLoaded',
            'angulartics',
            'angulartics.google.analytics',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'uiCropper'
        ])
        .run(run);


    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }

})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SignViewController', SignViewController);

    SignViewController.$inject = ['$scope', '$rootScope', '$stateParams',  '$state',
    'previousState', 'DataUtils', 'entity', 'workItem', 'entityWorkflow', 'entityPages',
    'Document', 'DocumentWorkItem', 'DocumentVersion', 'AppAccount', 'SignSvc'];

    function SignViewController($scope, $rootScope, $stateParams, $state,
        previousState, DataUtils, entity, workItem, entityWorkflow, entityPages,
        Document, DocumentWorkItem, DocumentVersion, AppAccount, SignSvc) {
        var vm = this;

        vm.document = entity;
        vm.workItem = workItem;
        vm.documentWorkitems = entityWorkflow;
        vm.documentPages = entityPages;
        vm.previousState = previousState.name;
        vm.signDocument = signDocument;
        vm.rejectDocument = rejectDocument;

        $scope.totalItems = entityPages.length;
        $scope.currentPage = 1;

        SignSvc.logEvent({id : vm.workItem.id}, {
            eventGroup: 'WORKITEM',
            description: vm.workItem.legalName + ' viewed the document review page.',
            restricted: false,
            type: 'INFO'
        });

        $scope.setPage = function(pageNo) {
            $scope.currentPage = pageNo;
        };

        function signDocument(){
            swal({
                    title: "Legal Statement",
                    text: "I, " + vm.workItem.legalName + ", hereby declare that I have read and understand the contents of this document.",

                    showCancelButton: true,
                    //confirmButtonColor: "#DD6B55",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes, I agree",
                    closeOnConfirm: false
                },
                function() {
                    swal.close();
                    if(vm.workItem.requireInitialPage) {
                        $state.go('sign.initial');
                    }
                    else {
                        $state.go('sign.capture');
                    }
                });
        };

        function rejectDocument(){
            swal({
              title: "Reject Document",
              text: "Please provide a reason below as to why you are declining to sign this document:",
              type: "input",
              showCancelButton: true,
              closeOnConfirm: false,
              inputPlaceholder: "Supply reason"
            },
            function(inputValue){
              if (inputValue === false) return false;

              if (inputValue === "") {
                swal.showInputError("Please provide a reason.");
                return false
              }

              SignSvc.reject({
                    id: vm.workItem.id
                }, inputValue ,
                    function() {

                        $state.go('inbox');
                        swal(
                            {
                              title: "Document",
                              type: "error",
                              text: "Has been rejected.",
                              timer: 2000,
                              showConfirmButton: false
                            });
                });
            });

        };
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sign', {
                parent: 'app',
                url: '/sign/{id}/{wiid}',
                data: {
                    authorities: [],
                    pageTitle: 'jmrsignApp.document.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/sign/landing.html',
                        controller: 'SignLandingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                        return DocumentSvc.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    workItem: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.get({
                            documentId: $stateParams.id,
                            id: $stateParams.wiid
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'inbox',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };

                        return currentStateData;
                    }]
                }
            })
            .state('sign.info', {
                parent: 'sign',
                url: '/info',
                data: {
                    authorities: [],
                    pageTitle: 'jmrsignApp.document.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/sign/info.html',
                        controller: 'SignInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                        return DocumentSvc.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    workItem: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.get({
                            documentId: $stateParams.id,
                            id: $stateParams.wiid
                        }).$promise;
                    }],
                    entityWorkflow: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.query({
                            documentId: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'inbox',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };

                        return currentStateData;
                    }]
                }
            })
            .state('sign.view', {
                parent: 'sign',
                url: '/view',
                data: {
                    authorities: [],
                    pageTitle: 'jmrsignApp.document.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/sign/view.html',
                        controller: 'SignViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                        return DocumentSvc.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    workItem: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.get({
                            documentId: $stateParams.id,
                            id: $stateParams.wiid
                        }).$promise;
                    }],
                    entityPages: ['$stateParams', 'DocumentPageSvc', function($stateParams, DocumentPageSvc) {
                        return DocumentPageSvc.query({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    entityWorkflow: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.query({
                            documentId: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'inbox',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };

                        return currentStateData;
                    }]
                }
            })
            .state('sign.initial', {
                parent: 'sign',
                url: '/initial',
                data: {
                    authorities: [],
                    pageTitle: 'jmrsignApp.document.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/sign/initial.html',
                        controller: 'SignInitialController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                        return DocumentSvc.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    workItem: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.get({
                            documentId: $stateParams.id,
                            id: $stateParams.wiid
                        }).$promise;
                    }],
                    entityPages: ['$stateParams', 'DocumentPageSvc', function($stateParams, DocumentPageSvc) {
                        return DocumentPageSvc.query({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    entityWorkflow: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.query({
                            documentId: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'inbox',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };

                        return currentStateData;
                    }]
                }
            })
            .state('sign.capture', {
                parent: 'sign',
                url: '/sign',
                data: {
                    authorities: [],
                    pageTitle: 'jmrsignApp.document.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/sign/capture.html',
                        controller: 'SignCaptureController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                        return DocumentSvc.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    workItem: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                        return DocumentWorkitemSvc.get({
                            documentId: $stateParams.id,
                            id: $stateParams.wiid
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'inbox',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };

                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SignLandingController', SignLandingController);

    SignLandingController.$inject = ['$scope', '$rootScope', '$stateParams', '$state',
    'previousState', 'DataUtils', 'entity', 'workItem', 'Principal',
    'AppPartySvc', 'PartySvc','LoginService'];

    function SignLandingController($scope, $rootScope, $stateParams, $state,
        previousState, DataUtils, entity, workItem, Principal,
        AppPartySvc, PartySvc, LoginService) {
        var vm = this;

        vm.login = LoginService.open;
        vm.document = entity;
        vm.party = null;
        vm.workItem = workItem;
        vm.previousState = previousState.name;
        vm.isAuthenticated = false;
        vm.viewDocument = viewDocument;

        // Security flags
        vm.wrongUser = false;
        vm.completed = false;
        vm.invalid = false;
        vm.requireLogin = false;

        function resetFlags() {
            vm.wrongUser = false;
            vm.completed = false;
            vm.invalid = false;
            vm.requireLogin = false;
        };

        Principal.identity(true).then(checkPrincipal);

        

        function checkPrincipal() {
            vm.isAuthenticated = Principal.isAuthenticated();
            if(checkWorkitem())
            {
                if(vm.isAuthenticated)
                {
                    // set account vs user menu permissions
                    AppPartySvc.get().$promise.then(loggedInUser);
                }
                else
                {
                    anonymousUser();
                }
            }
        };

        function loggedInUser(response) {
            console.log('-- LOGGED IN USER --');
            vm.party = response;

            if(checkUser(false))
            {
                viewDocument();
            }
        };

        function checkWorkitem() {
            vm.completed = vm.workItem.status == 'COMPLETED';
            vm.invalid = vm.workItem.status != 'NOTIFIED';

            return !vm.invalid;
        };

        function checkUser()
        {
            vm.wrongUser = vm.party.id != vm.workItem.partyId;
            return !vm.wrongUser;
        }

        function checkAnonUser(){
            vm.wrongUser = vm.party.userId != null;
            vm.requireLogin = true;

            return !vm.wrongUser && vm.requireLogin;
        };

        function anonymousUser() {
            console.log('-- ANONYMOUS USER --');

            // get workitem party
            PartySvc.get({id: vm.workItem.partyId}).$promise.then(function(response) {
                    vm.party = response;
                    if(checkAnonUser())
                    {
                        viewDocument();
                    };
            });
        };

        function viewDocument(){
            $state.go('sign.info');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SignInitialController', SignInitialController);

    SignInitialController.$inject = ['$scope', '$rootScope', '$stateParams',  '$state', '$window',
    'previousState', 'DataUtils', 'entity', 'workItem', 'entityWorkflow', 'entityPages',
    'Document', 'DocumentWorkItem', 'DocumentVersion', 'AppAccount', 'SignSvc'];

    function SignInitialController($scope, $rootScope, $stateParams, $state, $window,
        previousState, DataUtils, entity, workItem, entityWorkflow, entityPages,
        Document, DocumentWorkItem, DocumentVersion, AppAccount, SignSvc) {
        var vm = this;

        vm.document = entity;
        vm.workItem = workItem;
        vm.documentWorkitems = entityWorkflow;
        vm.documentPages = entityPages;
        vm.previousState = previousState.name;
        vm.signDocument = signDocument;
        vm.rejectDocument = rejectDocument;

        vm.totalItems = entityPages.length;
        vm.currentPage = 1;

        SignSvc.logEvent({id : vm.workItem.id}, {
            eventGroup: 'WORKITEM',
            description: vm.workItem.legalName + ' has started the process of initialling document page.',
            restricted: false,
            type: 'INFO'
        });

        $scope.setPage = function(pageNo) {

            SignSvc.logEvent({id : vm.workItem.id}, {
                eventGroup: 'WORKITEM',
                description: vm.workItem.legalName + ' declared they have read and understood the contents of page ' + vm.currentPage + ' of this document.',
                restricted: false,
                type: 'SUCCESS'
            });

            if(vm.currentPage < vm.totalItems)
            {
                vm.currentPage = pageNo;
            }
            else {
                $state.go('sign.capture');
            }

        };

        function signDocument(){
            swal({
                    title: "Legal Statement",
                    text: "I, " + vm.workItem.legalName + ", hereby declare that I have read and understand the contents of page " + vm.currentPage + " of this document.",

                    showCancelButton: true,
                    //confirmButtonColor: "#DD6B55",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes, I agree",
                    closeOnConfirm: false
                },
                function() {

                    swal.close();
                    $scope.setPage(vm.currentPage+1);
                    $window.scrollTo(0, 0);

                });
        };

        function rejectDocument(){
            swal({
              title: "Reject Document",
              text: "Please provide a reason below as to why you are declining to sign this document:",
              type: "input",
              showCancelButton: true,
              closeOnConfirm: false,
              inputPlaceholder: "Supply reason"
            },
            function(inputValue){
              if (inputValue === false) return false;

              if (inputValue === "") {
                swal.showInputError("Please provide a reason.");
                return false
              }

              SignSvc.reject({
                    id: vm.workItem.id
                }, inputValue ,
                    function() {

                        $state.go('inbox');
                        swal(
                            {
                              title: "Document",
                              type: "error",
                              text: "Has been rejected.",
                              timer: 2000,
                              showConfirmButton: false
                            });
                });
            });

        };
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SignInfoController', SignInfoController);

    SignInfoController.$inject = ['$scope', '$rootScope', '$stateParams', '$state',
    'previousState', 'DataUtils', 'entity', 'workItem', 'entityWorkflow',
    'Document', 'DocumentWorkItem', 'DocumentVersion', 'AppAccount', 'SignSvc'];

    function SignInfoController($scope, $rootScope, $stateParams, $state,
        previousState, DataUtils, entity, workItem, entityWorkflow,
        Document, DocumentWorkItem, DocumentVersion, AppAccount, SignSvc) {
        var vm = this;

        vm.document = entity;
        vm.workItem = workItem;
        vm.documentWorkitems = entityWorkflow;
        vm.previousState = previousState.name;
        vm.viewDocument = viewDocument;

        SignSvc.logEvent({id : vm.workItem.id}, {
            eventGroup: 'WORKITEM',
            description: vm.workItem.legalName + ' viewed the document information page.',
            restricted: false,
            type: 'INFO'
        });

        function viewDocument(){
            $state.go('sign.view');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SignCaptureController', SignCaptureController);

    SignCaptureController.$inject = ['$scope', '$rootScope', '$stateParams', '$state',
    'previousState', 'DataUtils', 'entity', 'workItem',
    'Document', 'DocumentVersion','PartySvc','SignSvc', 'Principal',
    '$timeout', 'DocumentWorkitemsSvc'  // JSS-54
    ];

    function SignCaptureController($scope, $rootScope, $stateParams, $state,
            previousState, DataUtils, entity, workItem,
            Document, DocumentVersion, PartySvc, SignSvc, Principal,
            $timeout, DocumentWorkitemsSvc
        ) {
        var vm = this;

        vm.credentials = { pin: null };
        vm.account = null;
        vm.party = null;
        vm.document = entity;
        vm.workItem = workItem;
        vm.requireOTP = vm.workItem.requireTwoStepAuth;
        vm.requireCode = vm.workItem.requireAccessCode;
        vm.previousState = previousState.name;
        vm.signDocument = signDocument;
        vm.resendOTP = resendOTP;
        vm.isAuthenticated = false;
        vm.wia = null;
        vm.date = new Date();

        // JSS-54
        $scope.workItemsResponseData = [];
        $scope.userWorkItems = [];

        SignSvc.logEvent({id : vm.workItem.id}, {
            eventGroup: 'WORKITEM',
            description: vm.workItem.legalName + ' initiated document signing process.',
            restricted: false,
            type: 'INFO'
        });

        Principal.identity(true).then(checkPrincipal);
        function checkPrincipal() {
            vm.isAuthenticated = Principal.isAuthenticated();
        };

        PartySvc.get({id : vm.workItem.partyId}).$promise.then(function(party) {
            vm.party = party;
            console.log(vm.party);
        });

        console.log(vm.workItem.id);
        SignSvc.requestOTP({id : vm.workItem.id}, false).$promise.then(function(result) {
            vm.wia = result;
        });

        function signDocument(){

            if(vm.requireOTP)
            {
                SignSvc.validateOTP({
                        id: vm.workItem.id
                    }, vm.credentials ,
                        successfulOTP,
                        failedOTP);
            }
            else
            {
                successfulOTP();
            }

        };

        function successfulOTP(result) {
            // success
            SignSvc.complete({
                    id: vm.workItem.id
                }, {} ,
                successfulSign,
                failedSign);
        };

        function successfulSign(result) {
        	if(vm.isAuthenticated)
            {
        		$state.go('inbox');
            }
        	else
        	{
        		$state.go('register');
        	}
            swal(
                {
                    title: "Document",
                    type: "success",
                    text: "Has been signed.",
                    timer: 2000,
                    showConfirmButton: false
            });
        };

        function failedSign(result) {
            swal(
                {
                    title: "Document cannot be signed.",
                    type: "error",
                    text: "Please contact your administrator.",
                    timer: 2200,
                    showConfirmButton: false
            });
        };

        function failedOTP(result) {
            // fail
            swal(
                {
                    title: "PIN is not correct.",
                    type: "error",
                    text: "Please verify you have entered the correct value.",
                    timer: 2200,
                    showConfirmButton: false
            });
        };

        function resendOTP() {
            SignSvc.requestOTP({id : vm.workItem.id}, true).$promise.then(function(result) {
                vm.wia = result;
            });
        };

        function validatePIN(data) {
            console.log('success');
            console.log(data);
        }

        // JSS-54
        getWorkItems();

        // JSS-54
        function getWorkItems() {
            DocumentWorkitemsSvc.getWorkItems(vm.document.id).then(function(response) {
                $scope.workItemsResponseData = response.data;

                for (var i = 0; i < $scope.workItemsResponseData.length; i++) {
                    if (vm.party.id === $scope.workItemsResponseData[i].partyId) {
                        $scope.userWorkItems.push($scope.workItemsResponseData[i]);
                    }
                }
            });
        }

        // JSS-54
        angular.element(document).ready(function () {
             $timeout(function() {
                 for (var i = 0; i < $scope.userWorkItems.length; i++) {
                    if ($scope.userWorkItems[i].pageNo !== null) {
                        if (vm.party.id == $scope.userWorkItems[i].partyId) {
                            $('img#document-image-'+$scope.userWorkItems[i].pageNo).selectAreas({
                                minSize: [150, 60],
                                allowEdit: false,
                                areas: [
                                    {
                                        x: $scope.userWorkItems[i].xPos,
                                        y: $scope.userWorkItems[i].yPos,
                                        width: 150,
                                        height: 60
                                    }
                                ]
                            });
                        }
                    }
                 }
             }, 100);
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('SignSvc', SignSvc);

    SignSvc.$inject = ['$resource', 'DateUtils', 'JmrAuth'];

    function SignSvc ($resource, DateUtils, JmrAuth) {
        var resourceUrl =  'api/accounts/:accountId/sign/:id';

        return $resource(resourceUrl, {
            accountId : JmrAuth.currentAccountId,
            }, {
            // Returns the documents associated to account
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        //TODO fix
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.expireDate = DateUtils.convertDateTimeFromServer(data.expireDate);
                    }
                    return data;
                }
            },
            'complete': {
                method:'POST',
                url: resourceUrl + '/completeAction'
            },
            'remind': {
                method:'POST',
                url: resourceUrl + '/remindAction'
            },
            'reject': {
                method:'POST',
                url: resourceUrl + '/rejectAction'
            },
            'requestOTP': {
                method:'POST',
                url: resourceUrl + '/requestOTP'
            },
            'validateOTP': {
                method:'POST',
                url: resourceUrl + '/validateOTP'
            },
            'logEvent': {
                method:'POST',
                url: resourceUrl + '/logEvent'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info/' + location.hostname).then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        //TODO enable
                        //response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;

                        //JMR-SIGN Properties
                        response.accountId = result.data.accountId;
                        response.siteTitle = result.data.siteTitle;
                        response.logoImg = result.data.logoImg;
                        response.logoImgContentType = result.data.logoImgContentType;
                        
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
	'use strict';
	angular.module('jmrsignApp').factory('PartyManagement', PartyManagement);

	PartyManagement.$inject = [ '$resource', 'JmrAuth', '$q' ];

	function PartyManagement($resource, JmrAuth, $q) {
		var resourceUrl = 'api/accounts/:accountId/parties/:id';
		console.log(resourceUrl);

		return $resource(resourceUrl, {
			accountId : JmrAuth.currentAccountId
		}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'search' : {
				method : 'GET',
				url :resourceUrl + '/search?q=:search',
				isArray : true
			},
			'searchText' : {
				method : 'GET',
				url :resourceUrl + '/searchText?keyword=:searchText',
				isArray : true
			},
			'update' : {
				method : 'PUT'
			},

		}, {
			'get' : {
				method : 'GET',
			},
			transformResponse : function(data) {
				if (data) {
					data = angular.fromJson(data);
				}
				return data;
				console.log(data);
				console.log(resourceUrl);
			}
		}, {

			'bulkUpload' : {
				url : resourceUrl + '/bulkUpload',
				method : 'POST'
			}

		});
	}
})();

(function() {
	'use strict';
	angular.module('jmrsignApp').factory('PartySvc', PartySvc);

	PartySvc.$inject = [ '$resource', 'JmrAuth' ];

	function PartySvc($resource, JmrAuth) {
		var resourceUrl = 'api/accounts/:accountId/parties/:id';

		return $resource(resourceUrl, {	
			accountId : JmrAuth.currentAccountId
		}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET'
			},
			'save' : {
				method : 'POST'
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

// JSS-54
(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('DocumentWorkitemsSvc', DocumentWorkitemsSvc);

    DocumentWorkitemsSvc.$inject = ['JmrAuth', '$resource', '$http', '$timeout'];

    function DocumentWorkitemsSvc (JmrAuth, $resource, $http, $timeout) {
        return {
            getWorkItems: function(documentId) {
                var accountId = JmrAuth.currentAccountId();
                var workItems = getWorkItems(documentId, accountId);

                return workItems;
            }
        }

        function getWorkItems(documentId, accountId) {
            var resourceUrl =  'api/accounts/' + accountId + '/documents/' + documentId + '/workitems';
            return $http.get(resourceUrl);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentWorkitemSvc', DocumentWorkitemSvc);

    DocumentWorkitemSvc.$inject = ['$resource', 'DateUtils', 'JmrAuth'];

    function DocumentWorkitemSvc ($resource, DateUtils, JmrAuth) {
        var resourceUrl =  'api/accounts/:accountId/documents/:documentId/workitems/:id';

        return $resource(resourceUrl, {
            accountId : JmrAuth.currentAccountId,
            }, {
            // Returns the documents associated to account
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentPageSvc', DocumentPageSvc);

    DocumentPageSvc.$inject = ['$resource', 'DateUtils', 'JmrAuth'];

    function DocumentPageSvc ($resource, DateUtils, JmrAuth) {
        var resourceUrl =  'api/accounts/:accountId/documents/:id/pages';

        return $resource(resourceUrl, {
            accountId : JmrAuth.currentAccountId,
            }, {
            // Returns the documents associated to account
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
	'use strict';
	angular.module('jmrsignApp').factory('DocumentSvc', DocumentSvc);

	DocumentSvc.$inject = [ '$resource', 'DateUtils', 'JmrAuth'];

	function DocumentSvc($resource, DateUtils, JmrAuth) {
		var resourceUrl = 'api/accounts/:accountId/documents/:id';
		
		return $resource(resourceUrl, {
			accountId : JmrAuth.currentAccountId,
		}, {
			// Returns the documents associated to account
			'query' : {
				method : 'GET',
				isArray : true
			},
			'filterSearch' : {
				url : resourceUrl + '/filterSearch?keyword=:filterSearch',
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
						data.createDate = DateUtils
								.convertDateTimeFromServer(data.createDate);
						data.expireDate = DateUtils
								.convertDateTimeFromServer(data.expireDate);
					}
					return data;
					console.log(data);
				}
			},
			'upload' : {
				method : 'POST'
			},
			'download' : {
				url : resourceUrl + '/fromURL',
				method : 'POST'
			},
			'delete' : {
				method : 'DELETE'
			},
			'lock' : {
				url : resourceUrl + '/lock',
				method : 'POST'
			},
			'events' : {
				url : resourceUrl + '/events',
				method : 'GET',
				isArray : true
			},
			
			'cancel' : {
				url : resourceUrl + '/cancel',
				method : 'PUT'
			},
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,

            isRegistered: isRegistered,
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                //JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isRegistered () {
            if (!_authenticated) {
                return $q.when(false);
            }
            return _identity.parties && _identity.parties.length > 0;
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('JmrAuth', JmrAuth);

    JmrAuth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal','ProfileService', 'AppAccountSvc'];

    function JmrAuth($rootScope, $state, $sessionStorage, $q, Principal, ProfileService, AppAccountSvc) {

        var _parties = null;
        var _profile = null;

        var service = {
            hasAccount: hasAccount,
            hasCurrentAccount: hasCurrentAccount,
            hasAnyAccount: hasAnyAccount,
            currentPartyId: currentPartyId,
            currentAccountId: currentAccountId,
            canRegister: canRegister
        };

        loadAuthorities();

        //$rootScope.$watch(function() {
        //    return Principal.isAuthenticated();
        //}, function() {
        //    loadAuthorities();
        //});

        return service;

        function loadAuthorities() {
            Principal.identity().then(function(_id) {
                // TODO gets called twice
                if (_id) {
                    console.log('-- Load Authorities --');
                    _parties = _id.parties;
                } else {
                    console.log('-- Remove Authorities --');
                    _parties = null;
                }
            }, function() {
                console.log('-- Remove Authorities --');
                _parties = null;
            });

            ProfileService.getProfileInfo().then(function(response) {
                _profile = response;
            });
        };

        function hasAccount(accountId) {

            loadAuthorities();

            //if (!_parties) {
            //    loadAuthorities();
            //}

            for (var i = 0; i < _parties.length; i++) {
                if (_parties[i].accountId == accountId) {
                    return true;
                }
            }

            return false;
        }

        function hasCurrentAccount() {

            return this.hasAccount(this.currentAccountId());
        }

        function hasAnyAccount() {
            if (!_parties) {
                loadAuthorities();
            }

            return _parties && _parties.length > 0;
        }

        function currentAccountId() {

            switch(window.location.hostname)
            {
                // Prod system
                case "my.eezisign.com": return 1;break;
                case "jmr.eezisign.com": return 2;break;
                case "biznews.eezisign.com": return 3;break;
                case "lateralunison.eezisign.com": return 4;break;
                case "tshepang.eezisign.com": return 5;break;
                case "itleaders.eezisign.com": return 6;break;
                case "sass.eezisign.com": return 7;break;
                case "mra.eezisign.com": return 8;break;
                // Demo system
                case "demo.eezisign.com": return 1;break;

                case "my.eezisign.local": return 1;break;
                case "jmr.eezisign.local": return 2;break;
                case "bcx.eezisign.local": return 3;break;

                default: return 1;break;
            };
        }

        function currentPartyId() {
            var currentAccountId = this.currentAccountId();

            if (!_parties) {
                loadAuthorities();
            }

            for (var i = 0; i < _parties.length; i++) {
                if (_parties[i].accountId == currentAccountId) {
                    return _parties[i].id;
                }
            }
        }

        function canRegister () {

            return AppAccountSvc.get({id: this.currentAccountId()}).$promise.then(function(result) {

                return result.allowUserRegistration;
            }, function(){
                return false;
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('canRegister', canRegister);

    canRegister.$inject = ['JmrAuth'];

    function canRegister(JmrAuth) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var flag = (attrs.canRegister == "true");
            console.log(flag);

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    JmrAuth.canRegister()
                        .then(function (result) {
                            console.log(result);
                            if (result && flag) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            defineVisibility(true);

                scope.$watch(function() {
                    return JmrAuth.currentAccountId();
                }, function() {
                    defineVisibility(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {
            //JhiTrackerService.disconnect();

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    //JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('AppPartySvc', AppPartySvc);

    AppPartySvc.$inject = ['$resource', 'JmrAuth'];

    function AppPartySvc ($resource, JmrAuth) {
        var resourceUrl =  'api/accounts/:accountId/party';

        return $resource(resourceUrl, {
            accountId : JmrAuth.currentAccountId
        }, {
            'get': { method: 'GET'}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('AppAccountSvc', AppAccountSvc);

    AppAccountSvc.$inject = ['$resource'];

    function AppAccountSvc ($resource) {
        var resourceUrl =  'api/accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/login/login.html',
                    controller: 'LoginPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('LoginPageController', LoginPageController);

    LoginPageController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function LoginPageController ($rootScope, $state, $timeout, Auth) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'login' || $state.current.name === 'home' || $state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('inbox');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', '$scope', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'AppPartySvc', 'JmrAuth'];

    function NavbarController ($state, $scope, Auth, Principal, ProfileService, LoginService, AppPartySvc, JmrAuth) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.title = "eezi-Sign";
        vm.party = null;
        vm.roleRank = 0;
        vm.disabled = false;
        vm.info = null;
        vm.accountId = JmrAuth.currentAccountId();


        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
            vm.info = response;
        });

        $scope.$watch(vm.isAuthenticated, function() {
            if(vm.isAuthenticated)
            {
                // set account vs user menu permissions
                AppPartySvc.get().$promise.then(function(response) {
                    vm.party = response;
                    vm.roleRank = rankRole(vm.party.type, vm.party.status);
                    vm.disabled = vm.party.status == 'DISABLED';
                });
            };
        });

        vm.login = login;
        vm.logout = logout;
        vm.minRole = minRole;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.showNav = showNav;
        vm.$state = $state;

        function minRole(type){
            return vm.roleRank >= rankRole(type);
        };

        function rankRole(type, status){

            if(status != null &&
                (status == 'RESTRICTED' ||
                status == 'DISABLED'))
            {
                return 0;
            }

            switch(type) {
                case "EXTERNAL_USER":
                    return 10;
                    break;
                case "INTERNAL_USER":
                    return 20;
                    break;
                case "ACCOUNT_USER":
                    return 30;
                    break;
                case "ADMIN":
                    return 99;
                    break;
                default:
                    return 0;
            }
        };

        function showNav() {
            return vm.$state.current.name != 'documents.sign';
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('inbox', {
            parent: 'app',
            url: '/inbox',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.inbox'
            },
            views: {
                'content@': {
                    templateUrl: 'app/inbox/inbox.html',
                    controller: 'InboxController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('inbox');
                    return $translate.refresh();
                }],
                party: ['$stateParams', 'AppPartySvc', function($stateParams, AppPartySvc) {
                    return AppPartySvc.get().$promise;
                }]
            }
        });
    }
})();




(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('InboxController', InboxController);

    InboxController.$inject = [
    '$scope', '$rootScope', 'Auth', 'Principal', 'party',
    'JmrAuth', 'LoginService', 'SignSvc', '$state'];

    function InboxController (
        $scope, $rootScope, Auth, Principal, party,
        JmrAuth, LoginService, SignSvc, $state) {
        var vm = this;

        vm.tabs = [
			{    
                title:'Inbox', 
                icon:'glyphicon-inbox', 
                items: vm.signItems,
                filter: { status: 'NOTIFIED' } },
			{ 
                title:'In Progress', 
                icon:'glyphicon-random', 
                items: vm.progItems,
                filter: { document : {status: 'IN_PROGRESS'}, type: 'EDITOR' } }
		];

        vm.account = null;
        console.log('ITEM');
        console.log(party.id);
        vm.party = party;
        vm.roleRank = rankRole(party.type, party.status);
        console.log('RANK:' + vm.roleRank + hasAccount() + party.status);
        vm.isAuthenticated = null;
        vm.hasAccount = hasAccount;
        vm.hasCurrentAccount = hasAccount;
        vm.login = LoginService.open;
        vm.logout = logout;
        vm.inboxItems = null;
        vm.searchText = '';
        vm.All = '';
        vm.minRole = minRole;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        function hasAccount() {
            return party.id != null
            && vm.party.status != 'DISABLED'
            && vm.party.status != 'RESTRICTED';
        };

        function minRole(type){
            return vm.roleRank >= rankRole(type);
        };

        function rankRole(type, status){

            if(status != null &&
                (status == 'RESTRICTED' ||
                status == 'DISABLED'))
            {
                return 0;
            }

            switch(type) {
                case "EXTERNAL_USER":
                    return 10;
                    break;
                case "INTERNAL_USER":
                    return 20;
                    break;
                case "ACCOUNT_USER":
                    return 30;
                    break;
                case "ADMIN":
                    return 99;
                    break;
                default:
                    return 0;
            }
        };


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                
                vm.account = account;
                //vm.isAuthenticated = Principal.isAuthenticated;
                //vm.hasAccount = JmrAuth.hasAccount('JMR');
                SignSvc.query(function(result) {
                    vm.inboxItems = result;
                    console.log(result);
                });
            });

        }

        function logout() {
            Auth.logout();
            $state.go('home');
        }

        var unsubscribe = $rootScope.$on('jmrsignApp:documentUpload', function(event, result) {
            vm.wi = result;
            $state.go('documents.setup', {id: vm.wi.documentId, wiid: vm.wi.id  }).then( function() { console.log($state.current) });
            
        });
        //$scope.$on('$destroy', unsubscribe);

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('RootCertController', RootCertController);

    RootCertController.$inject = ['$scope','$state'];

    function RootCertController ($scope, $state) {
        var vm = this;
        
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('root-cert', {
            parent: 'app',
            url: '/root-cert',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/root-cert.html',
                    controller: 'RootCertController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        //vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(vm.isAuthenticated()) {$state.go('inbox')}
                    else {$state.go('login')};
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyDialogController', PartyDialogController);

    PartyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Party', 'DocumentWorkItem', 'DocumentEvent', 'User', 'AppAccount'];

    function PartyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Party, DocumentWorkItem, DocumentEvent, User, AppAccount) {
        var vm = this;

        vm.party = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentworkitems = DocumentWorkItem.query();
        vm.documentevents = DocumentEvent.query();
        vm.users = User.query();
        vm.appaccounts = AppAccount.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.party.id !== null) {
                Party.update(vm.party, onSaveSuccess, onSaveError);
            } else {
                Party.save(vm.party, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:partyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setSignature = function ($file, party) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        party.signature = base64Data;
                        party.signatureContentType = $file.type;
                    });
                });
            }
        };

        vm.setSignatureImg = function ($file, party) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        party.signatureImg = base64Data;
                        party.signatureImgContentType = $file.type;
                    });
                });
            }
        };

        vm.setInitialImg = function ($file, party) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        party.initialImg = base64Data;
                        party.initialImgContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyDetailController', PartyDetailController);

    PartyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Party', 'DocumentWorkItem', 'DocumentEvent', 'User', 'AppAccount'];

    function PartyDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Party, DocumentWorkItem, DocumentEvent, User, AppAccount) {
        var vm = this;

        vm.party = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:partyUpdate', function(event, result) {
            vm.party = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyDeleteController',PartyDeleteController);

    PartyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Party'];

    function PartyDeleteController($uibModalInstance, entity, Party) {
        var vm = this;

        vm.party = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Party.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('party', {
            parent: 'entity',
            url: '/party',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.party.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/party/parties.html',
                    controller: 'PartyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('party');
                    $translatePartialLoader.addPart('partyType');
                    $translatePartialLoader.addPart('partyStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('party-detail', {
            parent: 'entity',
            url: '/party/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.party.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/party/party-detail.html',
                    controller: 'PartyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('party');
                    $translatePartialLoader.addPart('partyType');
                    $translatePartialLoader.addPart('partyStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Party', function($stateParams, Party) {
                    return Party.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'party',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('party-detail.edit', {
            parent: 'party-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Party', function(Party) {
                            return Party.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('party.new', {
            parent: 'party',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                internalSystemRef: null,
                                email: null,
                                firstName: null,
                                lastName: null,
                                cellNumber: null,
                                newCellNumber: null,
                                validationCode: null,
                                signature: null,
                                signatureContentType: null,
                                signatureImg: null,
                                signatureImgContentType: null,
                                initialImg: null,
                                initialImgContentType: null,
                                allowUserUpdate: false,
                                type: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('party', null, { reload: 'party' });
                }, function() {
                    $state.go('party');
                });
            }]
        })
        .state('party.edit', {
            parent: 'party',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Party', function(Party) {
                            return Party.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('party', null, { reload: 'party' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('party.delete', {
            parent: 'party',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/party/party-delete-dialog.html',
                    controller: 'PartyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Party', function(Party) {
                            return Party.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('party', null, { reload: 'party' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('Party', Party);

    Party.$inject = ['$resource'];

    function Party ($resource) {
        var resourceUrl =  'api/parties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyController', PartyController);

    PartyController.$inject = ['$scope', '$state', 'DataUtils', 'Party'];

    function PartyController ($scope, $state, DataUtils, Party) {
        var vm = this;
        
        vm.parties = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;


        function loadAll() {
            Party.query(function(result) {
                vm.parties = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemActionDialogController', DocumentWorkItemActionDialogController);

    DocumentWorkItemActionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'DocumentWorkItemAction', 'DocumentWorkItem'];

    function DocumentWorkItemActionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, DocumentWorkItemAction, DocumentWorkItem) {
        var vm = this;

        vm.documentWorkItemAction = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentworkitems = DocumentWorkItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentWorkItemAction.id !== null) {
                DocumentWorkItemAction.update(vm.documentWorkItemAction, onSaveSuccess, onSaveError);
            } else {
                DocumentWorkItemAction.save(vm.documentWorkItemAction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentWorkItemActionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        vm.setImageData = function ($file, documentWorkItemAction) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItemAction.imageData = base64Data;
                        documentWorkItemAction.imageDataContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemActionDetailController', DocumentWorkItemActionDetailController);

    DocumentWorkItemActionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'DocumentWorkItemAction', 'DocumentWorkItem'];

    function DocumentWorkItemActionDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, DocumentWorkItemAction, DocumentWorkItem) {
        var vm = this;

        vm.documentWorkItemAction = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentWorkItemActionUpdate', function(event, result) {
            vm.documentWorkItemAction = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemActionDeleteController',DocumentWorkItemActionDeleteController);

    DocumentWorkItemActionDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentWorkItemAction'];

    function DocumentWorkItemActionDeleteController($uibModalInstance, entity, DocumentWorkItemAction) {
        var vm = this;

        vm.documentWorkItemAction = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentWorkItemAction.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-work-item-action', {
            parent: 'entity',
            url: '/document-work-item-action',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItemAction.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-actions.html',
                    controller: 'DocumentWorkItemActionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItemAction');
                    $translatePartialLoader.addPart('workItemActionType');
                    $translatePartialLoader.addPart('workItemActionStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-work-item-action-detail', {
            parent: 'entity',
            url: '/document-work-item-action/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItemAction.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-detail.html',
                    controller: 'DocumentWorkItemActionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItemAction');
                    $translatePartialLoader.addPart('workItemActionType');
                    $translatePartialLoader.addPart('workItemActionStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentWorkItemAction', function($stateParams, DocumentWorkItemAction) {
                    return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-work-item-action',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-work-item-action-detail.edit', {
            parent: 'document-work-item-action-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-dialog.html',
                    controller: 'DocumentWorkItemActionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItemAction', function(DocumentWorkItemAction) {
                            return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item-action.new', {
            parent: 'document-work-item-action',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-dialog.html',
                    controller: 'DocumentWorkItemActionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                seqNo: null,
                                startDate: null,
                                endDate: null,
                                textData: null,
                                imageData: null,
                                imageDataContentType: null,
                                pageNo: null,
                                xPos: null,
                                yPos: null,
                                type: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-work-item-action', null, { reload: 'document-work-item-action' });
                }, function() {
                    $state.go('document-work-item-action');
                });
            }]
        })
        .state('document-work-item-action.edit', {
            parent: 'document-work-item-action',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-dialog.html',
                    controller: 'DocumentWorkItemActionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItemAction', function(DocumentWorkItemAction) {
                            return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item-action', null, { reload: 'document-work-item-action' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item-action.delete', {
            parent: 'document-work-item-action',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-delete-dialog.html',
                    controller: 'DocumentWorkItemActionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentWorkItemAction', function(DocumentWorkItemAction) {
                            return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item-action', null, { reload: 'document-work-item-action' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentWorkItemAction', DocumentWorkItemAction);

    DocumentWorkItemAction.$inject = ['$resource', 'DateUtils'];

    function DocumentWorkItemAction ($resource, DateUtils) {
        var resourceUrl =  'api/document-work-item-actions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemActionController', DocumentWorkItemActionController);

    DocumentWorkItemActionController.$inject = ['$scope', '$state', 'DataUtils', 'DocumentWorkItemAction'];

    function DocumentWorkItemActionController ($scope, $state, DataUtils, DocumentWorkItemAction) {
        var vm = this;
        
        vm.documentWorkItemActions = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            DocumentWorkItemAction.query(function(result) {
                vm.documentWorkItemActions = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemDialogController', DocumentWorkItemDialogController);

    DocumentWorkItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'DocumentWorkItem', 'DocumentWorkItemAction', 'DocumentEvent', 'Party', 'Document'];

    function DocumentWorkItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, DocumentWorkItem, DocumentWorkItemAction, DocumentEvent, Party, Document) {
        var vm = this;

        vm.documentWorkItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentworkitemactions = DocumentWorkItemAction.query();
        vm.documentevents = DocumentEvent.query();
        vm.parties = Party.query();
        vm.documents = Document.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentWorkItem.id !== null) {
                DocumentWorkItem.update(vm.documentWorkItem, onSaveSuccess, onSaveError);
            } else {
                DocumentWorkItem.save(vm.documentWorkItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentWorkItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        vm.setSignature = function ($file, documentWorkItem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItem.signature = base64Data;
                        documentWorkItem.signatureContentType = $file.type;
                    });
                });
            }
        };

        vm.setSignatureImg = function ($file, documentWorkItem) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItem.signatureImg = base64Data;
                        documentWorkItem.signatureImgContentType = $file.type;
                    });
                });
            }
        };

        vm.setInitialImg = function ($file, documentWorkItem) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItem.initialImg = base64Data;
                        documentWorkItem.initialImgContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemDetailController', DocumentWorkItemDetailController);

    DocumentWorkItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'DocumentWorkItem', 'DocumentWorkItemAction', 'DocumentEvent', 'Party', 'Document'];

    function DocumentWorkItemDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, DocumentWorkItem, DocumentWorkItemAction, DocumentEvent, Party, Document) {
        var vm = this;

        vm.documentWorkItem = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentWorkItemUpdate', function(event, result) {
            vm.documentWorkItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemDeleteController',DocumentWorkItemDeleteController);

    DocumentWorkItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentWorkItem'];

    function DocumentWorkItemDeleteController($uibModalInstance, entity, DocumentWorkItem) {
        var vm = this;

        vm.documentWorkItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentWorkItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-work-item', {
            parent: 'entity',
            url: '/document-work-item',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item/document-work-items.html',
                    controller: 'DocumentWorkItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItem');
                    $translatePartialLoader.addPart('workItemType');
                    $translatePartialLoader.addPart('workItemStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-work-item-detail', {
            parent: 'entity',
            url: '/document-work-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item/document-work-item-detail.html',
                    controller: 'DocumentWorkItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItem');
                    $translatePartialLoader.addPart('workItemType');
                    $translatePartialLoader.addPart('workItemStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentWorkItem', function($stateParams, DocumentWorkItem) {
                    return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-work-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-work-item-detail.edit', {
            parent: 'document-work-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-dialog.html',
                    controller: 'DocumentWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item.new', {
            parent: 'document-work-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-dialog.html',
                    controller: 'DocumentWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                seqNo: null,
                                startDate: null,
                                endDate: null,
                                email: null,
                                legalName: null,
                                accessCode: null,
                                note: null,
                                roleName: null,
                                signature: null,
                                signatureContentType: null,
                                signatureImg: null,
                                signatureImgContentType: null,
                                initialImg: null,
                                initialImgContentType: null,
                                pageNo: null,
                                xPos: null,
                                yPos: null,
                                requireTwoStepAuth: null,
                                requireSignedCopy: null,
                                type: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-work-item', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('document-work-item');
                });
            }]
        })
        .state('document-work-item.edit', {
            parent: 'document-work-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-dialog.html',
                    controller: 'DocumentWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item.delete', {
            parent: 'document-work-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-delete-dialog.html',
                    controller: 'DocumentWorkItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentWorkItem', DocumentWorkItem);

    DocumentWorkItem.$inject = ['$resource', 'DateUtils'];

    function DocumentWorkItem ($resource, DateUtils) {
        var resourceUrl =  'api/document-work-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemController', DocumentWorkItemController);

    DocumentWorkItemController.$inject = ['$scope', '$state', 'DataUtils', 'DocumentWorkItem'];

    function DocumentWorkItemController ($scope, $state, DataUtils, DocumentWorkItem) {
        var vm = this;
        
        vm.documentWorkItems = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            DocumentWorkItem.query(function(result) {
                vm.documentWorkItems = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionPageDialogController', DocumentVersionPageDialogController);

    DocumentVersionPageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'DocumentVersionPage', 'DocumentVersion'];

    function DocumentVersionPageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, DocumentVersionPage, DocumentVersion) {
        var vm = this;

        vm.documentVersionPage = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentversions = DocumentVersion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentVersionPage.id !== null) {
                DocumentVersionPage.update(vm.documentVersionPage, onSaveSuccess, onSaveError);
            } else {
                DocumentVersionPage.save(vm.documentVersionPage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentVersionPageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, documentVersionPage) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentVersionPage.data = base64Data;
                        documentVersionPage.dataContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionPageDetailController', DocumentVersionPageDetailController);

    DocumentVersionPageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'DocumentVersionPage', 'DocumentVersion'];

    function DocumentVersionPageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, DocumentVersionPage, DocumentVersion) {
        var vm = this;

        vm.documentVersionPage = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentVersionPageUpdate', function(event, result) {
            vm.documentVersionPage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionPageDeleteController',DocumentVersionPageDeleteController);

    DocumentVersionPageDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentVersionPage'];

    function DocumentVersionPageDeleteController($uibModalInstance, entity, DocumentVersionPage) {
        var vm = this;

        vm.documentVersionPage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentVersionPage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-version-page', {
            parent: 'entity',
            url: '/document-version-page',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersionPage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version-page/document-version-pages.html',
                    controller: 'DocumentVersionPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersionPage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-version-page-detail', {
            parent: 'entity',
            url: '/document-version-page/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersionPage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version-page/document-version-page-detail.html',
                    controller: 'DocumentVersionPageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersionPage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentVersionPage', function($stateParams, DocumentVersionPage) {
                    return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-version-page',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-version-page-detail.edit', {
            parent: 'document-version-page-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-dialog.html',
                    controller: 'DocumentVersionPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersionPage', function(DocumentVersionPage) {
                            return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version-page.new', {
            parent: 'document-version-page',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-dialog.html',
                    controller: 'DocumentVersionPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                pageNo: null,
                                fileRef: null,
                                data: null,
                                dataContentType: null,
                                imageHeight: null,
                                imageWidth: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-version-page', null, { reload: 'document-version-page' });
                }, function() {
                    $state.go('document-version-page');
                });
            }]
        })
        .state('document-version-page.edit', {
            parent: 'document-version-page',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-dialog.html',
                    controller: 'DocumentVersionPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersionPage', function(DocumentVersionPage) {
                            return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version-page', null, { reload: 'document-version-page' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version-page.delete', {
            parent: 'document-version-page',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-delete-dialog.html',
                    controller: 'DocumentVersionPageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentVersionPage', function(DocumentVersionPage) {
                            return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version-page', null, { reload: 'document-version-page' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentVersionPage', DocumentVersionPage);

    DocumentVersionPage.$inject = ['$resource'];

    function DocumentVersionPage ($resource) {
        var resourceUrl =  'api/document-version-pages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionPageController', DocumentVersionPageController);

    DocumentVersionPageController.$inject = ['$scope', '$state', 'DataUtils', 'DocumentVersionPage'];

    function DocumentVersionPageController ($scope, $state, DataUtils, DocumentVersionPage) {
        var vm = this;
        
        vm.documentVersionPages = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            DocumentVersionPage.query(function(result) {
                vm.documentVersionPages = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionDialogController', DocumentVersionDialogController);

    DocumentVersionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'DocumentVersion', 'DocumentVersionPage', 'Document'];

    function DocumentVersionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, DocumentVersion, DocumentVersionPage, Document) {
        var vm = this;

        vm.documentVersion = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentversionpages = DocumentVersionPage.query();
        vm.documents = Document.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentVersion.id !== null) {
                DocumentVersion.update(vm.documentVersion, onSaveSuccess, onSaveError);
            } else {
                DocumentVersion.save(vm.documentVersion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentVersionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, documentVersion) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentVersion.data = base64Data;
                        documentVersion.dataContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionDetailController', DocumentVersionDetailController);

    DocumentVersionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'DocumentVersion', 'DocumentVersionPage', 'Document'];

    function DocumentVersionDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, DocumentVersion, DocumentVersionPage, Document) {
        var vm = this;

        vm.documentVersion = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentVersionUpdate', function(event, result) {
            vm.documentVersion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionDeleteController',DocumentVersionDeleteController);

    DocumentVersionDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentVersion'];

    function DocumentVersionDeleteController($uibModalInstance, entity, DocumentVersion) {
        var vm = this;

        vm.documentVersion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentVersion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-version', {
            parent: 'entity',
            url: '/document-version',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version/document-versions.html',
                    controller: 'DocumentVersionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-version-detail', {
            parent: 'entity',
            url: '/document-version/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version/document-version-detail.html',
                    controller: 'DocumentVersionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentVersion', function($stateParams, DocumentVersion) {
                    return DocumentVersion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-version',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-version-detail.edit', {
            parent: 'document-version-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-dialog.html',
                    controller: 'DocumentVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersion', function(DocumentVersion) {
                            return DocumentVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version.new', {
            parent: 'document-version',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-dialog.html',
                    controller: 'DocumentVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                versionNo: null,
                                fileRef: null,
                                data: null,
                                dataContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-version', null, { reload: 'document-version' });
                }, function() {
                    $state.go('document-version');
                });
            }]
        })
        .state('document-version.edit', {
            parent: 'document-version',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-dialog.html',
                    controller: 'DocumentVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersion', function(DocumentVersion) {
                            return DocumentVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version', null, { reload: 'document-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version.delete', {
            parent: 'document-version',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-delete-dialog.html',
                    controller: 'DocumentVersionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentVersion', function(DocumentVersion) {
                            return DocumentVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version', null, { reload: 'document-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentVersion', DocumentVersion);

    DocumentVersion.$inject = ['$resource'];

    function DocumentVersion ($resource) {
        var resourceUrl =  'api/document-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionController', DocumentVersionController);

    DocumentVersionController.$inject = ['$scope', '$state', 'DataUtils', 'DocumentVersion'];

    function DocumentVersionController ($scope, $state, DataUtils, DocumentVersion) {
        var vm = this;
        
        vm.documentVersions = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            DocumentVersion.query(function(result) {
                vm.documentVersions = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentEventDialogController', DocumentEventDialogController);

    DocumentEventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DocumentEvent', 'Document', 'DocumentWorkItem', 'Party'];

    function DocumentEventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DocumentEvent, Document, DocumentWorkItem, Party) {
        var vm = this;

        vm.documentEvent = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.documents = Document.query();
        vm.documentworkitems = DocumentWorkItem.query();
        vm.parties = Party.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentEvent.id !== null) {
                DocumentEvent.update(vm.documentEvent, onSaveSuccess, onSaveError);
            } else {
                DocumentEvent.save(vm.documentEvent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.eventTimestamp = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentEventDetailController', DocumentEventDetailController);

    DocumentEventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DocumentEvent', 'Document', 'DocumentWorkItem', 'Party'];

    function DocumentEventDetailController($scope, $rootScope, $stateParams, previousState, entity, DocumentEvent, Document, DocumentWorkItem, Party) {
        var vm = this;

        vm.documentEvent = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentEventUpdate', function(event, result) {
            vm.documentEvent = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentEventDeleteController',DocumentEventDeleteController);

    DocumentEventDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentEvent'];

    function DocumentEventDeleteController($uibModalInstance, entity, DocumentEvent) {
        var vm = this;

        vm.documentEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentEvent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-event', {
            parent: 'entity',
            url: '/document-event',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-event/document-events.html',
                    controller: 'DocumentEventController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentEvent');
                    $translatePartialLoader.addPart('eventType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-event-detail', {
            parent: 'entity',
            url: '/document-event/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-event/document-event-detail.html',
                    controller: 'DocumentEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentEvent');
                    $translatePartialLoader.addPart('eventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentEvent', function($stateParams, DocumentEvent) {
                    return DocumentEvent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-event-detail.edit', {
            parent: 'document-event-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-dialog.html',
                    controller: 'DocumentEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentEvent', function(DocumentEvent) {
                            return DocumentEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-event.new', {
            parent: 'document-event',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-dialog.html',
                    controller: 'DocumentEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                eventTimestamp: null,
                                eventGroup: null,
                                description: null,
                                restricted: false,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-event', null, { reload: 'document-event' });
                }, function() {
                    $state.go('document-event');
                });
            }]
        })
        .state('document-event.edit', {
            parent: 'document-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-dialog.html',
                    controller: 'DocumentEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentEvent', function(DocumentEvent) {
                            return DocumentEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-event', null, { reload: 'document-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-event.delete', {
            parent: 'document-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-delete-dialog.html',
                    controller: 'DocumentEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentEvent', function(DocumentEvent) {
                            return DocumentEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-event', null, { reload: 'document-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentEvent', DocumentEvent);

    DocumentEvent.$inject = ['$resource', 'DateUtils'];

    function DocumentEvent ($resource, DateUtils) {
        var resourceUrl =  'api/document-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.eventTimestamp = DateUtils.convertDateTimeFromServer(data.eventTimestamp);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentEventController', DocumentEventController);

    DocumentEventController.$inject = ['$scope', '$state', 'DocumentEvent'];

    function DocumentEventController ($scope, $state, DocumentEvent) {
        var vm = this;
        
        vm.documentEvents = [];

        loadAll();

        function loadAll() {
            DocumentEvent.query(function(result) {
                vm.documentEvents = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentDialogController', DocumentDialogController);

    DocumentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Document', 'DocumentVersion', 'DocumentWorkItem', 'DocumentEvent', 'AppAccount'];

    function DocumentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Document, DocumentVersion, DocumentWorkItem, DocumentEvent, AppAccount) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.currentversions = DocumentVersion.query({filter: 'document-is-null'});
        $q.all([vm.document.$promise, vm.currentversions.$promise]).then(function() {
            if (!vm.document.currentVersionId) {
                return $q.reject();
            }
            return DocumentVersion.get({id : vm.document.currentVersionId}).$promise;
        }).then(function(currentVersion) {
            vm.currentversions.push(currentVersion);
        });
        vm.documentworkitems = DocumentWorkItem.query();
        vm.documentversions = DocumentVersion.query();
        vm.documentevents = DocumentEvent.query();
        vm.appaccounts = AppAccount.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.document.id !== null) {
                Document.update(vm.document, onSaveSuccess, onSaveError);
            } else {
                Document.save(vm.document, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPreviewImg = function ($file, document) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.previewImg = base64Data;
                        document.previewImgContentType = $file.type;
                    });
                });
            }
        };

        vm.setData = function ($file, document) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.data = base64Data;
                        document.dataContentType = $file.type;
                    });
                });
            }
        };

        vm.setDataComplete = function ($file, document) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.dataComplete = base64Data;
                        document.dataCompleteContentType = $file.type;
                    });
                });
            }
        };

        vm.setDataAudit = function ($file, document) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.dataAudit = base64Data;
                        document.dataAuditContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.expireDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentDetailController', DocumentDetailController);

    DocumentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Document', 'DocumentVersion', 'DocumentWorkItem', 'DocumentEvent', 'AppAccount'];

    function DocumentDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Document, DocumentVersion, DocumentWorkItem, DocumentEvent, AppAccount) {
        var vm = this;

        vm.document = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentUpdate', function(event, result) {
            vm.document = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentDeleteController',DocumentDeleteController);

    DocumentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Document'];

    function DocumentDeleteController($uibModalInstance, entity, Document) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Document.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document', {
            parent: 'entity',
            url: '/document',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.document.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document/documents.html',
                    controller: 'DocumentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('documentStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-detail', {
            parent: 'entity',
            url: '/document/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.document.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document/document-detail.html',
                    controller: 'DocumentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('documentStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Document', function($stateParams, Document) {
                    return Document.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-detail.edit', {
            parent: 'document-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document/document-dialog.html',
                    controller: 'DocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Document', function(Document) {
                            return Document.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document.new', {
            parent: 'document',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document/document-dialog.html',
                    controller: 'DocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                internalSystemRef: null,
                                externalSystemRef: null,
                                previewImg: null,
                                previewImgContentType: null,
                                fileRef: null,
                                data: null,
                                dataContentType: null,
                                dataComplete: null,
                                dataCompleteContentType: null,
                                dataAudit: null,
                                dataAuditContentType: null,
                                createDate: null,
                                expireDate: null,
                                title: null,
                                description: null,
                                digitallySigned: false,
                                barcoded: false,
                                currentVersionNo: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document', null, { reload: 'document' });
                }, function() {
                    $state.go('document');
                });
            }]
        })
        .state('document.edit', {
            parent: 'document',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document/document-dialog.html',
                    controller: 'DocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Document', function(Document) {
                            return Document.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document', null, { reload: 'document' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document.delete', {
            parent: 'document',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document/document-delete-dialog.html',
                    controller: 'DocumentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Document', function(Document) {
                            return Document.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document', null, { reload: 'document' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('Document', Document);

    Document.$inject = ['$resource', 'DateUtils'];

    function Document ($resource, DateUtils) {
        var resourceUrl =  'api/documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.expireDate = DateUtils.convertDateTimeFromServer(data.expireDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentController', DocumentController);

    DocumentController.$inject = ['$scope', '$state', 'DataUtils', 'Document'];

    function DocumentController ($scope, $state, DataUtils, Document) {
        var vm = this;
        
        vm.documents = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            Document.query(function(result) {
                vm.documents = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountDialogController', AppAccountDialogController);

    AppAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'AppAccount', 'Party', 'Document'];

    function AppAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, AppAccount, Party, Document) {
        var vm = this;

        vm.appAccount = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.parties = Party.query();
        vm.documents = Document.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appAccount.id !== null) {
                AppAccount.update(vm.appAccount, onSaveSuccess, onSaveError);
            } else {
                AppAccount.save(vm.appAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:appAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setLogoImg = function ($file, appAccount) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        appAccount.logoImg = base64Data;
                        appAccount.logoImgContentType = $file.type;
                    });
                });
            }
        };

        vm.setWatermarkImg = function ($file, appAccount) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        appAccount.watermarkImg = base64Data;
                        appAccount.watermarkImgContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountDetailController', AppAccountDetailController);

    AppAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'AppAccount', 'Party', 'Document'];

    function AppAccountDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, AppAccount, Party, Document) {
        var vm = this;

        vm.appAccount = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:appAccountUpdate', function(event, result) {
            vm.appAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountDeleteController',AppAccountDeleteController);

    AppAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppAccount'];

    function AppAccountDeleteController($uibModalInstance, entity, AppAccount) {
        var vm = this;

        vm.appAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('app-account', {
            parent: 'entity',
            url: '/app-account',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.appAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-account/app-accounts.html',
                    controller: 'AppAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('app-account-detail', {
            parent: 'entity',
            url: '/app-account/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.appAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-account/app-account-detail.html',
                    controller: 'AppAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppAccount', function($stateParams, AppAccount) {
                    return AppAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'app-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('app-account-detail.edit', {
            parent: 'app-account-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-dialog.html',
                    controller: 'AppAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAccount', function(AppAccount) {
                            return AppAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-account.new', {
            parent: 'app-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-dialog.html',
                    controller: 'AppAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                domain: null,
                                allowUserRegistration: false,
                                allowDigitalSig: false,
                                allowTwoStepAuth: false,
                                logoImg: null,
                                logoImgContentType: null,
                                watermarkImg: null,
                                watermarkImgContentType: null,
                                terms: null,
                                tplDocToSign: null,
                                tplDocComplete: null,
                                tplDocReject: null,
                                tplDocRemind: null,
                                publicUse: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('app-account', null, { reload: 'app-account' });
                }, function() {
                    $state.go('app-account');
                });
            }]
        })
        .state('app-account.edit', {
            parent: 'app-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-dialog.html',
                    controller: 'AppAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAccount', function(AppAccount) {
                            return AppAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-account', null, { reload: 'app-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-account.delete', {
            parent: 'app-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-delete-dialog.html',
                    controller: 'AppAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppAccount', function(AppAccount) {
                            return AppAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-account', null, { reload: 'app-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('AppAccount', AppAccount);

    AppAccount.$inject = ['$resource'];

    function AppAccount ($resource) {
        var resourceUrl =  'api/app-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountController', AppAccountController);

    AppAccountController.$inject = ['$scope', '$state', 'DataUtils', 'AppAccount'];

    function AppAccountController ($scope, $state, DataUtils, AppAccount) {
        var vm = this;
        
        vm.appAccounts = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            AppAccount.query(function(result) {
                vm.appAccounts = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentsWorkItemDialogController', DocumentsWorkItemDialogController);

    DocumentsWorkItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'DocumentWorkItem', 'DocumentWorkItemAction', 'Party', 'Document'];

    function DocumentsWorkItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, DocumentWorkItem, DocumentWorkItemAction, Party, Document) {
        var vm = this;

        vm.documentWorkItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentworkitemactions = DocumentWorkItemAction.query();
        vm.parties = Party.query();
        vm.documents = Document.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentWorkItem.id !== null) {
                DocumentWorkItem.update(vm.documentWorkItem, onSaveSuccess, onSaveError);
            } else {
                DocumentWorkItem.save(vm.documentWorkItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentWorkItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        vm.setSignature = function ($file, documentWorkItem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItem.signature = base64Data;
                        documentWorkItem.signatureContentType = $file.type;
                    });
                });
            }
        };

        vm.setSignatureImg = function ($file, documentWorkItem) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItem.signatureImg = base64Data;
                        documentWorkItem.signatureImgContentType = $file.type;
                    });
                });
            }
        };

        vm.setInitialImg = function ($file, documentWorkItem) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItem.initialImg = base64Data;
                        documentWorkItem.initialImgContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentsWorkItemDeleteController',DocumentsWorkItemDeleteController);

    DocumentsWorkItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentWorkItem'];

    function DocumentsWorkItemDeleteController($uibModalInstance, entity, DocumentWorkItem) {
        var vm = this;

        vm.documentWorkItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentWorkItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('documents.setup.addwi', {
            parent: 'documents.setup',
            url: 'wi/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/documents/workitems/documents-work-item-dialog.html',
                    controller: 'DocumentsWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                seqNo: null,
                                startDate: null,
                                endDate: null,
                                email: null,
                                legalName: null,
                                accessCode: null,
                                note: null,
                                roleName: null,
                                signature: null,
                                signatureContentType: null,
                                signatureImg: null,
                                signatureImgContentType: null,
                                initialImg: null,
                                initialImgContentType: null,
                                type: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documents.setup.editwi', {
            parent: 'documents.setup',
            url: 'wi/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/documents/workitems/documents-work-item-dialog.html',
                    controller: 'DocumentsWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documents.setup.deletewi', {
            parent: 'documents.setup',
            url: 'wi/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/documents/workitems/document-work-item-delete-dialog.html',
                    controller: 'DocumentsWorkItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentsUploadDialogController', DocumentsUploadDialogController);

    DocumentsUploadDialogController.$inject = ['$timeout', '$scope', '$stateParams',
    '$uibModalInstance', 'DataUtils', 'entity', 'DocumentSvc',
    'DocumentWorkItem', 'DocumentVersion', 'AppAccount', 'JmrAuth'];

    function DocumentsUploadDialogController ($timeout, $scope, $stateParams,
        $uibModalInstance, DataUtils, entity, DocumentSvc, DocumentWorkItem,
        DocumentVersion, AppAccount, JmrAuth) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.type ='fu';
        vm.appaccounts = AppAccount.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            //TODO
            if(vm.type == 'fu')
            {
                DocumentSvc.upload(vm.document, onSaveSuccess, onSaveError);
            }
            else
            {
                DocumentSvc.download(vm.document, onSaveSuccess, onSaveError);
            }


            //onSaveSuccess(vm.document);
        }

        function onSaveSuccess (result) {

            console.log(result);
            $scope.$emit('jmrsignApp:documentUpload', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, document) {

            document.accountId = JmrAuth.currentAccountId;

            if ($file) {

                var name = $file.name.split('.').shift();
                var ext = $file.name.split('.').pop().toLowerCase();

                if($.inArray(ext, ['pdf','doc','docx','xls','xlsx']) == -1) {
                    swal(
                        {
                          title: "Document is not a valid Office Document.",
                          type: "error",
                          text: "Only valid documents types can be uploaded.",
                          timer: 2200,
                          showConfirmButton: false
                        });

                    return;
                }

                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.data = base64Data;
                        document.dataContentType = $file.type;
                        document.title = name;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.expireDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentsSetupController', DocumentsSetupController);

    DocumentsSetupController.$inject = [
        '$scope', '$rootScope', '$stateParams', '$state',
        'previousState', 'DataUtils', 'entity', 'workItem', 'entityPages', 'entityWorkflow',
        'DocumentSvc','DocumentWorkItem', 'PartySearchService', 'PartyNewService', 'SignSvc',
        'DocumentWorkitemSvc'
    ];

    function DocumentsSetupController(
        $scope, $rootScope, $stateParams, $state,
        previousState, DataUtils, entity, workItem, entityPages, entityWorkflow,
        DocumentSvc, DocumentWorkItem, PartySearchService, PartyNewService, SignSvc,
        DocumentWorkitemSvc) {
        var vm = this;

        // PartySearchService.open();

        vm.document = entity;
        vm.workItem = workItem;
        vm.documentPages = entityPages;
        vm.documentWorkitems = entityWorkflow;
        vm.sigBox = [];
        vm.isSaving = false;
        vm.documentWorkItem = null;
        vm.saveWorkitem = saveWorkitem;

        vm.totalItems = entityPages.length;
        vm.currentPage = 1;

        vm.areas = [];
        vm.sigs = [];
        vm.isAdding = false;

        // JSS-11/47
        vm.addingSignature = false;

        for(var i = 0; i < vm.documentPages.length; i++) {
            vm.areas.push(null);
        };

        $scope.setupPage = function() {
            destroyAllAreas();
            buildAreaDisplay();
        };

        function buildPageSignatures() {
            var img = document.getElementById('size-wrapper');
            vm.sigs = [];
            $(vm.documentWorkitems)
            .filter(function (i,wi){
                return wi.pageNo == vm.currentPage
                && wi.type == 'SIGNER';
            }).each(function( index, wi ) {
                    vm.sigs.push({
                        id: wi.id,
                        title: wi.email,
                        x: (wi.xPos / 1000 * img.clientWidth),
                        y: (wi.yPos / 1000 * img.clientHeight),
                        width: 150,
                        height: 60,
                    });
            });
        };

        function buildAreaDisplay() {
            vm.isAdding = false;
            buildPageSignatures();
            buildArea(false);
        };

        function buildAreaAdd() {
            vm.isAdding = true;
            vm.sigs = [];
            buildArea(true);
        };

        function buildArea(allowSelect) {

            vm.areas[vm.currentPage-1] = $('#document-image-' + vm.currentPage).selectAreas({
                aspectRatio: 0,
                overlayOpacity:0.1,
                allowSelect: allowSelect,
                allowDelete: false,
                minSize: [150, 60],
                maxSize: [150, 60],
                onChanged: signatureChanged,
                width: 0,
                areas: vm.sigs
            });

            // JSS-11/47
            vm.addingSignature = false;
        };

        function signatureChanged(event, id, areas) {
            // JSS-11/47
            if (!vm.addingSignature) {
                if(vm.isAdding)
                {
                    PartySearchService.open(linkPartyToWorkitem, cancelWorkitem);
                    return;
                }

                console.log('signatureChanged');

                var img = document.getElementById('document-image-' + vm.currentPage);
                $(vm.documentWorkitems)
                .filter(function (i,wi){
                    return wi.pageNo == vm.currentPage
                    && wi.type == 'SIGNER';
                }).each(function( index, wi ) {
                        if(areas[index] != null)
                        {
                            wi.xPos = (areas[index].x / img.clientWidth * 1000);
                            wi.yPos = (areas[index].y / img.clientHeight * 1000);
                            saveWorkitem(wi);
                        }
                });
            } else {
                console.log('Busy adding signature');
            }
        };

        function destroyAllAreas() {
            // event.stopPropagation(); // firefox
            $.each( vm.areas, function( key, value ) {
                if(value != null)
                {
                    $(value).selectAreas('destroy');
                }
            });
        }

        vm.addSignature = function(wi) {
            // JSS-11/47
            vm.addingSignature = true;

            vm.documentWorkItem = wi;
            if(vm.documentWorkItem == null)
            {
                destroyAllAreas();
                buildAreaAdd();
            }
            else
            {
                // vm.isAdding = true;
                PartySearchService.open(linkPartyToWorkitem, cancelWorkitem);
            }

            // PartySearchService.open(linkPartyToWorkitem);


			/*
			 * $('#document-image-' + vm.currentPage).selectAreas('destroy');
			 *
			 * vm.areas[vm.currentPage-1] = $('#document-image-' +
			 * vm.currentPage).selectAreas({ aspectRatio: 0, overlayOpacity:0.2,
			 * allowSelect: true, allowDelete: false, minSize: [150, 50],
			 * maxSize: [150, 50], onChanged: vm.signatureChanged, width:'100%',
			 * areas: []
			 *
			 * });
			 */

        };

        function cancelWorkitem() {
            if(vm.isAdding)
            {
                vm.isAdding = false;
                destroyAllAreas();
                buildAreaDisplay();
            };
        };

        function linkPartyToWorkitem(party) {
            console.log('LINK');
            // Create workitem and link
            if (party !== null) {
                var img = document.getElementById('document-image-' + vm.currentPage);
                var areas = $('#document-image-' + vm.currentPage).selectAreas('areas');
                if (vm.documentWorkItem == null) {
                    vm.documentWorkItem = {
                        seqNo: vm.documentWorkitems.length + 1,
                        accessCode: null,
                        note: null,
                        roleName: null,
                        type: party.wiType,
                        status: 'PENDING',
                        xPos: (areas[0].x / img.clientWidth * 1000),
                        yPos: (areas[0].y / img.clientHeight * 1000),
                        id: null
                    };
                }
                vm.documentWorkItem.partyId = party.id;
                vm.documentWorkItem.party = party;
                vm.documentWorkItem.pageNo = vm.currentPage;
                vm.documentWorkItem.email = party.email;
                vm.documentWorkItem.accessCode = party.cellNumber;
                vm.documentWorkItem.legalName = party.firstName + ' ' + party.lastName;

                var twoStep = (party.type == "EXTERNAL_USER"
                    && (party.cellNumber != null && party.cellNumber != ''));

                vm.documentWorkItem.requireTwoStepAuth = twoStep;
                vm.documentWorkItem.requireSignedCopy = vm.workItem.partyId != party.id;

                if(vm.documentWorkItem.type == 'SIGNED_COPY')
                {
                    vm.documentWorkItem.requireSignedCopy = true;
                }
                if(vm.documentWorkItem.type == 'CARBON_COPY')
                {
                    vm.documentWorkItem.requireSignedCopy = false;
                }

                saveWorkitem(vm.documentWorkItem);
            }
            else
            {
                PartyNewService.open(linkPartyToWorkitem);
            }
        };

        function saveWorkitem(wi) {
            vm.isSaving = true;
            // Override documentid to current
            wi.documentId = vm.document.id;
            if (wi.id !== null) {
                DocumentWorkItem.update(wi, onSaveSuccess, onSaveError);
            } else {
                DocumentWorkItem.save(wi, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {

            vm.isSaving = false;
            DocumentWorkitemSvc.query({documentId : $stateParams.id}).$promise.then(function(results) {
                vm.documentWorkitems = results;

                if(vm.isAdding)
                {
                    vm.isAdding = false;
                    destroyAllAreas();
                    buildAreaDisplay();
                };
            });
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.userSearch = function(wi) {
            var dialog = ngDialog.open({
                template: '/App/Main/modals/users/search.cshtml',
                showClose: false,
                disableAnimation: true
            });

            dialog.closePromise.then(function(data) {
                wi.user = data.value;
            });
        };

        vm.removeSignature = function(wi) {
            swal({
                    title: "Are you sure?",
                    text: "The signature will be removed from the document.",
                    type: "warning",
                    showCancelButton: true,
                    // confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, remove it",
                    closeOnConfirm: false
                },
                function() {
                    DocumentWorkItem.delete({
                            id: wi.id
                        },
                        function() {
                            swal.close();
                            toastr.success('Work item has been removed.', 'Success');
                            $state.reload();
                        });
                });
        };



        vm.updateSignatureLocation = function() {
            var sigs = sigBox.selectAreas('relativeAreas');

            for (i = 0; i < vm.document.workflow.length; i++) {
                var wi = vm.document.workflow[i];
                var sig = sigs[i];
                wi.xPos = sig.x;
                wi.yPos = sig.y;
            }
        };

        vm.finalize = function() {

            if(!validate())
            {
                return;
            };

            swal({
                    title: "Are you sure?",
                    text: "The document flow will be secured, and the document will be forwarded on to the first person to sign.",
                    type: "warning",
                    showCancelButton: true,
                    // confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, finalize document",
                    closeOnConfirm: false
                },
                function() {
                    SignSvc.complete({
                            id: vm.workItem.id
                        }, {} ,
                        function() {
                            swal.close();
                            $state.go('inbox');
                            toastr.success('Document has been locked.', 'Success');
                        });
                });
        };

        function validate() {

            var hasSig = false;
            var allAlloc = true;

            $.each(vm.documentWorkitems, function( index, wi ) {

              if(wi.type == 'SIGNER')
              {
                hasSig = true;
              }

              if(wi.partyId == null)
              {
                allAlloc = false;
              }

            });

            if(!hasSig) {
                toastr.error('At least one signatory is required.', 'Error');
            };
            if(!allAlloc) {
                toastr.error('All signatories are not allocated to a party.', 'Error');
            };

            return hasSig && allAlloc;
        };

        vm.previousState = 'inbox';
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;



        var unsubscribe = $rootScope.$on('jmrsignApp:documentUpdate', function(event, result) {
            vm.document = result;
        });

        vm.moveUp = function(wi, index) {
            if (vm.document.status == "DRAFT" || vm.document.status == "IN_PROGRESS") {
                if (wi.status != "COMPLETED" && wi.status != "NOTIFIED") {
                    if (index > 1) {  //first signer can not move up to editor's place
                        var tempWiPrev = angular.copy(vm.documentWorkitems[index - 1]);
                        var tempWiCurr = angular.copy(vm.documentWorkitems[index]);

                        tempWiPrev.seqNo = angular.copy(vm.documentWorkitems[index].seqNo);
                        tempWiCurr.seqNo = angular.copy(vm.documentWorkitems[index - 1].seqNo);
                        tempWiPrev.id = angular.copy(vm.documentWorkitems[index].id);
                        tempWiCurr.id = angular.copy(vm.documentWorkitems[index - 1].id);

                        vm.documentWorkitems[index - 1] = tempWiCurr;
                        vm.documentWorkitems[index] = tempWiPrev;

                        //save both work items with new seqNo's
                        vm.saveWorkitem(tempWiPrev);
                        vm.saveWorkitem(tempWiCurr);
                    }
                }
            }

        }

        vm.moveDown = function(wi, index) {
             if (vm.document.status == "DRAFT" || vm.document.status == "IN_PROGRESS") {
                if (wi.status != "COMPLETED" && wi.status != "NOTIFIED") {
                    if (index < vm.documentWorkitems.length - 1) {  //First item is the list is the editor
                        var tempWiCurr = angular.copy(vm.documentWorkitems[index]);
                        var tempWiNext = angular.copy(vm.documentWorkitems[index + 1]);

                         tempWiCurr.seqNo = angular.copy(vm.documentWorkitems[index + 1].seqNo);
                         tempWiNext.seqNo = angular.copy(vm.documentWorkitems[index].seqNo);
                         tempWiCurr.id = angular.copy(vm.documentWorkitems[index + 1].id);
                         tempWiNext.id = angular.copy(vm.documentWorkitems[index].id);

                         vm.documentWorkitems[index] = tempWiNext;
                         vm.documentWorkitems[index + 1] = tempWiCurr;

                         //save both work items with new seqNo's
                         vm.saveWorkitem(tempWiCurr);
                         vm.saveWorkitem(tempWiNext);
                     }
                }
             }
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentsEditDialogController', DocumentsEditDialogController);

    DocumentsEditDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Document', 'DocumentVersion', 'DocumentWorkItem', 'AppAccount'];

    function DocumentsEditDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Document, DocumentVersion, DocumentWorkItem, AppAccount) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.document.barcoded = true;
            
            if (vm.document.id !== null) {
                Document.update(vm.document, onSaveSuccess, onSaveError);
            } else {
                Document.save(vm.document, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPreviewImg = function ($file, document) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.previewImg = base64Data;
                        document.previewImgContentType = $file.type;
                    });
                });
            }
        };

        vm.setData = function ($file, document) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.data = base64Data;
                        document.dataContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.expireDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
	'use strict';

	angular.module('jmrsignApp').controller('DocumentsDetailController',
			DocumentsDetailController);

	DocumentsDetailController.$inject = [ '$scope', '$http', '$rootScope',
			'$stateParams', '$state', 'previousState', 'DataUtils', 'entity',
			'entityPages', 'entityWorkflow', 'entityEvents', 'Document',
			'DocumentVersion', 'DocumentWorkItem', 'DocumentEvent',
			'AppAccount', 'SignSvc', 'DocumentWorkitemSvc', 'DocumentSvc'];

	function DocumentsDetailController($scope, $http, $rootScope, $stateParams,
			$state, previousState, DataUtils, entity, entityPages,
			entityWorkflow, entityEvents, Document, DocumentVersion,
			DocumentWorkItem, DocumentEvent, AppAccount, SignSvc,
			DocumentWorkitemSvc, DocumentSvc) {
		var vm = this;

		vm.document = entity;
		vm.documentPages = entityPages;
		vm.documentEvents = entityEvents;
		vm.documentWorkitems = entityWorkflow;
		vm.previousState = previousState.name;
		vm.saveWorkitem = saveWorkitem;

		console.log(vm.documentEvents);

		angular.forEach(vm.documentWorkitems, function(value, key) {
			if (value.type === 'EDITOR' && value.seqNo === 1) {
				console.log(key + ':' + value.type)
			} else if (value.type === 'SIGNER' && value.seqNo !== 1) {
				console.log(key + ':' + value.type)
			}
		});

		vm.remindDocument = function(wi) {
			swal({
				title : "Are you sure?",
				text : " A reminder notification email will be sent to" + " "
						+ wi.legalName + " " + "to sign.",
				type : "warning",
				showCancelButton : true,
				confirmButtonColor : "#DD6B55",
				confirmButtonText : "Yes, remind!",
				closeOnConfirm : false

			}, function() {
				SignSvc.remind({
					id : wi.id
				}, {}, function() {
					swal.close();
					toastr.success('Reminder email has been sent.', 'Success');
				});
			});
		}

		vm.cancelDocument = function(wi) {
			swal({
				title : "Are you sure?",
				text : "Do you want to canel" + " " + vm.document.title + " "
						+ "to sign.",
				type : "warning",
				showCancelButton : true,
				confirmButtonColor : "#DD6B55",
				confirmButtonText : "Yes, cancel!",
				closeOnConfirm : false

			}, function() {
				DocumentSvc.cancel({
					id : vm.document.id
				}, {}, function() {
					swal.close();
					toastr.success('Document cancelled.', 'Success');
					$state.go('documents.setup', {
						id : vm.document.id,
						wiid : vm.documentWorkitems[0].id
					});
				});
			});
		}

		function saveWorkitem(wi) {
            vm.isSaving = true;
            // Override documentid to current
            wi.documentId = vm.document.id;
            if (wi.id !== null) {
                DocumentWorkItem.update(wi, onSaveSuccess, onSaveError);
            } else {
                DocumentWorkItem.save(wi, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {

            vm.isSaving = false;
            DocumentWorkitemSvc.query({documentId : $stateParams.id}).$promise.then(function(results) {
                vm.documentWorkitems = results;

                if(vm.isAdding)
                {
                    vm.isAdding = false;
                    destroyAllAreas();
                    buildAreaDisplay();
                };
            });
        }

        function onSaveError() {
            vm.isSaving = false;
        }

		vm.moveUp = function(wi, index) {
            if (vm.document.status == "DRAFT" || vm.document.status == "IN_PROGRESS") {
                if (wi.status != "COMPLETED" && wi.status != "NOTIFIED") {
                    if (index > 1) {  //first signer can not move up to editor's place
                        var tempWiPrev = angular.copy(vm.documentWorkitems[index - 1]);
                        var tempWiCurr = angular.copy(vm.documentWorkitems[index]);

                        tempWiPrev.seqNo = angular.copy(vm.documentWorkitems[index].seqNo);
                        tempWiCurr.seqNo = angular.copy(vm.documentWorkitems[index - 1].seqNo);
                        tempWiPrev.id = angular.copy(vm.documentWorkitems[index].id);
                        tempWiCurr.id = angular.copy(vm.documentWorkitems[index - 1].id);

                        vm.documentWorkitems[index - 1] = tempWiCurr;
                        vm.documentWorkitems[index] = tempWiPrev;

                        //save both work items with new seqNo's
                        vm.saveWorkitem(tempWiPrev);
                        vm.saveWorkitem(tempWiCurr);
                    }
                }
            }

        }

        vm.moveDown = function(wi, index) {
             if (vm.document.status == "DRAFT" || vm.document.status == "IN_PROGRESS") {
                if (wi.status != "COMPLETED" && wi.status != "NOTIFIED") {
                    if (index < vm.documentWorkitems.length - 1) {  //First item is the list is the editor
                        var tempWiCurr = angular.copy(vm.documentWorkitems[index]);
                        var tempWiNext = angular.copy(vm.documentWorkitems[index + 1]);

                         tempWiCurr.seqNo = angular.copy(vm.documentWorkitems[index + 1].seqNo);
                         tempWiNext.seqNo = angular.copy(vm.documentWorkitems[index].seqNo);
                         tempWiCurr.id = angular.copy(vm.documentWorkitems[index + 1].id);
                         tempWiNext.id = angular.copy(vm.documentWorkitems[index].id);

                         vm.documentWorkitems[index] = tempWiNext;
                         vm.documentWorkitems[index + 1] = tempWiCurr;

                         //save both work items with new seqNo's
                         vm.saveWorkitem(tempWiCurr);
                         vm.saveWorkitem(tempWiNext);
                    }
                }
             }
        }
	}
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentsDeleteController',DocumentsDeleteController);

    DocumentsDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentSvc'];

    function DocumentsDeleteController($uibModalInstance, entity, DocumentSvc) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentSvc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('documents', {
            parent: 'app',
            url: '/documents?page&sort',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.document.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/documents/documents.html',
                    controller: 'DocumentsController',
                    controllerAs: 'vm'
                }
            },         params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                searchState: {
                    value: '',
                    squash: false
                },
                searchText: {
                    value: '',
                    squash: false
                }
            },

            resolve: {
            	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        searchState: $stateParams.searchState,
                        searchText: $stateParams.searchText
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('documentStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('documents.upload', {
            parent: 'inbox',
            url: '/upload',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/documents/documents-upload-dialog.html',
                    controller: 'DocumentsUploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                internalSystemRef: null,
                                externalSystemRef: null,
                                fileRef: null,
                                data: null,
                                dataContentType: null,
                                createDate: null,
                                expireDate: null,
                                title: null,
                                description: null,
                                currentVersionNo: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    //$state.go('inbox', null, { reload: 'document' });
                }, function() {
                    $state.go('inbox');
                });
            }]
        }).state('documents.setup', {
            parent: 'documents',
            url: '/{id}/{wiid}/setup',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.document.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/documents/documents-setup.html',
                    controller: 'DocumentsSetupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('documentStatus');
                    $translatePartialLoader.addPart('documentWorkItem');
                    $translatePartialLoader.addPart('workItemType');
                    $translatePartialLoader.addPart('workItemStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                    return DocumentSvc.get({id : $stateParams.id}).$promise;
                }],
                workItem: ['$stateParams', 'DocumentWorkItem', function($stateParams, DocumentWorkItem) {
                    return DocumentWorkItem.get({id : $stateParams.wiid}).$promise;
                }],
                entityPages: ['$stateParams', 'DocumentPageSvc', function($stateParams, DocumentPageSvc) {
                    return DocumentPageSvc.query({id : $stateParams.id}).$promise;
                }],
                entityWorkflow: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                    return DocumentWorkitemSvc.query({documentId : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documents',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };

                    return currentStateData;
                }]
            }
        })
        .state('documents.setup.edit', {
            parent: 'documents.setup',
            url: '/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/documents/documents-edit-dialog.html',
                    controller: 'DocumentsEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentSvc', function(DocumentSvc) {
                            return DocumentSvc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documents.detail', {
            parent: 'documents',
            url: '/{id}/detail',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.document.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/documents/documents-detail.html',
                    controller: 'DocumentsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('documentStatus');
                    $translatePartialLoader.addPart('documentWorkItem');
                    $translatePartialLoader.addPart('workItemType');
                    $translatePartialLoader.addPart('workItemStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                    return DocumentSvc.get({id : $stateParams.id}).$promise;
                }],
                entityPages: ['$stateParams', 'DocumentPageSvc', function($stateParams, DocumentPageSvc) {
                    return DocumentPageSvc.query({id : $stateParams.id}).$promise;
                }],
                entityWorkflow: ['$stateParams', 'DocumentWorkitemSvc', function($stateParams, DocumentWorkitemSvc) {
                    return DocumentWorkitemSvc.query({documentId : $stateParams.id}).$promise;
                }],
                entityEvents: ['$stateParams', 'DocumentSvc', function($stateParams, DocumentSvc) {
                    return DocumentSvc.events({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documents',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };

                    return currentStateData;
                }]
            }
        })
        .state('documents.delete', {
            parent: 'documents',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/documents/documents-delete-dialog.html',
                    controller: 'DocumentsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Document', function(Document) {
                            return Document.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('documents', null, { reload: 'documents' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        ;
    }

})();

(function() {
	'use strict';

	angular.module('jmrsignApp').controller('DocumentsController',
			DocumentsController);

	DocumentsController.$inject = [ '$scope', '$state', 'DataUtils',
			'DocumentSvc', 'AlertService', 'pagingParams',
			'paginationConstants', 'ParseLinks', '$http' ];

	function DocumentsController($scope, $state, DataUtils, DocumentSvc,
			AlertService, pagingParams, paginationConstants, ParseLinks, $http) {
		var vm = this;
		vm.documents = DocumentSvc.filterSearch();
		vm.loadAll = loadAll;
		vm.page = 1;
		vm.searchState = pagingParams.searchState;
		vm.searchText = pagingParams.searchText;
		vm.totalItems = null;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.transition = transition;
		vm.search = search;
		vm.documents = [];
		vm.openFile = DataUtils.openFile;
		vm.byteSize = DataUtils.byteSize;
		vm.loadAll();
		console.log(DocumentSvc.query());

		function loadAll() {
			DocumentSvc.filterSearch({
				filterSearch : (vm.searchState + ((!(vm.searchState == null || vm.searchState === '')
                                && !(vm.searchText == null || vm.searchText === '')) ? '|' : '')
                                + vm.searchText),
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
		}

		function search() {
			vm.loadAll();
		}

		//console.log(vm.loadAll());

		function onSuccess(result, headers) {
			var hiddenDocumentSize = 0;
			for ( var i in result) {
				if (result[i]['login']) {
					result.splice(i, 1);
					hiddenDocumentSize++;
				}
			}
			vm.links = ParseLinks.parse(headers('link'));
			vm.totalItems = headers('X-Total-Count') - hiddenDocumentSize;
			vm.queryCount = vm.totalItems;
			vm.page = pagingParams.page;
			vm.documents = result;
		}
		// console.log(vm.documents);

		function onError(error) {
			AlertService.error(error.result.message);
		}

		function sort() {
			var result = [ vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc') ];
			if (vm.predicate !== 'id') {
				result.push('id');
			}
			return result;
			// console.log(result);
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				searchState : vm.searchState,
				searchText : vm.searchText
			});
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('jmrsignApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

/* global window, Image, jQuery */
/**
 * @author 360Learning
 * @author Catalin Dogaru (https://github.com/cdog - http://code.tutsplus.com/tutorials/how-to-create-a-jquery-image-cropping-plugin-from-scratch-part-i--net-20994)
 * @author Adrien David-Sivelle (https://github.com/AdrienDS - Refactoring, Multiselections & Mobile compatibility)
 */
(function($) {
    $.imageArea = function(parent, id, title) {
        var options = parent.options,
            $image = parent.$image,
            $trigger = parent.$trigger,
            $outline,
            $selection,
            $resizeHandlers = {},
            $btDelete,
            resizeHorizontally = true,
            resizeVertically = true,
            selectionOffset = [0, 0],
            selectionOrigin = [0, 0],
            area = {
                id: id,
                title: title,
                x: 0,
                y: 0,
                z: 0,
                height: 0,
                width: 0
            },
            blur = function () {
                area.z = 0;
                refresh("blur");
            },
            focus = function () {
                parent.blurAll();
                area.z = 100;
                refresh();
            },
            getData = function () {
                return area;
            },
            fireEvent = function (event) {
                $image.trigger(event, [area.id, parent.areas()]);
            },
            cancelEvent = function (e) {
                var event = e || window.event || {};
                event.cancelBubble = true;
                event.returnValue = false;
                event.stopPropagation && event.stopPropagation(); // jshint ignore: line
                event.preventDefault && event.preventDefault(); // jshint ignore: line
            },
            off = function() {
                $.each(arguments, function (key, val) {
                    on(val);
                });
            },
            on = function (type, handler) {
                var browserEvent, mobileEvent;
                switch (type) {
                    case "start":
                        browserEvent = "mousedown";
                        mobileEvent = "touchstart";
                        break;
                    case "move":
                        browserEvent = "mousemove";
                        mobileEvent = "touchmove";
                        break;
                    case "stop":
                        browserEvent = "mouseup";
                        mobileEvent = "touchend";
                        break;
                    default:
                        return;
                }
                if (handler && jQuery.isFunction(handler)) {
                    $(window.document).on(browserEvent, handler).on(mobileEvent, handler);
                } else {
                    $(window.document).off(browserEvent).off(mobileEvent);
                }
            },
            updateSelection = function () {
                // Update the outline layer
                $outline.css({
                    cursor: "default",
                    width: area.width,
                    height: area.height,
                    left: area.x,
                    top: area.y,
                    "z-index": area.z
                });

                // Update the selection layer
                $selection.css({
                    backgroundPosition : ( - area.x - 1) + "px " + ( - area.y - 1) + "px",
                    cursor : options.allowMove ? "move" : "default",
                    width: (area.width - 2 > 0) ? (area.width - 2) : 0,
                    height: (area.height - 2 > 0) ? (area.height - 2) : 0,
                    left : area.x + 1,
                    top : area.y + 1,
                    "z-index": area.z + 2
                });
            },
            updateResizeHandlers = function (show) {
                if (! options.allowResize) {
                    return;
                }
                if (show) {
                    $.each($resizeHandlers, function(name, $handler) {
                        var top,
                            left,
                            semiwidth = Math.round($handler.width() / 2),
                            semiheight = Math.round($handler.height() / 2),
                            vertical = name[0],
                            horizontal = name[name.length - 1];

                        if (vertical === "n") {             // ====== North* ======
                            top = - semiheight;

                        } else if (vertical === "s") {      // ====== South* ======
                            top = area.height - semiheight - 1;

                        } else {                            // === East & West ===
                            top = Math.round(area.height / 2) - semiheight - 1;
                        }

                        if (horizontal === "e") {           // ====== *East ======
                            left = area.width - semiwidth - 1;

                        } else if (horizontal === "w") {    // ====== *West ======
                            left = - semiwidth;

                        } else {                            // == North & South ==
                            left = Math.round(area.width / 2) - semiwidth - 1;
                        }

                        $handler.css({
                            display: "block",
                            left: area.x + left,
                            top: area.y + top,
                            "z-index": area.z + 1
                        });
                    });
                } else {
                    $(".select-areas-resize-handler").each(function() {
                        $(this).css({ display: "none" });
                    });
                }
            },
            updateBtDelete = function (visible) {
                if ($btDelete) {
                    $btDelete.css({
                        display: visible ? "block" : "none",
                        left: area.x + area.width + 1,
                        top: area.y - $btDelete.outerHeight() - 1,
                        "z-index": area.z + 1
                    });
                }
            },
            updateCursor = function (cursorType) {
                $outline.css({
                    cursor: cursorType
                });

                $selection.css({
                    cursor: cursorType
                });
            },
            refresh = function(sender) {
                switch (sender) {
                    case "startSelection":
                        parent._refresh();
                        updateSelection();
                        updateResizeHandlers();
                        updateBtDelete(true);
                        break;

                    case "pickSelection":
                    case "pickResizeHandler":
                        updateResizeHandlers();
                        break;

                    case "resizeSelection":
                        updateSelection();
                        updateResizeHandlers();
                        updateCursor("crosshair");
                        updateBtDelete(true);
                        break;

                    case "moveSelection":
                        updateSelection();
                        updateResizeHandlers();
                        updateCursor("move");
                        updateBtDelete(true);
                        break;

                    case "blur":
                        updateSelection();
                        updateResizeHandlers();
                        updateBtDelete();
                        break;

                    //case "releaseSelection":
                    default:
                        updateSelection();
                        updateResizeHandlers(true);
                        updateBtDelete(true);
                }
            },
            startSelection  = function (event) {
                cancelEvent(event);

                // Reset the selection size
                area.width = options.minSize[0];
                area.height = options.minSize[1];
                focus();
                on("move", resizeSelection);
                on("stop", releaseSelection);

                // Get the selection origin
                selectionOrigin = getMousePosition(event);
                if (selectionOrigin[0] + area.width > $image.width()) {
                    selectionOrigin[0] = $image.width() - area.width;
                }
                if (selectionOrigin[1] + area.height > $image.height()) {
                    selectionOrigin[1] = $image.height() - area.height;
                }
                // And set its position
                area.x = selectionOrigin[0];
                area.y = selectionOrigin[1];

                refresh("startSelection");
            },
            pickSelection = function (event) {
                cancelEvent(event);
                focus();
                on("move", moveSelection);
                on("stop", releaseSelection);

                var mousePosition = getMousePosition(event);

                // Get the selection offset relative to the mouse position
                selectionOffset[0] = mousePosition[0] - area.x;
                selectionOffset[1] = mousePosition[1] - area.y;

                refresh("pickSelection");
            },
            pickResizeHandler = function (event) {
                cancelEvent(event);
                focus();

                var card = event.target.className.split(" ")[1];
                if (card[card.length - 1] === "w") {
                    selectionOrigin[0] += area.width;
                    area.x = selectionOrigin[0] - area.width;
                }
                if (card[0] === "n") {
                    selectionOrigin[1] += area.height;
                    area.y = selectionOrigin[1] - area.height;
                }
                if (card === "n" || card === "s") {
                    resizeHorizontally = false;
                } else if (card === "e" || card === "w") {
                    resizeVertically = false;
                }

                on("move", resizeSelection);
                on("stop", releaseSelection);

                refresh("pickResizeHandler");
            },
            resizeSelection = function (event) {
                cancelEvent(event);
                focus();

                var mousePosition = getMousePosition(event);

                // Get the selection size
                var height = mousePosition[1] - selectionOrigin[1],
                    width = mousePosition[0] - selectionOrigin[0];

                // If the selection size is smaller than the minimum size set it to minimum size
                if (Math.abs(width) < options.minSize[0]) {
                    width = (width >= 0) ? options.minSize[0] : - options.minSize[0];
                }
                if (Math.abs(height) < options.minSize[1]) {
                    height = (height >= 0) ? options.minSize[1] : - options.minSize[1];
                }
                // Test if the selection size exceeds the image bounds
                if (selectionOrigin[0] + width < 0 || selectionOrigin[0] + width > $image.width()) {
                    width = - width;
                }
                if (selectionOrigin[1] + height < 0 || selectionOrigin[1] + height > $image.height()) {
                    height = - height;
                }
                // Test if the selection size is bigger than the maximum size (ignored if minSize > maxSize)
                if (options.maxSize[0] > options.minSize[0] && options.maxSize[1] > options.minSize[1]) {
                    if (Math.abs(width) > options.maxSize[0]) {
                        width = (width >= 0) ? options.maxSize[0] : - options.maxSize[0];
                    }

                    if (Math.abs(height) > options.maxSize[1]) {
                        height = (height >= 0) ? options.maxSize[1] : - options.maxSize[1];
                    }
                }

                // Set the selection size
                if (resizeHorizontally) {
                    area.width = width;
                }
                if (resizeVertically) {
                    area.height = height;
                }
                // If any aspect ratio is specified
                if (options.aspectRatio) {
                    // Calculate the new width and height
                    if ((width > 0 && height > 0) || (width < 0 && height < 0)) {
                        if (resizeHorizontally) {
                            height = Math.round(width / options.aspectRatio);
                        } else {
                            width = Math.round(height * options.aspectRatio);
                        }
                    } else {
                        if (resizeHorizontally) {
                            height = - Math.round(width / options.aspectRatio);
                        } else {
                            width = - Math.round(height * options.aspectRatio);
                        }
                    }
                    // Test if the new size exceeds the image bounds
                    if (selectionOrigin[0] + width > $image.width()) {
                        width = $image.width() - selectionOrigin[0];
                        height = (height > 0) ? Math.round(width / options.aspectRatio) : - Math.round(width / options.aspectRatio);
                    }

                    if (selectionOrigin[1] + height < 0) {
                        height = - selectionOrigin[1];
                        width = (width > 0) ? - Math.round(height * options.aspectRatio) : Math.round(height * options.aspectRatio);
                    }

                    if (selectionOrigin[1] + height > $image.height()) {
                        height = $image.height() - selectionOrigin[1];
                        width = (width > 0) ? Math.round(height * options.aspectRatio) : - Math.round(height * options.aspectRatio);
                    }

                    // Set the selection size
                    area.width = width;
                    area.height = height;
                }

                if (area.width < 0) {
                    area.width = Math.abs(area.width);
                    area.x = selectionOrigin[0] - area.width;
                } else {
                    area.x = selectionOrigin[0];
                }
                if (area.height < 0) {
                    area.height = Math.abs(area.height);
                    area.y = selectionOrigin[1] - area.height;
                } else {
                    area.y = selectionOrigin[1];
                }

                fireEvent("changing");
                refresh("resizeSelection");
            },
            moveSelection = function (event) {
                cancelEvent(event);
                if (! options.allowMove) {
                    return;
                }
                focus();

                var mousePosition = getMousePosition(event);
                moveTo({
                    x: mousePosition[0] - selectionOffset[0],
                    y: mousePosition[1] - selectionOffset[1]
                });

                fireEvent("changing");
            },
            moveTo = function (point) {
                // Set the selection position on the x-axis relative to the bounds
                // of the image
                if (point.x > 0) {
                    if (point.x + area.width < $image.width()) {
                        area.x = point.x;
                    } else {
                        area.x = $image.width() - area.width;
                    }
                } else {
                    area.x = 0;
                }
                // Set the selection position on the y-axis relative to the bounds
                // of the image
                if (point.y > 0) {
                    if (point.y + area.height < $image.height()) {
                        area.y = point.y;
                    } else {
                        area.y = $image.height() - area.height;
                    }
                } else {
                    area.y = 0;
                }
                refresh("moveSelection");
            },
            releaseSelection = function (event) {
                cancelEvent(event);
                off("move", "stop");

                // Update the selection origin
                selectionOrigin[0] = area.x;
                selectionOrigin[1] = area.y;

                // Reset the resize constraints
                resizeHorizontally = true;
                resizeVertically = true;

                fireEvent("changed");

                refresh("releaseSelection");
            },
            deleteSelection = function (event) {
                cancelEvent(event);
                $selection.remove();
                $outline.remove();
                $.each($resizeHandlers, function(card, $handler) {
                    $handler.remove();
                });
                if ($btDelete) {
                    $btDelete.remove();    
                } 
                parent._remove(id);
                fireEvent("changed");
            },
            getElementOffset = function (object) {
                var offset = $(object).offset();

                return [offset.left, offset.top];
            },
            getMousePosition = function (event) {
                var imageOffset = getElementOffset($image);

                if (! event.pageX) {
                    if (event.originalEvent) {
                        event = event.originalEvent;
                    }

                    if(event.changedTouches) {
                        event = event.changedTouches[0];
                    }

                    if(event.touches) {
                        event = event.touches[0];
                    }
                }
                var x = event.pageX - imageOffset[0],
                    y = event.pageY - imageOffset[1];

                x = (x < 0) ? 0 : (x > $image.width()) ? $image.width() : x;
                y = (y < 0) ? 0 : (y > $image.height()) ? $image.height() : y;

                return [x, y];
            };


        // Initialize an outline layer and place it above the trigger layer
        $outline = $("<div class=\"select-areas-outline\" />")
            .css({
                opacity : options.outlineOpacity,
                position : "absolute"
            })
            .insertAfter($trigger);

        // Initialize a selection layer and place it above the outline layer
        $selection = $("<div><span id='area-title-" + area.id + "' class='select-areas-title'></span> </div>")
            .addClass("select-areas-background-area")
            .css({
                background : "#fff url(" + $image.attr("src") + ") no-repeat",
                backgroundSize : $image.width() + "px " + $image.height() + "px",
                position : "absolute"
            })
            .insertAfter($outline);

        // Initialize all handlers
        if (options.allowResize) {
            $.each(["nw", "n", "ne", "e", "se", "s", "sw", "w"], function (key, card) {
                $resizeHandlers[card] =  $("<div class=\"select-areas-resize-handler " + card + "\"/>")
                    .css({
                        opacity : 0.5,
                        position : "absolute",
                        cursor : card + "-resize"
                    })
                    .insertAfter($selection)
                    .mousedown(pickResizeHandler)
                    .bind("touchstart", pickResizeHandler);
            });
        }
        // initialize delete button
        if (options.allowDelete) {
            var bindToDelete = function ($obj) {
                $obj.click(deleteSelection)
                    .bind("touchstart", deleteSelection)
                    .bind("tap", deleteSelection);
                return $obj;
            };
            $btDelete = bindToDelete($("<div class=\"delete-area\" />"))
                .append(bindToDelete($("<div class=\"select-areas-delete-area\" />")))
                .insertAfter($selection);
        }

        if (options.allowMove) {
            $selection.mousedown(pickSelection).bind("touchstart", pickSelection);
        }

        focus();

        return {
            getData: getData,
            startSelection: startSelection,
            deleteSelection: deleteSelection,
            options: options,
            blur: blur,
            focus: focus,
            nudge: function (point) {
                point.x = area.x;
                point.y = area.y;
                if (point.d) {
                    point.y = area.y + point.d;
                }
                if (point.u) {
                    point.y = area.y - point.u;
                }
                if (point.l) {
                    point.x = area.x - point.l;
                }
                if (point.r) {
                    point.x = area.x + point.r;
                }
                moveTo(point);
                fireEvent("changed");
            },
            set: function (dimensions, silent) {
                area = $.extend(area, dimensions);
                $('#area-title-' + area.id).html(area.title);
                selectionOrigin[0] = area.x;
                selectionOrigin[1] = area.y;
                if (! silent) {
                    fireEvent("changed");
                }
            },
            contains: function (point) {
                return (point.x >= area.x) && (point.x <= area.x + area.width) &&
                       (point.y >= area.y) && (point.y <= area.y + area.height);
            }
        };
    };


    $.imageSelectAreas = function() { };

    $.imageSelectAreas.prototype.init = function (object, customOptions) {
        var that = this,
            defaultOptions = {
                allowEdit: true,
                allowMove: true,
                allowResize: true,
                allowSelect: true,
                allowDelete: true,
                allowNudge: true,
                aspectRatio: 0,
                minSize: [0, 0],
                maxSize: [0, 0],
                width: 0,
                maxAreas: 0,
                outlineOpacity: 0.5,
                overlayOpacity: 0.5,
                areas: [],
                onChanging: null,
                onChanged: null
            };

        this.options = $.extend(defaultOptions, customOptions);

        if (! this.options.allowEdit) {
            this.options.allowSelect = this.options.allowMove = this.options.allowResize = this.options.allowDelete = false;
        }

        this._areas = {};

        // Initialize the image layer
        this.$image = $(object);

        this.ratio = 1;
        if (this.options.width && this.$image.width() && this.options.width !== this.$image.width()) {
            this.ratio = this.options.width / this.$image.width();
            this.$image.width(this.options.width);
        }

        if (this.options.onChanging) {
            this.$image.on("changing", this.options.onChanging);
        }
        if (this.options.onChanged) {
            this.$image.on("changed", this.options.onChanged);
        }
        if (this.options.onLoaded) {
            this.$image.on("loaded", this.options.onLoaded);
        }

        // Initialize an image holder
        this.$holder = $("<div />")
            .css({
                position : "relative",
                width: this.$image.width(),
                height: this.$image.height()
            });

        // Wrap the holder around the image
        this.$image.wrap(this.$holder)
            .css({
                position : "absolute"
            });

        // Initialize an overlay layer and place it above the image
        this.$overlay = $("<div class=\"select-areas-overlay\" />")
            .css({
                opacity : this.options.overlayOpacity,
                position : "absolute",
                width: this.$image.width(),
                height: this.$image.height()
            })
            .insertAfter(this.$image);

        // Initialize a trigger layer and place it above the overlay layer
        this.$trigger = $("<div />")
            .css({
                backgroundColor : "#000000",
                opacity : 0,
                position : "absolute",
                width: this.$image.width(),
                height: this.$image.height()
            })
            .insertAfter(this.$overlay);

        $.each(this.options.areas, function (key, area) {
            that._add(area, true);
        });


        this.blurAll();
        this._refresh();

        if (this.options.allowSelect) {
            // Bind an event handler to the "mousedown" event of the trigger layer
            this.$trigger.mousedown($.proxy(this.newArea, this)).on("touchstart", $.proxy(this.newArea, this));
        }
        if (this.options.allowNudge) {
            $('html').keydown(function (e) { // move selection with arrow keys
                var codes = {
                        37: "l",
                        38: "u",
                        39: "r",
                        40: "d"
                    },
                    direction = codes[e.which],
                    selectedArea;

                if (direction) {
                    that._eachArea(function (area) {
                        if (area.getData().z === 100) {
                            selectedArea = area;
                            return false;
                        }
                    });
                    if (selectedArea) {
                        var move = {};
                        move[direction] = 1;
                        selectedArea.nudge(move);
                    }
                }
            });
        }
    };

    $.imageSelectAreas.prototype._refresh = function () {
        var nbAreas = this.areas().length;
        this.$overlay.css({
            display : nbAreas? "block" : "none"
        });
        if (nbAreas) {
            this.$image.addClass("blurred");
        } else {
            this.$image.removeClass("blurred");
        }
        this.$trigger.css({
            cursor : this.options.allowSelect ? "crosshair" : "default"
        });
    };

    $.imageSelectAreas.prototype._eachArea = function (cb) {
        $.each(this._areas, function (id, area) {
            if (area) {
                return cb(area, id);
            }
        });
    };

    $.imageSelectAreas.prototype._remove = function (id) {
        delete this._areas[id];
        this._refresh();
    };

    $.imageSelectAreas.prototype.remove = function (id) {
        if (this._areas[id]) {
            this._areas[id].deleteSelection();
        }
    };

    $.imageSelectAreas.prototype.newArea = function (event) {
        var id = -1;
        this.blurAll();
        if (this.options.maxAreas && this.options.maxAreas <=  this.areas().length) {
            return id;
        }
        this._eachArea(function (area, index) {
            id = Math.max(id, parseInt(index, 10));
        });
        id += 1;

        this._areas[id] = $.imageArea(this, id);
        if (event) {
            this._areas[id].startSelection(event);
        }
        return id;
    };

    $.imageSelectAreas.prototype.set = function (id, options, silent) {
        if (this._areas[id]) {
            options.id = id;
            this._areas[id].set(options, silent);
            this._areas[id].focus();
        }
    };

    $.imageSelectAreas.prototype._add = function (options, silent) {
        var id = this.newArea();
        this.set(id, options, silent);
    };

    $.imageSelectAreas.prototype.add = function (options) {
        var that = this;
        this.blurAll();
        if ($.isArray(options)) {
            $.each(options, function (key, val) {
                that._add(val);
            });
        } else {
            this._add(options);
        }
        this._refresh();
        if (! this.options.allowSelect && ! this.options.allowMove && ! this.options.allowResize && ! this.options.allowDelete) {
            this.blurAll();
        }
    };

    $.imageSelectAreas.prototype.reset = function () {
        var that = this;
        this._eachArea(function (area, id) {
            that.remove(id);
        });
        this._refresh();
    };

    $.imageSelectAreas.prototype.destroy = function () {
        this.reset();
        this.$holder.remove();
        this.$overlay.remove();
        this.$trigger.remove();
        this.$image.css("width", "").css("position", "").unwrap();
        this.$image.removeData("mainImageSelectAreas");
        this.$image.off('changing changed loaded');
    };

    $.imageSelectAreas.prototype.areas = function () {
        var ret = [];
        this._eachArea(function (area) {
            ret.push(area.getData());
        });
        return ret;
    };

    $.imageSelectAreas.prototype.relativeAreas = function () {
        var areas = this.areas(),
            ret = [],
            ratio = this.ratio,
            scale = function (val) {
                return Math.floor(val / ratio);
            };

        for (var i = 0; i < areas.length; i++) {
            ret[i] = $.extend({}, areas[i]);
            ret[i].x = scale(ret[i].x);
            ret[i].y = scale(ret[i].y);
            ret[i].width = scale(ret[i].width);
            ret[i].height = scale(ret[i].height);
        }
        return ret;
    };

    $.imageSelectAreas.prototype.blurAll = function () {
        this._eachArea(function (area) {
            area.blur();
        });
    };

    $.imageSelectAreas.prototype.contains  = function (point) {
        var res = false;
        this._eachArea(function (area) {
            if (area.contains(point)) {
                res = true;
                return false;
            }
        });
        return res;
    };

    $.selectAreas = function(object, options) {
        var $object = $(object);
        if (! $object.data("mainImageSelectAreas")) {
            var mainImageSelectAreas = new $.imageSelectAreas();
            mainImageSelectAreas.init(object, options);
            $object.data("mainImageSelectAreas", mainImageSelectAreas);
            $object.trigger("loaded");
        }
        return $object.data("mainImageSelectAreas");
    };


    $.fn.selectAreas = function(customOptions) {
        if ( $.imageSelectAreas.prototype[customOptions] ) { // Method call
            var ret = $.imageSelectAreas.prototype[ customOptions ].apply( $.selectAreas(this), Array.prototype.slice.call( arguments, 1 ));
            return typeof ret === "undefined" ? this : ret;

        } else if ( typeof customOptions === "object" || ! customOptions ) { // Initialization
            //Iterate over each object
            this.each(function() {
                var currentObject = this,
                    image = new Image();

                // And attach selectAreas when the object is loaded
                image.onload = function() {
                    $.selectAreas(currentObject, customOptions);
                };

                // Reset the src because cached images don"t fire load sometimes
                image.src = currentObject.src;

            });
            return this;

        } else {
            $.error( "Method " +  customOptions + " does not exist on jQuery.selectAreas" );
        }
    };
}) (jQuery);

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('PartySearchService', PartySearchService);

    PartySearchService.$inject = ['$uibModal'];

    function PartySearchService ($uibModal) {
        var service = {
            open: open,
            
            
        };

        var modalInstance = null;
        var callback = null;
        var cancelCallback = null;

        var resultModal = function (result) {
            if(callback != null)
            {
                callback(result);
            }

            callback = null;
            cancelCallback = null;
            modalInstance = null;
        };

        var resetModal = function (result) {
            if(cancelCallback != null)
            {
                cancelCallback();
            }
            callback = null;
            cancelCallback = null;
            modalInstance = null;
        };

        return service;

        function open (callbackFn, cancelFn) {
            callback = callbackFn;
            cancelCallback = cancelFn;
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/party/party-search.html',
                controller: 'PartySearchController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }],
                    party: ['$stateParams', 'AppPartySvc', function($stateParams, AppPartySvc) {
                        return AppPartySvc.get().$promise;
                    }]
                }
            });
            modalInstance.result.then(
                resultModal,
                resetModal
            );
        }
        
    
     
    }
})();

(function() {
	'use strict';

	angular.module('jmrsignApp').controller('PartySearchController',
			PartySearchController);

	PartySearchController.$inject = [ '$rootScope', '$state', '$timeout',
			'PartyManagement', 'party', '$uibModalInstance',
			'PartySearchService', '$http', '$q', '$scope' ];

	function PartySearchController($rootScope, $state, $timeout,
			PartyManagement, party, $uibModalInstance, PartySearchService,
			$http, $q, $scope) {
		var vm = this;

		// vm.parties = PartyManagement.query();
        vm.type = 'SIGNER';
		vm.party = undefined;
		vm.currentParty = party;
		vm.cancel = cancel;
		vm.select = select;
		vm.selectCurrent = selectCurrent;
		vm.newParty = newParty;
		vm.noResults = false;
		vm.getAllPartiesSearch = getAllPartiesSearch;

		$timeout(function() {
			angular.element('#field_party').focus();
		});

		function newParty() {
			$uibModalInstance.close(null);
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
			// $uibModalInstance.close(null, true);
		}

		function select() {
            vm.party.wiType = vm.type;
			$uibModalInstance.close(vm.party);
		}

		function selectCurrent() {
		    vm.currentParty.wiType = vm.type;
			$uibModalInstance.close(vm.currentParty);
		}

		function getAllPartiesSearch(searchStr) {
			var defer = $q.defer();
			if (searchStr) {
				PartyManagement.search({
					search : searchStr
				}, function(data, headers) {
					if (!$scope.$$phase) { // check if digest is not in
						// progress
						$rootScope.$apply(function() {
							defer.resolve(data);
						});
					} else {
						defer.resolve(data);
					}
				}, function(response) {
					if (!$scope.$$phase) {
						$rootScope.$apply(function() {
							defer.reject('Server rejected with status '
									+ response.status);
						});
					} else {
						defer.reject('Server rejected with status '
								+ response.status);
					}
				});
			} else {
				if (!$scope.$$phase) {
					$rootScope.$apply(function() {
						defer.reject('No search query ');
						$log.info('No search query provided');
					});
				} else {
					defer.reject('No search query ');
					$log.info('No search query provided');
				}
			}
			return defer.promise;
		}
		;

	}
	;

})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('PartyNewService', PartyNewService);

    PartyNewService.$inject = ['$uibModal'];

    function PartyNewService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var callback = null;
        var cancelCallback = null;

        var resultModal = function (result) {
            if(callback !== null)
            {
                callback(result);
            }

            callback = null;
            cancelCallback = null;
            modalInstance = null;
        };

        var resetModal = function () {
            if(cancelCallback !== null)
            {
                cancelCallback();
            }

            modalInstance = null;
            cancelCallback = null;
            callback = null;
        };

        return service;

        function open (callbackFn, cancelFn) {
            callback = callbackFn;
            cancelCallback = cancelFn;
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/party/party-new.html',
                controller: 'PartyNewController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('party');
                        $translatePartialLoader.addPart('partyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                            return {
                                internalSystemRef: null,
                                email: null,
                                firstName: null,
                                lastName: null,
                                cellNumber: null,
                                newCellNumber: null,
                                validationCode: null,
                                signature: null,
                                signatureContentType: null,
                                signatureImg: null,
                                signatureImgContentType: null,
                                initialImg: null,
                                initialImgContentType: null,
                                allowUserUpdate: true,
                                status: 'RESTRICTED',
                                type: null,
                                id: null
                            };
                        }
                }
            });
            modalInstance.result.then(
                resultModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyNewController', PartyNewController);

    PartyNewController.$inject = ['$rootScope', '$state', '$timeout', 'entity', 'PartyManagement', '$uibModalInstance'];

    function PartyNewController ($rootScope, $state, $timeout, entity, PartyManagement, $uibModalInstance) {
        var vm = this;
        vm.party = entity;
        vm.cancel = cancel;
        vm.save = save;
        vm.newParty = newParty;
        vm.noResults = false;


        var iti = null;
        $timeout(function (){
        angular.element('#field_email').focus();

         var input = document.getElementById('field_cellNumber');
            iti = window.intlTelInput(input, {
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/14.0.3/js/utils.js",
                initialCountry: "za",
                preferredCountries: [ "za", "gb" ],
                separateDialCode: true
            });
        });

        function newParty () {
        }

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {

         if (iti){
                vm.party.cellNumber = iti.getNumber();
            }
            vm.isSaving = true;
            if (vm.party.id !== null) {
                PartyManagement.update(vm.party, onSaveSuccess, onSaveError);
            } else {
                PartyManagement.save(vm.party, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            console.log('Create Result');
            console.log(result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'home' || $state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('inbox');
                }

                if($state.current.name === 'sign') {
                    $state.reload();
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文',
                'af': 'Afrikaans'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            //'af'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('jmrsignApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('jmrsignApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-jmrsignApp-error');
                var entityKey = httpResponse.headers('X-jmrsignApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('jmrsignApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('jmrsignApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-jmrsignApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-jmrsignApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('jmrsignApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {c = c.substring(1);}

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountProfileController', AppAccountProfileController);

    AppAccountProfileController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'AppAccount', 'Party', 'Document'];

    function AppAccountProfileController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, AppAccount, Party, Document) {
        var vm = this;

        vm.appAccount = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:appAccountUpdate', function(event, result) {
            vm.appAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyManagementUploadDialogController', PartyManagementUploadDialogController);

    PartyManagementUploadDialogController.$inject = ['$timeout', '$scope', '$stateParams', 
    '$uibModalInstance', 'DataUtils', 'entity', 'PartyManagement', 'JmrAuth'];

    function PartyManagementUploadDialogController ($timeout, $scope, $stateParams, 
        $uibModalInstance, DataUtils, entity, PartyManagement, JmrAuth) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.save = save;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            PartyManagement.bulkUpload(vm.document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {

            console.log(result);
            //$scope.$emit('jmrsignApp:documentUpload', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, document) {

            document.accountId = JmrAuth.currentAccountId;

            if ($file) {

                var name = $file.name.split('.').shift();
                var ext = $file.name.split('.').pop().toLowerCase();

                /*if($.inArray(ext, ['csv']) == -1) {
                    swal(
                        {
                          title: "Document is not a CSV.",
                          type: "error",
                          text: "Only documents of type CSV can be uploaded.",
                          timer: 2200,
                          showConfirmButton: false
                        });

                    return;
                } */

                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        document.data = base64Data;
                        document.dataContentType = $file.type;
                        document.title = "csvfile";
                    });
                });
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('jmrsignApp').controller('PartyManagementDialogController',
			PartyManagementDialogController);

	PartyManagementDialogController.$inject = [ '$timeout', '$scope',
			'$stateParams', '$uibModalInstance', 'DataUtils', 'entity',
			'PartyManagement', 'DocumentWorkItem', 'DocumentEvent', 'User',
			'AppAccount', 'Party' ];

	function PartyManagementDialogController($timeout, $scope, $stateParams,
			$uibModalInstance, DataUtils, entity, PartyManagement,
			DocumentWorkItem, DocumentEvent, User, AppAccount, Party) {
		var vm = this;

		vm.party = entity;
		vm.clear = clear;
		vm.byteSize = DataUtils.byteSize;
		vm.openFile = DataUtils.openFile;
		vm.save = save;
		vm.documentworkitems = DocumentWorkItem.query();
		vm.documentevents = DocumentEvent.query();
		vm.users = User.query();
		vm.appaccounts = AppAccount.query();

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			console.log
			vm.isSaving = true;
			if (vm.party.id !== null) {
				PartyManagement.update(vm.party, onSaveSuccess, onSaveError);
			} else {
				PartyManagement.save(vm.party, onSaveSuccess, onSaveError);
			}
			console.log(vm.party.id);
		}

		function onSaveSuccess(result) {
			$scope.$emit('jmrsignApp:partyUpdate', result);
			$uibModalInstance.close(result);
			vm.isSaving = false;
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		vm.setSignature = function($file, party) {
			if ($file) {
				DataUtils.toBase64($file, function(base64Data) {
					$scope.$apply(function() {
						party.signature = base64Data;
						party.signatureContentType = $file.type;
					});
				});
			}
		};

		vm.setSignatureImg = function($file, party) {
			if ($file && $file.$error === 'pattern') {
				return;
			}
			if ($file) {
				DataUtils.toBase64($file, function(base64Data) {
					$scope.$apply(function() {
						party.signatureImg = base64Data;
						party.signatureImgContentType = $file.type;
					});
				});
			}
		};

		vm.setInitialImg = function($file, party) {
			if ($file && $file.$error === 'pattern') {
				return;
			}
			if ($file) {
				DataUtils.toBase64($file, function(base64Data) {
					$scope.$apply(function() {
						party.initialImg = base64Data;
						party.initialImgContentType = $file.type;
					});
				});
			}
		};

	}
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyManagementDetailController', PartyManagementDetailController);

    PartyManagementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'PartyManagement', 'DocumentWorkItem', 'DocumentEvent', 'User', 'AppAccount'];

    function PartyManagementDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, PartyManagement, DocumentWorkItem, DocumentEvent, User, AppAccount) {
        var vm = this;

        vm.party = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:partyUpdate', function(event, result) {
            vm.party = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyManagementDeleteController',PartyManagementDeleteController);

    PartyManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'PartyManagement'];

    function PartyManagementDeleteController($uibModalInstance, entity, PartyManagement) {
        var vm = this;

        vm.party = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PartyManagement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
	'use strict';

	angular.module('jmrsignApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider
				.state(
						'party-management',
						{
							parent : 'appadmin',
							url : '/party-management?page&sort',
							data : {
								authorities : [ 'ROLE_USER' ],
								pageTitle : 'jmrsignApp.party.home.title'
							},
							views : {
								'content@' : {
									templateUrl : 'app/app-account/party-management/party-management.html',
									controller : 'PartyManagementController',
									controllerAs : 'vm'
								}
							},
							params : {
								page : {
									value : '1',
									squash : true
								},
								sort : {
									value : 'id,asc',
									squash : true
								}
							},
							resolve : {
								pagingParams : [
										'$stateParams',
										'PaginationUtil',
										function($stateParams, PaginationUtil) {
											return {
												page : PaginationUtil
														.parsePage($stateParams.page),
												sort : $stateParams.sort,
												predicate : PaginationUtil
														.parsePredicate($stateParams.sort),
												ascending : PaginationUtil
														.parseAscending($stateParams.sort)
											};
										} ],
								translatePartialLoader : [
										'$translate',
										'$translatePartialLoader',
										function($translate,
												$translatePartialLoader) {
											$translatePartialLoader
													.addPart('party');
											$translatePartialLoader
													.addPart('partyType');
											$translatePartialLoader
													.addPart('partyStatus');
											$translatePartialLoader
													.addPart('global');
											return $translate.refresh();
										} ]
							}
						})
				.state(
						'party-management.upload',
						{
							parent : 'party-management',
							url : '/upload',
							data : {
								authorities : [ 'ROLE_USER' ]
							},
							onEnter : [
									'$stateParams',
									'$state',
									'$uibModal',
									function($stateParams, $state, $uibModal) {
										$uibModal
												.open({
													templateUrl : 'app/app-account/party-management/party-management-upload-dialog.html',
													controller : 'PartyManagementUploadDialogController',
													controllerAs : 'vm',
													backdrop : 'static',
													size : 'lg',
													resolve : {
														entity : function() {
															return {
																data : null,
																dataContentType : null
															};
														}
													}
												}).result.then(function() {
											$state.go('^', {}, {
												reload : false
											});
										}, function() {
											$state.go('^');
										});
									} ]
						})
				.state(
						'party-management-detail',
						{
							parent : 'appadmin',
							url : '/party-management/{id}',
							data : {
								authorities : [ 'ROLE_USER' ],
								pageTitle : 'jmrsignApp.party.detail.title'
							},
							views : {
								'content@' : {
									templateUrl : 'app/app-account/party-management/party-management-detail.html',
									controller : 'PartyManagementDetailController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								translatePartialLoader : [
										'$translate',
										'$translatePartialLoader',
										function($translate,
												$translatePartialLoader) {
											$translatePartialLoader
													.addPart('party');
											$translatePartialLoader
													.addPart('partyType');
											return $translate.refresh();
										} ],
								entity : [
										'$stateParams',
										'PartyManagement',
										function($stateParams, PartyManagement) {
											return PartyManagement.get({
												id : $stateParams.id
											}).$promise;
										} ],
								previousState : [
										"$state",
										function($state) {
											var currentStateData = {
												name : $state.current.name
														|| 'party',
												params : $state.params,
												url : $state.href(
														$state.current.name,
														$state.params)
											};
											return currentStateData;
										} ]
							}
						})
				.state(
						'party-management-detail.edit',
						{
							parent : 'party-management-detail',
							url : '/detail/edit',
							data : {
								authorities : [ 'ROLE_USER' ]
							},
							onEnter : [
									'$stateParams',
									'$state',
									'$uibModal',
									function($stateParams, $state, $uibModal) {
										$uibModal
												.open({
													templateUrl : 'app/app-account/party-management/party-management-dialog.html',
													controller : 'PartyManagementDialogController',
													controllerAs : 'vm',
													backdrop : 'static',
													size : 'lg',
													resolve : {
														entity : [
																'PartyManagement',
																function(
																		PartyManagement) {
																	return PartyManagement
																			.get({
																				id : $stateParams.id
																			}).$promise;
																} ]
													}
												}).result.then(function() {
											$state.go('^', {}, {
												reload : false
											});
										}, function() {
											$state.go('^');
										});
									} ]
						})
				.state(
						'party-management.new',
						{
							parent : 'party-management',
							url : '/new',
							data : {
								authorities : [ 'ROLE_USER' ]
							},
							onEnter : [
									'$stateParams',
									'$state',
									'$uibModal',
									function($stateParams, $state, $uibModal) {
										$uibModal
												.open({
													templateUrl : 'app/app-account/party-management/party-management-dialog.html',
													controller : 'PartyManagementDialogController',
													controllerAs : 'vm',
													backdrop : 'static',
													size : 'lg',
													resolve : {
														entity : function() {
															return {
																internalSystemRef : null,
																email : null,
																firstName : null,
																lastName : null,
																cellNumber : null,
																newCellNumber : null,
																validationCode : null,
																signature : null,
																signatureContentType : null,
																signatureImg : null,
																signatureImgContentType : null,
																initialImg : null,
																initialImgContentType : null,
																allowUserUpdate : false,
																type : null,
																id : null
															};
														}
													}
												}).result
												.then(
														function() {
															$state
																	.go(
																			'party-management',
																			null,
																			{
																				reload : 'party-management'
																			});
														},
														function() {
															$state
																	.go('party-management');
														});
									} ]
						})
				.state(
						'party-management.edit',
						{
							parent : 'party-management',
							url : '/{id}/edit',
							data : {
								authorities : [ 'ROLE_USER' ]
							},
							onEnter : [
									'$stateParams',
									'$state',
									'$uibModal',
									function($stateParams, $state, $uibModal) {
										$uibModal
												.open({
													templateUrl : 'app/app-account/party-management/party-management-dialog.html',
													controller : 'PartyManagementDialogController',
													controllerAs : 'vm',
													backdrop : 'static',
													size : 'lg',
													resolve : {
														entity : [
																'PartyManagement',
																function(
																		PartyManagement) {
																	return PartyManagement
																			.get({
																				id : $stateParams.id
																			}).$promise;
																} ]
													}
												}).result
												.then(
														function() {
															$state
																	.go(
																			'party-management',
																			null,
																			{
																				reload : 'party-management'
																			});
														}, function() {
															$state.go('^');
														});
									} ]
						})
				.state(
						'party-management.delete',
						{
							parent : 'party-management',
							url : '/{id}/delete',
							data : {
								authorities : [ 'ROLE_USER' ]
							},
							onEnter : [
									'$stateParams',
									'$state',
									'$uibModal',
									function($stateParams, $state, $uibModal) {
										$uibModal
												.open({
													templateUrl : 'app/app-account/party-management/party-management-delete-dialog.html',
													controller : 'PartyManagementDeleteController',
													controllerAs : 'vm',
													size : 'md',
													resolve : {
														entity : [
																'PartyManagement',
																function(
																		PartyManagement) {
																	return PartyManagement
																			.get({
																				id : $stateParams.id
																			}).$promise;
																} ]
													}
												}).result
												.then(
														function() {
															$state
																	.go(
																			'party-management',
																			null,
																			{
																				reload : 'party-management'
																			});
														}, function() {
															$state.go('^');
														});
									} ]
						});
	}

})();

(function() {
	'use strict';

	angular.module('jmrsignApp').controller('PartyManagementController',
			PartyManagementController);

	PartyManagementController.$inject = [ '$scope', '$state', 'DataUtils',
			'PartyManagement', 'pagingParams', 'paginationConstants',
			'ParseLinks', '$http' ];

	function PartyManagementController($scope, $state, DataUtils,
			PartyManagement, pagingParams, paginationConstants, ParseLinks,
			$http) {
		var vm = this;
		vm.loadAll = loadAll;
		vm.parties = [];
		vm.parties = PartyManagement.searchText();
		vm.openFile = DataUtils.openFile;
		vm.byteSize = DataUtils.byteSize;
		vm.page = 1;
		vm.totalItems = null;
		vm.searchText = '';
		vm.search = search;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.transition = transition;
		vm.loadAll();

		function onSuccess(result, headers) {
			var hiddenPartySize = 0;
			for ( var i in result) {
				if (result[i]['login']) {
					result.splice(i, 1);
					hiddenPartySize++;
				}
			}
			vm.links = ParseLinks.parse(headers('link'));
			vm.totalItems = headers('X-Total-Count') - hiddenPartySize;
			vm.queryCount = vm.totalItems;
			vm.page = pagingParams.page;
			vm.parties = result;
		}
		function loadAll() {
			PartyManagement.searchText({
				searchText : vm.searchText,
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
		}
		
		function search() {
			vm.loadAll();
		}

		function onError(error) {
			AlertService.error(error.result.message);
		}

		function sort() {
			var result = [ vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc') ];
			if (vm.predicate !== 'id') {
				result.push('id');
			}
			return result;
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : vm.currentSearch
			});
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('appadmin', {
            abstract: true,
            parent: 'app'
        })
        .state('app-account-profile', {
            parent: 'appadmin',
            url: '/profile',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.appAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/app-account/profile.html',
                    controller: 'AppAccountProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppAccount','JmrAuth', function($stateParams, AppAccount, JmrAuth) {
                    return AppAccount.get({id : JmrAuth.currentAccountId()}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'app-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('jmrsignApp')
        .constant('VERSION', "2.0.1")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                //JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                //JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('jmrsignApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers['X-CSRF-TOKEN'] = $cookies[$http.defaults.xsrfCookieName];
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('jmrsignApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SocialRegisterController', SocialRegisterController);

    SocialRegisterController.$inject = ['$filter', '$stateParams'];

    function SocialRegisterController ($filter, $stateParams) {
        var vm = this;

        vm.success = $stateParams.success;
        vm.error = !vm.success;
        vm.provider = $stateParams.provider;
        vm.providerLabel = $filter('capitalize')(vm.provider);
        vm.success = $stateParams.success;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('social-register', {
            parent: 'account',
            url: '/social-register/:provider?{success:boolean}',
            data: {
                authorities: [],
                pageTitle: 'social.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/social/social-register.html',
                    controller: 'SocialRegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('social');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('SocialService', SocialService);

    SocialService.$inject = ['$document'];

    function SocialService ($document) {
        var socialService = {
            getProviderSetting: getProviderSetting,
            getProviderURL: getProviderURL,
            getCSRF: getCSRF
        };

        return socialService;

        function getProviderSetting (provider) {
            switch(provider) {
            case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
            case 'facebook': return 'public_profile,email';
            case 'twitter': return '';
                // jhipster-needle-add-social-button
            default: return 'Provider setting not defined';
            }
        }

        function getProviderURL (provider) {
            return 'signin/' + provider;
        }

        function getCSRF () {
            /* globals document */
            var name = 'CSRF-TOKEN=';
            var ca = $document[0].cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) !== -1) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('jhSocial', jhSocial);

    jhSocial.$inject = ['$translatePartialLoader', '$translate', '$filter', 'SocialService'];

    function jhSocial($translatePartialLoader, $translate, $filter, SocialService) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider'
            },
            templateUrl: 'app/account/social/directive/social.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {
            
            $translatePartialLoader.addPart('social');
            $translate.refresh();
            
            scope.label = $filter('capitalize')(scope.provider);
            scope.providerSetting = SocialService.getProviderSetting(scope.provider);
            scope.providerURL = SocialService.getProviderURL(scope.provider);
            scope.csrf = SocialService.getCSRF();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('party');
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'JmrAuth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, JmrAuth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.registerAccount.login = vm.registerAccount.email;
                vm.registerAccount.accountId = JmrAuth.currentAccountId();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyDialogController', PartyDialogController);

    PartyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Party', 'DocumentWorkItem', 'User', 'AppAccount','Principal', 'JmrAuth'];

    function PartyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Party, DocumentWorkItem, User, AppAccount , Principal, JmrAuth) {
        var vm = this;

        vm.party = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentworkitems = DocumentWorkItem.query();
        vm.users = User.query();
        vm.appaccounts = AppAccount.query();
        vm.uncroppedSignatureImg = '';
        vm.uncroppedInitialImg = '';

        Principal.identity().then(function(account) {
            vm.party.email = account.email;
            vm.party.firstName = account.firstName;
            vm.party.lastName = account.lastName;
            vm.party.accountId = JmrAuth.currentAccountId();
        });

        var iti = null;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();

            var input = document.getElementById('field_cellNumber');
            iti = window.intlTelInput(input, {
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/14.0.3/js/utils.js",
                initialCountry: "za",
                preferredCountries: [ "za", "gb" ],
                separateDialCode: true
            });

        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if (iti){
                vm.party.cellNumber = iti.getNumber();
            }

            vm.isSaving = true;
            if(vm.party.signatureImg){
                var countSI = (vm.party.signatureImg.match(/base64,/g) || []).length;
                if (countSI > 0){
                    vm.party.signatureImg = vm.party.signatureImg.substr(vm.party.signatureImg.indexOf('base64,') + 'base64,'.length);
                }   
            }

            if(vm.party.initialImg){
                var countII = (vm.party.initialImg.match(/base64,/g) || []).length;
                if (countII > 0){
                    vm.party.initialImg = vm.party.initialImg.substr(vm.party.initialImg.indexOf('base64,') + 'base64,'.length);
                }   
            }
            
            if (vm.party.id !== null) {
                Party.update(vm.party, onSaveSuccess, onSaveError);
            } else {
                Party.save(vm.party, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:partyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setSignatureImg = function ($file, party) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (evt) {
                    $scope.$apply(function($scope){
                        vm.uncroppedSignatureImg = evt.target.result;
                        party.signatureImgContentType = $file.type;
                    });
                };
            }
        };

        vm.setInitialImg = function ($file, party) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (evt) {
                    $scope.$apply(function($scope){
                        vm.uncroppedInitialImg = evt.target.result;
                        party.initialImgContentType = $file.type;
                    });
                };
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyDetailController', PartyDetailController);

    PartyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Party', 'DocumentWorkItem', 'User', 'AppAccount'];

    function PartyDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Party, DocumentWorkItem, User, AppAccount) {
        var vm = this;
        vm.party = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:partyUpdate', function(event, result) {
            vm.party = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyDeleteController',PartyDeleteController);

    PartyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Party'];

    function PartyDeleteController($uibModalInstance, entity, Party) {
        var vm = this;

        vm.party = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Party.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('account.party', {
            parent: 'account',
            url: '/party',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jmrsignApp.party.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/party/parties.html',
                    controller: 'PartyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('party');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('account.party-detail', {
            parent: 'account',
            url: '/party/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jmrsignApp.party.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/party/party-detail.html',
                    controller: 'PartyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('party');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Party', function($stateParams, Party) {
                    return Party.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'party',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('account.party-detail.edit', {
            parent: 'account.party-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Party', function(Party) {
                            return Party.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account.party.new', {
            parent: 'account.party',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                email: null,
                                firstName: null,
                                lastName: null,
                                cellNumber: null,
                                signature: null,
                                signatureContentType: null,
                                initial: null,
                                initialContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('account.party', null, { reload: 'party' });
                }, function() {
                    $state.go('account.party');
                });
            }]
        })
        .state('account.party.edit', {
            parent: 'account.party',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Party', function(Party) {
                            return Party.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account.party', null, { reload: 'party' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account.party.delete', {
            parent: 'account.party',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/party/party-delete-dialog.html',
                    controller: 'PartyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Party', function(Party) {
                            return Party.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account.party', null, { reload: 'party' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('my-party', {
            parent: 'account',
            url: '/my-party',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.party.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/party/party-detail.html',
                    controller: 'PartyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('party');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppPartySvc','JmrAuth', function($stateParams, AppPartySvc, JmrAuth) {

                    // TODO
                    //console.log('Current Party:' + JmrAuth.currentPartyId());
                    return AppPartySvc.get().$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'party',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('my-party.new', {
            parent: 'inbox',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','JmrAuth', function($stateParams, $state, $uibModal, JmrAuth) {
                $uibModal.open({
                    templateUrl: 'app/account/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('party');
                            return $translate.refresh();
                        }],

                        entity: function () {
                            return {
                                email: null,
                                firstName: null,
                                lastName: null,
                                cellNumber: null,
                                signature: null,
                                signatureContentType: null,
                                initial: null,
                                initialContentType: null,
                                id: null,
                                allowUserUpdate: true,
                                status: 'ENABLED',
                                type:'EXTERNAL_USER'
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('inbox', null, { reload: true });
                }, function() {
                    $state.go('inbox');
                });
            }]
        })
        .state('my-party.edit', {
            parent: 'my-party',
            url: '/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'JmrAuth', function($stateParams, $state, $uibModal, JmrAuth) {
                $uibModal.open({
                    templateUrl: 'app/account/party/party-dialog.html',
                    controller: 'PartyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppPartySvc', function(AppPartySvc) {
                            // TODO
                            return AppPartySvc.get().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('my-party', null, { reload: 'party' });
                }, function() {
                    $state.go('my-party');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('Party', Party);

    Party.$inject = ['$resource'];

    function Party ($resource) {
        var resourceUrl =  'api/parties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyController', PartyController);

    PartyController.$inject = ['$scope', '$state', 'DataUtils', 'Party'];

    function PartyController ($scope, $state, DataUtils, Party) {
        var vm = this;

        vm.parties = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            Party.query(function(result) {
                vm.parties = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('jmrsignApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/app-account/profile.html','<div class="row"><div class="col-md-6 col-md-offset-3"><div class="panel panel-border panel-primary"><div class="panel-heading"><h3 class="panel-title">Company Account Profile</h3></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.appAccount.title">Title</span></dt><dd><span>{{vm.appAccount.title}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.domain">Domain</span></dt><dd><span>{{vm.appAccount.domain}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.allowUserRegistration">Allow User Registration</span></dt><dd><div class="checkbox checkbox-success checkbox-circle"><input disabled="disabled" ng-model="vm.appAccount.allowUserRegistration" type="checkbox"><label>{{vm.appAccount.allowUserRegistration}}</label></div></dd><dt><span data-translate="jmrsignApp.appAccount.allowDigitalSig">Allow Digital Sig</span></dt><dd><div class="checkbox checkbox-success checkbox-circle"><input disabled="disabled" ng-model="vm.appAccount.allowDigitalSig" type="checkbox"><label>{{vm.appAccount.allowDigitalSig}}</label></div></dd><dt><span data-translate="jmrsignApp.appAccount.allowTwoStepAuth">Allow Two Step Auth</span></dt><dd><div class="checkbox checkbox-success checkbox-circle"><input disabled="disabled" ng-model="vm.appAccount.allowTwoStepAuth" type="checkbox"><label>{{vm.appAccount.allowTwoStepAuth}}</label></div></dd><dt><span>Initial Pages</span></dt><dd><div class="checkbox checkbox-success checkbox-circle"><input disabled="disabled" ng-model="vm.appAccount.allowTwoStepAuth" type="checkbox"><label>{{vm.appAccount.allowInitialPages}}</label></div></dd><dt><span data-translate="jmrsignApp.appAccount.logoImg">Logo Img</span></dt><dd><div ng-if="vm.appAccount.logoImg"><a ng-click="vm.openFile(vm.appAccount.logoImgContentType, vm.appAccount.logoImg)"><img data-ng-src="{{\'data:\' + vm.appAccount.logoImgContentType + \';base64,\' + vm.appAccount.logoImg}}" style="max-width: 100%"> </a>{{vm.appAccount.logoImgContentType}}, {{vm.byteSize(vm.appAccount.logoImg)}}</div></dd><dt><span data-translate="jmrsignApp.appAccount.terms">Terms</span></dt><dd><span>{{vm.appAccount.terms}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocToSign">Tpl Doc To Sign</span></dt><dd><span>{{vm.appAccount.tplDocToSign}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocComplete">Tpl Doc Complete</span></dt><dd><span>{{vm.appAccount.tplDocComplete}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocReject">Tpl Doc Reject</span></dt><dd><span>{{vm.appAccount.tplDocReject}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocRemind">Tpl Doc Remind</span></dt><dd><span>{{vm.appAccount.tplDocRemind}}</span></dd></dl></div></div></div></div>');
$templateCache.put('app/documents/documents-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.document.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.document.delete.question" translate-values="{id: \'{{vm.document.title}}\'}">Are you sure you want to delete this Document?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/documents/documents-detail.html','<div class="btn-group pull-right"><a ng-href="/api/accounts/{{vm.document.accountId}}/documents/{{vm.document.id}}/pdf/original" type="button" class="btn btn-default dropdown-toggle waves-effect waves-light"><span class="glyphicon glyphicon-download"></span> <span>Original Copy<span> </span></span></a><a ng-href="/api/accounts/{{vm.document.accountId}}/documents/{{vm.document.id}}/pdf/audit" ng-disabled="vm.document.status != \'COMPLETED\'" type="button" class="btn btn-default dropdown-toggle waves-effect waves-light {{vm.document.status != \'COMPLETED\' ? \'disabled-button\':\'\'}}"><span class="glyphicon glyphicon-download"></span> <span>Audit Trail<span> </span></span></a><a ng-href="/api/accounts/{{vm.document.accountId}}/documents/{{vm.document.id}}/pdf/signed" ng-disabled="vm.document.status != \'COMPLETED\'" type="button" class="btn btn-success dropdown-toggle waves-effect waves-light {{vm.document.status != \'COMPLETED\' ? \'disabled-button\':\'\'}}"><span class="glyphicon glyphicon-download"></span> <span>Signed Copy<span></span></span></a></div><h2>Document - {{vm.document.title}}</h2><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-6"><div class="panel panel-border panel-primary"><div class="panel-heading"><div class="btn-group pull-right"><button type="button" disabled="disabled" class="btn btn-default waves-effect waves-light">{{vm.document.status}}</button></div><div class="btn-group pull-right"><button type="button" ng-if="vm.document.status == \'IN_PROGRESS\'" ng-click="vm.cancelDocument(wi)" class="btn btn-danger waves-effect waves-light"><span class="glyphicon glyphicon-remove-sign"></span> <span class="hidden-xs hidden-sm">Cancel</span></button></div><h3 class="panel-title">Workflow</h3></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Type</span></th><th><span>Page</span></th><th><span>Person</span></th><th><span>Options</span></th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="wi in vm.documentWorkitems track by $index"><td>{{wi.seqNo}}</td><td>{{wi.type}}</td><td><span ng-if="wi.pageNo">Page {{wi.pageNo}} ({{wi.xPos}},{{wi.yPos}})</span></td><td><span ng-if="wi.partyId">{{wi.legalName}} ({{wi.email}})</span></td><td><div ng-if="wi.type == \'SIGNER\'" class="checkbox checkbox-info checkbox-circle"><input disabled="disabled" ng-model="wi.requireInitialPage" type="checkbox"><label>Initial&nbsp;Pages</label></div><div ng-if="wi.type == \'SIGNER\'" class="checkbox checkbox-info checkbox-circle"><input disabled="disabled" ng-model="wi.requireTwoStepAuth" type="checkbox"><label>Require&nbsp;OTP</label></div><div ng-if="wi.type == \'SIGNER\'" class="checkbox checkbox-info checkbox-circle"><input disabled="disabled" ng-model="wi.requireAccessCode" type="checkbox"><label>Secret&nbsp;Token</label></div><div class="checkbox checkbox-success checkbox-circle"><input disabled="disabled" ng-model="wi.requireSignedCopy" type="checkbox"><label>Signed&nbsp;Copy</label></div></td><td>{{wi.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-if="wi.status == \'NOTIFIED\' && wi.type == \'SIGNER\'" type="submit" ng-click="vm.remindDocument(wi)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-user"></span> <span class="hidden-xs hidden-sm">Remind</span></button></div></td><td><div><button class="btn btn-success move-up-down" ng-click="vm.moveUp(wi, $index);" ng-if="(vm.document.status == \'DRAFT\' || vm.document.status == \'IN_PROGRESS\') &&\n                                                       wi.status != \'NOTIFIED\' &&\n                                                       wi.status != \'COMPLETED\' &&\n                                                       vm.documentWorkitems[$index - 1].status != \'NOTIFIED\' &&\n                                                       vm.documentWorkitems[$index - 1].status != \'COMPLETED\' &&\n                                                       $index > 1">Move Up</button></div><div><button class="btn btn-success move-up-down" ng-click="vm.moveDown(wi, $index);" ng-if="(vm.document.status == \'DRAFT\' || vm.document.status == \'IN_PROGRESS\') &&\n                                                       wi.status != \'NOTIFIED\' &&\n                                                       wi.status != \'COMPLETED\' &&\n                                                       vm.documentWorkitems[$index + 1].status != \'NOTIFIED\' &&\n                                                       vm.documentWorkitems[$index + 1].status != \'COMPLETED\' &&\n                                                       $index < vm.documentWorkitems.length - 1">Move Down</button></div></td></tr></tbody></table></div></div></div></div><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><div class="btn-group pull-right"></div><h3 class="panel-title">Information</h3></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.document.externalSystemRef">External System Ref</span></dt><dd><span>{{vm.document.externalSystemRef}}</span></dd><dt><span data-translate="jmrsignApp.document.title">Title</span></dt><dd><span>{{vm.document.title}}</span></dd><dt><span data-translate="jmrsignApp.document.description">Description</span></dt><dd><span>{{vm.document.description}}</span></dd><dt><span data-translate="jmrsignApp.document.createDate">Create Date</span></dt><dd><span>{{vm.document.createDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.document.expireDate">Expire Date</span></dt><dd><span>{{vm.document.expireDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.document.status">Status</span></dt><dd><span data-translate="{{\'jmrsignApp.DocumentStatus.\' + vm.document.status}}">{{vm.document.status}}</span></dd></dl></div></div></div></div><div class="row"><div class="col-md-12"><div class="panel panel-border panel-default"><div class="panel-heading"><div class="btn-group pull-right"></div><h3 class="panel-title">Audit Events</h3></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Timestamp</span></th><th><span>Group</span></th><th><span>Description</span></th><th><span>Type</span></th><th></th></tr></thead><tbody><tr ng-repeat="evt in vm.documentEvents"><td>{{evt.eventTimestamp}}</td><td>{{evt.eventGroup}}</td><td>{{evt.description}}</td><td>{{evt.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"></div></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/documents/documents-edit-dialog.html','<form name="docEditForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentLabel">Edit Document Information</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.externalSystemRef" for="field_externalSystemRef">External System Ref</label><input type="text" class="form-control" name="externalSystemRef" id="field_externalSystemRef" ng-model="vm.document.externalSystemRef" required><div ng-show="docEditForm.externalSystemRef.$invalid"><p class="help-block" ng-show="docEditForm.externalSystemRef.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.expireDate" for="field_expireDate">Expire Date</label><div class="input-group"><input id="field_expireDate" type="text" class="form-control" name="expireDate" datetime-picker="{{dateformat}}" ng-model="vm.document.expireDate" is-open="vm.datePickerOpenStatus.expireDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expireDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.document.title" required><div ng-show="docEditForm.title.$invalid"><p class="help-block" ng-show="docEditForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.document.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="docEditForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/documents/documents-setup.html','<div class="btn-group pull-right"><button ng-click="vm.finalize()" type="button" class="btn btn-success dropdown-toggle waves-effect waves-light">Finalize Document Flow</button></div><h2>Setup Document</h2><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-5"><div class="panel panel-border panel-primary"><div class="panel-heading"><div class="btn-group pull-right"><button type="button" ng-click="vm.addSignature(null)" class="btn btn-default waves-effect waves-light"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm">Add</span></button></div><h3 class="panel-title">Workflow</h3></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Type</span></th><th><span>Page</span></th><th><span>Person</span></th><th><span>Options</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="wi in vm.documentWorkitems track by $index"><td>{{wi.seqNo}}</td><td>{{wi.type}}</td><td><span ng-if="wi.pageNo">Page {{wi.pageNo}} ({{wi.xPos}},{{wi.yPos}})</span></td><td><span ng-if="wi.partyId">{{wi.legalName}} ({{wi.email}})</span></td><td><div ng-if="wi.type == \'SIGNER\'" class="checkbox checkbox-info checkbox-circle"><input ng-model="wi.requireInitialPage" ng-change="vm.saveWorkitem(wi)" type="checkbox"><label>Initial&nbsp;Pages</label></div><div ng-if="wi.type == \'SIGNER\'" class="checkbox checkbox-info checkbox-circle"><input ng-disabled="wi.accessCode == null || wi.accessCode == \'\' || wi.status == \'COMPLETED\'" ng-model="wi.requireTwoStepAuth" ng-change="vm.saveWorkitem(wi)" type="checkbox"><label>Require&nbsp;OTP</label></div><div ng-if="wi.type == \'SIGNER\'" class="checkbox checkbox-info checkbox-circle"><input ng-model="wi.requireAccessCode" ng-change="vm.saveWorkitem(wi)" type="checkbox"><label>Secret&nbsp;Token</label></div><div ng-if="wi.type == \'SIGNER\' && wi.requireAccessCode" class=""><input ng-model="wi.accessCode" ng-blur="vm.saveWorkitem(wi)" type="password"></div><div class="checkbox checkbox-success checkbox-circle"><input ng-disabled="wi.type == \'EDITOR\' || wi.status == \'COMPLETED\' || wi.type == \'SIGNED_COPY\' || wi.type == \'CARBON_COPY\'" ng-model="wi.requireSignedCopy" ng-change="vm.saveWorkitem(wi)" type="checkbox"><label>Signed&nbsp;Copy</label></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-disabled="wi.status == \'COMPLETED\'" ng-if="wi.type != \'EDITOR\'" type="submit" ng-click="vm.addSignature(wi)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button ng-disabled="wi.status == \'COMPLETED\'" ng-if="wi.type != \'EDITOR\'" type="submit" ng-click="vm.removeSignature(wi)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-sm btn-default move-up-down" ng-click="vm.moveUp(wi, $index);" ng-if="(vm.document.status == \'DRAFT\' || vm.document.status == \'IN_PROGRESS\') &&\n                                                       wi.status != \'NOTIFIED\' &&\n                                                       wi.status != \'COMPLETED\' &&\n                                                       vm.documentWorkitems[$index - 1].status != \'NOTIFIED\' &&\n                                                       vm.documentWorkitems[$index - 1].status != \'COMPLETED\' &&\n                                                       $index > 1"><span class="glyphicon glyphicon glyphicon-arrow-up"></span> <span class="hidden-xs hidden-sm"></span></button> <button class="btn btn-sm btn-default move-up-down" ng-click="vm.moveDown(wi, $index);" ng-if="(vm.document.status == \'DRAFT\' || vm.document.status == \'IN_PROGRESS\')&&\n                                                wi.status != \'NOTIFIED\' &&\n                                                wi.status != \'COMPLETED\' &&\n                                                vm.documentWorkitems[$index + 1].status != \'NOTIFIED\' &&\n                                                vm.documentWorkitems[$index + 1].status != \'COMPLETED\' &&\n                                                $index < vm.documentWorkitems.length - 1"><span class="glyphicon glyphicon glyphicon-arrow-down"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div ng-if="vm.isAdding" class="alert alert-info">Select the location of the signature by clicking on the document. <i class="fa fa-arrow-circle-o-right fa-2x pull-right"></i></div></div></div><div class="panel panel-default"><div class="panel-heading"><div class="btn-group pull-right"><button type="button" ui-sref="documents.setup.edit({id:vm.document.id})" class="btn btn-default waves-effect waves-light"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div><h3 class="panel-title">Information</h3></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.document.externalSystemRef">External System Ref</span></dt><dd><span>{{vm.document.externalSystemRef}}</span></dd><dt><span data-translate="jmrsignApp.document.title">Title</span></dt><dd><span>{{vm.document.title}}</span></dd><dt><span data-translate="jmrsignApp.document.description">Description</span></dt><dd><span>{{vm.document.description}}</span></dd><dt><span data-translate="jmrsignApp.document.createDate">Create Date</span></dt><dd><span>{{vm.document.createDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.document.expireDate">Expire Date</span></dt><dd><span>{{vm.document.expireDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.document.status">Status</span></dt><dd><span data-translate="{{\'jmrsignApp.DocumentStatus.\' + vm.document.status}}">{{vm.document.status}}</span></dd></dl></div></div></div><div class="col-md-7"><div class="panel panel-defaultpanel-fill"><div class="panel-heading"><h3 class="panel-title">Preview: Page: {{vm.currentPage}} of {{vm.totalItems}}</h3><div class="pull-right" style="margin-top: -50px"><ul uib-pagination items-per-page="1" total-items="vm.totalItems" ng-model="vm.currentPage" class="pagination-sm" boundary-links="true" ng-change="setupPage()"></ul></div></div><div class="panel-body" ng-model="currentPage"><div id="size-wrapper"><div ng-repeat="page in vm.documentPages"><img class="doc-images" ng-show="vm.currentPage == $index+1" id="document-image-{{$index+1}}" ng-src="/api/accounts/{{vm.document.accountId}}/documents/{{vm.document.id}}/pages/{{$index+1}}" style="max-width: 100%"></div></div></div></div></div></div>');
$templateCache.put('app/documents/documents-upload-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentLabel">Upload Document</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group">\n            <label class="control-label" data-translate="jmrsignApp.document.externalSystemRef" for="field_externalSystemRef">External System Ref</label>\n            <input type="text" class="form-control" name="externalSystemRef" id="field_externalSystemRef"\n            ng-model="vm.document.externalSystemRef"\n            required />\n            <div ng-show="editForm.externalSystemRef.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.externalSystemRef.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div> --><div class="form-group"><div class="btn-group"><label class="btn" ng-class="(vm.type == \'fu\') ? \'btn-primary\' : \'btn-default\' " ng-model="vm.type" uib-btn-radio="\'fu\'">File Upload</label><label class="btn" ng-class="(vm.type == \'url\') ? \'btn-primary\' : \'btn-default\' " ng-model="vm.type" uib-btn-radio="\'url\'">Internet URL</label></div></div><div ng-if="vm.type == \'fu\'" class="form-group" ngf-drop ngf-change="vm.setData($file, vm.document)"><label class="control-label" for="field_data">Select Document</label><div><div ng-if="vm.document.data" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.document.dataContentType, vm.document.data)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.document.dataContentType}}, {{vm.byteSize(vm.document.data)}}</span> <button type="button" ng-click="vm.document.data=null;vm.document.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setData($file, vm.document)">Add Document</button></div><input type="hidden" class="form-control" name="data" id="field_data" ng-model="vm.document.data" required> <input type="hidden" class="form-control" name="dataContentType" id="field_dataContentType" ng-model="vm.document.dataContentType"></div><div ng-if="vm.type == \'url\'" class="form-group"><label class="control-label" for="field_url">Document Internet URL</label><input type="url" class="form-control" name="url" id="field_url" ng-model="vm.document.url" required><div ng-show="editForm.url.$invalid"><p class="help-block" ng-show="editForm.url.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.url.$error.url">Not valid url!</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.document.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/documents/documents.html','<div class="form-horizontal"><div class="form-group"><label class="col-md-9 control-label">Search</label><div class="col-md-offset-9"><input ng-model="vm.searchText" type="text" class="form-control" placeholder="Document title" ng-change="vm.search()" ng-minlength="3"></div><label class="col-md-9 control-label">Search By Status</label><div class="col-md-offset-9"><select ng-model="vm.searchState" type="text" class="form-control" ng-change="vm.search()"><option value="">ALL</option><option value="DRAFT">DRAFT</option><option value="IN_PROGRESS">IN_PROGRESS</option><option value="REJECTED">REJECTED</option><option value="COMPLETED">COMPLETED</option><option value="TRASH">TRASH</option><option value="FAILED">FAILED</option></select></div></div></div><h3>Account Documents</h3><div class="row"><jhi-alert-error></jhi-alert-error><div class="col-md-12"><div class="panel panel-border panel-primary"><div class="panel-heading"><h3 class="panel-title">Document List</h3></div><div class="panel-body"><div class="clearfix"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Reference No.</span></th><th jh-sort-by="title"><span data-translate="jmrsignApp.document.title">Title</span> &nbsp; <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createDate"><span data-translate="jmrsignApp.document.createDate">CreateDate</span> &nbsp; <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="expireDate"><span data-translate="jmrsignApp.document.expireDate">ExpireDate</span> &nbsp; <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="jmrsignApp.document.status">Status</span> &nbsp; <span class="glyphicon glyphicon-sort"></span></th><th><span>Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="document in vm.documents track by document.id"><td>{{document.externalSystemRef}}</td><td>{{document.title}}</td><td>{{document.createDate | date:\'medium\'}}</td><td>{{document.expireDate | date:\'medium\'}}</td><td data-translate="{{\'jmrsignApp.DocumentStatus.\' + document.status}}">{{document.status}}</td><td><a ng-if="document.data" ng-click="vm.openFile(document.dataContentType, document.data)" data-translate="entity.action.open">open</a> <span ng-if="document.data">{{document.dataContentType}}, {{vm.byteSize(document.data)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="documents.detail({id:document.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ng-if="document.status == \'DRAFT\'" ui-sref="documents.delete({id:document.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div style="width: 300px; margin: 0 auto"><uib-pagination style="width:300px; margin:0 auto" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination><!--  <pre>You are currently on page {{vm.page}}</pre> --></div></div></div></div></div>');
$templateCache.put('app/inbox/inbox.html','<div class="container-fluid" ng-switch="vm.hasCurrentAccount()"><div class="row" ng-switch-when="false"><div class="col-md-6 col-md-offset-3"><div ng-if="vm.party.status == \'DISABLED\'" class="alert alert-danger fade in"><p><i class="fa fa-ban fa-4x pull-left"></i> Access to this account is currently disabled on your profile. If you believe this to be an error, please contact the administrators of the account.</p><p><button ng-click="vm.logout()" type="button" class="btn btn-danger waves-effect waves-light">Log out</button></p></div><div ng-if="vm.party.status == \'RESTRICTED\'" class="alert alert-warning fade in"><p><i class="fa fa-warning fa-4x pull-left"></i> Access to this account is currently restricted on your profile. Before you continue please validate your signature details.</p><p><button ui-sref="my-party" type="button" class="btn btn-warning waves-effect waves-light">Validate my details</button></p></div><div can-register="true" class="alert alert-warning fade in"><h4>Oh no!</h4><p>You are currently registered with us, however you do not yet have an account setup, would you like to create one?</p><p><button ui-sref="my-party.new" type="button" class="btn btn-warning waves-effect waves-light">Yes, create an account</button> <button type="button" class="btn btn-default waves-effect" ng-click="vm.logout()">No, sign out</button></p></div><div can-register="false" class="alert alert-danger fade in"><h4>Oh no!</h4><p>You are currently registered with us, however you have not been given access to use this account, please contact the company.</p><p><button type="button" class="btn btn-danger waves-effect waves-light" ng-click="vm.logout()">OK, sign out</button></p></div></div></div><div class="row" ng-switch-when="true"><div has-authority="ROLE_USER" class="col-md-4 col-lg-7 p-b-10"><span><h4>Welcome, {{vm.party.displayName}}</h4></span></div><div class="col-md-4 col-lg-3"><div class="form-horizontal"><div class="form-group"><label class="col-md-2 control-label">Search</label><div class="col-md-10"><input ng-model="vm.searchText" type="text" class="form-control"></div></div></div></div><div class="col-md-4 col-lg-2 p-b-10"><button has-authority="ROLE_USER" ng-if="vm.minRole(\'ACCOUNT_USER\')" class="btn btn-primary btn-block waves-effect" ui-sref="documents.upload"><span class="glyphicon glyphicon-upload"></span> <span>Upload Document</span></button></div></div><div class="row" ng-switch-when="true"><div class="col-md-12"><uib-tabset active="active" class="nav nav-tabs navtab-bg" justified="false" type="tabs"><uib-tab class="tab" index="$index + 1" ng-repeat="tab in vm.tabs" disable="tab.disabled"><uib-tab-heading><i class="glyphicon {{tab.icon}}"></i>&nbsp;&nbsp;<span>{{tab.title}}</span> <span ng-if="tab.items.length > 0" style="float: right;margin-top: 15px" class="badge badge-primary">{{tab.items.length}}</span></uib-tab-heading><div class="row"><div class="col-lg-3 col-md-4 col-sm-6" ng-repeat="item in vm.inboxItems | filter:vm.searchText | filter:tab.filter track by item.id"><div class="panel panel-default panel-border"><div class="panel-heading"><h3 class="panel-title">{{item.document.title}}</h3></div><div class="panel-body"><div class="media"><div class="media-left"><a href="#"><img ng-src="/api/accounts/{{item.document.accountId}}/documents/{{item.document.id}}/preview" style="max-width: 100px"></a></div><div class="media-body"><h4 class="media-heading">{{item.document.status}}</h4><dl class=""><dt>Description</dt><dd>{{item.document.description}}</dd><dt>Allocated</dt><dd>{{item.startDate | date:\'medium\'}}</dd></dl></div></div></div><div class="panel-footer"><a ng-if="item.type == \'SIGNER\'" ui-sref="sign({ id: item.document.id, wiid: item.id})" class="btn btn-primary btn-block" role="button">Sign</a> <a ng-if="item.type != \'SIGNER\' && item.status != \'COMPLETED\'" ui-sref="documents.setup({ id: item.document.id, wiid: item.id})" class="btn btn-default btn-block" role="button">Setup</a></div></div></div><div class="alert alert-info" ng-hide="(vm.inboxItems | filter:vm.searchText | filter:tab.filter).length > 0"><i class="fa fa-info fa-2x pull-left"></i>&nbsp;No documents found.</div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-12"><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><!-- <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>\n                    If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").\n                </div> --><div can-register="true" class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div></div></div></div></div>');
$templateCache.put('app/home/root-cert.html','<div class="row"><div class="col-md-6 col-md-offset-3"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title">Trusted Root Certificate installation guide</h3></div><div class="panel-body"><div class="alert alert-success fade in"><p><i class="fa fa-info-circle fa-4x pull-left"></i> Please download the following file, remember where you saved this file, and then just double click on it and follow the screen prints below.</p><p><a href="/content/images/root-cert/Eezi-Sign-Cert.fdf" type="button" class="btn btn-success waves-effect waves-light">Download Root Certificate</a></p></div><div class="panel panel-border panel-default"><div class="panel-heading"><h3 class="panel-title">Step 1</h3></div><div class="panel-body"><img src="/content/images/root-cert/cert1.png" style="width:100%"></div></div><div class="panel panel-border panel-default"><div class="panel-heading"><h3 class="panel-title">Step 2</h3></div><div class="panel-body"><img src="/content/images/root-cert/cert2.png" style="width:100%"></div></div><div class="panel panel-border panel-default"><div class="panel-heading"><h3 class="panel-title">Step 3</h3></div><div class="panel-body"><img src="/content/images/root-cert/cert3.png" style="width:100%"></div></div><div class="panel panel-border panel-default"><div class="panel-heading"><h3 class="panel-title">Step 4</h3></div><div class="panel-body"><img src="/content/images/root-cert/cert4.png" style="width:100%"></div></div></div></div></div></div>');
$templateCache.put('app/login/login.html','<div class="row"><div class="col-md-4 col-md-offset-4"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title" data-translate="login.title">Registration</h3></div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-12"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.email">Email</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary btn-block" data-translate="login.form.button">Sign in</button></form><br><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div can-register="true" class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div><!--<div class="col-md-6">\n                        \n                        <br/>\n                        <jh-social ng-provider="google"></jh-social>\n                        <jh-social ng-provider="facebook"></jh-social>\n                        <jh-social ng-provider="twitter"></jh-social> --><!-- jhipster-needle-add-social-button --><!-- </div> --></div></div><div class="panel-footer"></div></div></div></div>');
$templateCache.put('app/sign/capture.html','<div class="row"><div class="col-md-8 col-md-offset-2"><h3>{{vm.document.title}}</h3><jhi-alert-error></jhi-alert-error></div></div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Signature</h3></div><div class="panel-body"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.signDocument()" show-validation><div class="form-group"><label class="control-label" for="field_signature">Your Signature</label><div><div ng-if="vm.party.signatureImg" class="help-block clearfix"><div class="media"><a class="pull-left" href="#"><img data-ng-src="{{\'data:\' + vm.party.signatureImgContentType + \';base64,\' + vm.party.signatureImg}}" style="max-height: 100px" ng-if="vm.party.signatureImg"></a><div class="media-body"><h4 class="media-heading">Signed by: {{vm.workItem.legalName}}</h4><h5 class="media-heading">Cell: {{vm.party.cellNumber}}</h5><h5 class="media-heading">Date: {{vm.date | date:\'dd MMM yyyy (HH:mm)\'}}</h5></div></div><!-- <button type="button" ng-click="vm.party.signature=null;vm.party.signatureContentType=null;"\n                                        class="btn btn-default btn-xs pull-right">\n                                    <span class="glyphicon glyphicon-remove"></span>\n                                </button> --></div><!-- <button type="button" ngf-select class="btn btn-default btn-block"\n                                    ngf-change="vm.setSignature($file, vm.party)" data-translate="entity.action.addblob">\n                                Add blob\n                            </button> --></div><input type="hidden" class="form-control" name="signature" id="field_signature" ng-model="vm.party.signature"> <input type="hidden" class="form-control" name="signatureContentType" id="field_signatureContentType" ng-model="vm.party.signatureContentType"></div><div ng-if="vm.requireOTP" class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">One-Time PIN</h3></div><div class="panel-body"><div class="alert alert-warning fade in"><h4>A one-time PIN has been delivered to {{vm.party.cellNumber}} at {{vm.wia.startDate | date:\'mediumTime\'}}.</h4><p>This PIN will remain valid for 5 minutes. If in the event you have not received a PIN in that time, please <a ng-click="vm.resendOTP()" class="alert-link">request re-delivery of OTP.</a></p></div><div class="form-group"><label class="control-label" for="pin">PIN</label><input ui-mask="999-999" type="pin" class="form-control" id="pin" name="pin" ng-model="vm.credentials.pin" required><div ng-show="form.pin.$dirty && form.pin.$invalid"><p class="help-block" ng-show="form.pin.$error.required">Your PIN is required.</p></div></div></div></div><div ng-if="vm.requireCode" class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Secret Token</h3></div><div class="panel-body"><div class="alert alert-warning fade in"><h4>A Secret Token has been provided to you by directly by the document originator.</h4><p>Please enter the token below. If you have not yet received this token, please contact them directly.</p></div><div class="form-group"><label class="control-label" for="token">Token</label><input class="form-control" id="token" name="token" ng-model="vm.credentials.token" required type="password"><div ng-show="form.token.$dirty && form.token.$invalid"><p class="help-block" ng-show="form.token.$error.required">Your Token is required.</p></div></div></div></div><!-- <div class="form-group">\n                        <label class="control-label" for="password">Password</label>\n                        <input type="password" class="form-control" id="password" name="password" placeholder="Your password"\n                        ng-model="vm.credentials.password" ng-minlength=4 ng-maxlength=50 required>\n                        <div ng-show="form.password.$dirty && form.password.$invalid">\n                            <p class="help-block"\n                                ng-show="form.password.$error.required">\n                                Your password is required.\n                            </p>\n                            <p class="help-block"\n                                ng-show="form.password.$error.minlength">\n                                Your password is required to be at least 4 characters.\n                            </p>\n                            <p class="help-block"\n                                ng-show="form.password.$error.maxlength">\n                                Your password cannot be longer than 50 characters.\n                            </p>\n                        </div>\n                    </div> --> <button type="submit" ng-disabled="form.$invalid" class="btn btn-success btn-lg">Sign Document</button></form></div></div></div></div><!-- JSS-54 --><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default panel-fill"><div class="panel-body"><div ng-repeat="item in userWorkItems"><img class="doc-images doc-images-work-items" id="document-image-{{item.pageNo}}" ng-if="item.pageNo != null" ng-src="/api/accounts/{{vm.document.accountId}}/documents/{{item.documentId}}/pages/{{item.pageNo}}"><br><br></div></div></div></div></div>');
$templateCache.put('app/sign/info.html','<div class="row"><div class="col-md-8 col-md-offset-2"><h3>{{vm.document.title}}</h3><div class="alert alert-info fade in"><h4>{{vm.workItem.legalName}}, your signature is required.</h4><p>Before continuing, please review the information pertaining to the document below.</p><blockquote ng-if="vm.workItem.note"><footer>A note from the Document Originator</footer><p>{{vm.workItem.note}}</p></blockquote><p class=""><button ng-click="vm.viewDocument()" type="button" class="btn btn-primary waves-effect waves-light">VIEW Document</button></p></div></div></div><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Information</h3></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span>Reference No.</span></dt><dd><span>{{vm.document.externalSystemRef}}</span></dd><dt><span data-translate="jmrsignApp.document.description">Description</span></dt><dd><span>{{vm.document.description}}</span></dd><dt><span data-translate="jmrsignApp.document.createDate">Create Date</span></dt><dd><span>{{vm.document.createDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.document.expireDate">Expire Date</span></dt><dd><span>{{vm.document.expireDate | date:\'medium\'}}</span></dd></dl></div></div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Signatories</h3></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Person</span></th><th><span>Status</span></th></tr></thead><tbody><tr ng-repeat="wi in vm.documentWorkitems | filter: { type: \'SIGNER\' }"><td>{{$index+1}}</td><td><span ng-if="wi.partyId">{{wi.legalName}} ({{wi.email}})</span></td><td>{{wi.status}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/sign/initial.html','<div class="row"><div class="col-md-8 col-md-offset-2"><h3>{{vm.document.title}}</h3><div class="alert alert-success fade in" ng-hide="vm.currentPage == 1"><p><b>Page {{vm.currentPage-1}}</b> successfully initialed.</p></div><div class="alert alert-info fade in"><h4>{{vm.workItem.legalName}},</h4><p>Please read <b>Page {{vm.currentPage}}</b> below carefully and once you are satisfied that you are fully in agreement with the page content, please initial at the bottom of the page.</p></div></div></div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title">Page: {{vm.currentPage}} of {{vm.totalItems}}</h3></div><div class="panel-body"><div ng-repeat="page in vm.documentPages"><img class="doc-images" ng-show="vm.currentPage == $index+1" id="document-image-{{$index+1}}" ng-src="/api/accounts/{{vm.document.accountId}}/documents/{{vm.document.id}}/pages/{{$index+1}}" style="max-width: 100%"></div></div></div></div></div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-info fade in"><p class="pull-right"><button type="button" ng-click="vm.rejectDocument()" class="btn btn-danger waves-effect waves-light"><span class="glyphicon glyphicon-remove-circle"></span> REJECT Page</button> <button type="button" ng-click="vm.signDocument()" class="btn btn-primary waves-effect waves-light"><span class="glyphicon glyphicon-ok-circle"></span> INITIAL Page</button></p><p>&nbsp;</p></div></div></div><div class="row"></div>');
$templateCache.put('app/sign/landing.html','<div class="row"><div class="col-md-8 col-md-offset-2"><h3>{{vm.document.title}}</h3><div ng-if="vm.invalid && vm.completed" class="alert alert-success fade in"><p><i class="fa fa-check-circle-o fa-4x pull-left"></i> This signature action has been completed, access to this process is denied.</p><p><button ui-sref="inbox" type="button" class="btn btn-success waves-effect waves-light">Back to inbox</button></p></div><div ng-if="vm.invalid && !vm.completed" class="alert alert-success fade in"><p>This signature action has been completed, access to this process is denied.</p><p><button ui-sref="inbox" type="button" class="btn btn-success waves-effect waves-light">Back to inbox</button></p></div><div ng-if="vm.wrongUser && !vm.requireLogin" class="alert alert-danger fade in"><h4>{{vm.party.displayName}}, this signature action is for another person.</h4><p>This signature action is allocated for another party, access to this process is denied.</p><p><button ui-sref="inbox" type="button" class="btn btn-danger waves-effect waves-light">Back to inbox</button></p></div><div ng-if="vm.wrongUser && vm.requireLogin" class="alert alert-warning fade in"><h4>{{vm.party.displayName}},</h4><p>Please log in to your existing account before continuing with the signing process.</p><p><button ng-click="vm.login()" type="button" class="btn btn-warning waves-effect waves-light">Login</button></p></div><div ng-if="!vm.wrongUser && vm.requireLogin" class="alert alert-warning fade in"><h4>{{vm.party.displayName}},</h4><p>Please log in to your existing account before continuing with the signing process.</p><p><button ng-click="vm.viewDocument()" type="button" class="btn btn-warning waves-effect waves-light">Login</button></p></div></div></div>');
$templateCache.put('app/sign/view.html','<div class="row"><div class="col-md-8 col-md-offset-2"><h3>{{vm.document.title}}</h3><div class="alert alert-info fade in"><h4>{{vm.workItem.legalName}},</h4><p>Please read the document below carefully and once you are happy with the content please proceed to the signing process.</p><p class=""><button type="button" ng-click="vm.signDocument()" class="btn btn-primary waves-effect waves-light"><span class="glyphicon glyphicon-ok-circle"></span> ACCEPT Document</button> <button type="button" ng-click="vm.rejectDocument()" class="btn btn-danger waves-effect waves-light"><span class="glyphicon glyphicon-remove-circle"></span> REJECT Document</button> <a ng-href="/api/accounts/{{vm.document.accountId}}/documents/{{vm.document.id}}/pdf/original" type="button" class="btn btn-default dropdown-toggle waves-effect waves-light"><span class="glyphicon glyphicon-download"></span> <span>Download Unsigned Copy</span></a></p></div></div></div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title">Page: {{currentPage}} of {{totalItems}}</h3></div><div class="panel-body"><ul uib-pager items-per-page="1" total-items="totalItems" ng-model="currentPage" previous-text="\xAB Previous Page" next-text="Next Page \xBB" ng-init="renderSignatures()" ng-change="renderSignatures()"></ul><div ng-repeat="page in vm.documentPages"><img class="doc-images" ng-show="currentPage == $index+1" id="document-image-{{$index+1}}" ng-src="/api/accounts/{{vm.document.accountId}}/documents/{{vm.document.id}}/pages/{{$index+1}}" style="max-width: 100%"></div></div></div></div></div><div class="row"></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" data-translate="metrics.ehcache.objects">Objects</th><th class="text-right" data-translate="metrics.ehcache.hits">Hits</th><th class="text-right" data-translate="metrics.ehcache.misses">Misses</th><th class="text-right" data-translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" data-translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/party/parties.html','<div><h2 data-translate="jmrsignApp.party.home.title">Parties</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="party.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.party.home.createLabel">Create new Party</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.party.email">Email</span></th><th><span data-translate="jmrsignApp.party.firstName">First Name</span></th><th><span data-translate="jmrsignApp.party.lastName">Last Name</span></th><th><span data-translate="jmrsignApp.party.cellNumber">Cell Number</span></th><th><span data-translate="jmrsignApp.party.signature">Signature</span></th><th><span data-translate="jmrsignApp.party.initial">Initial</span></th><th><span data-translate="jmrsignApp.party.user">User</span></th><th><span data-translate="jmrsignApp.party.account">Account</span></th><th></th></tr></thead><tbody><tr ng-repeat="party in vm.parties track by party.id"><td><a ui-sref="party-detail({id:party.id})">{{party.id}}</a></td><td>{{party.email}}</td><td>{{party.firstName}}</td><td>{{party.lastName}}</td><td>{{party.cellNumber}}</td><td><a ng-if="party.signature" ng-click="vm.openFile(party.signatureContentType, party.signature)" data-translate="entity.action.open">open</a> <span ng-if="party.signature">{{party.signatureContentType}}, {{vm.byteSize(party.signature)}}</span></td><td><a ng-if="party.initial" ng-click="vm.openFile(party.initialContentType, party.initial)" data-translate="entity.action.open">open</a> <span ng-if="party.initial">{{party.initialContentType}}, {{vm.byteSize(party.initial)}}</span></td><td>{{party.userId}}</td><td><a ui-sref="app-account-detail({id:party.accountId})">{{party.accountId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="party-detail({id:party.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="party.edit({id:party.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="party.delete({id:party.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/party/party-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.party.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.party.delete.question" translate-values="{id: \'{{vm.party.id}}\'}">Are you sure you want to delete this Party?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/account/party/party-detail.html','<div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-border panel-primary"><div class="panel-heading"><h3 class="panel-title">Signature details for account eezi-Sign</h3></div><div class="panel-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.party.email">Email</span></dt><dd><span>{{vm.party.email}}</span></dd><dt><span data-translate="jmrsignApp.party.firstName">First Name</span></dt><dd><span>{{vm.party.firstName}}</span></dd><dt><span data-translate="jmrsignApp.party.lastName">Last Name</span></dt><dd><span>{{vm.party.lastName}}</span></dd><dt><span data-translate="jmrsignApp.party.cellNumber">Cell Number</span></dt><dd><span>{{vm.party.cellNumber}}</span></dd><dt><span data-translate="jmrsignApp.party.signatureImg">Signature Img</span></dt><dd><div ng-if="vm.party.signatureImg"><a ng-click="vm.openFile(vm.party.signatureImgContentType, vm.party.signatureImg)"><img data-ng-src="{{\'data:\' + vm.party.signatureImgContentType + \';base64,\' + vm.party.signatureImg}}" style="max-width: 100%"> </a>{{vm.party.signatureImgContentType}}, {{vm.byteSize(vm.party.signatureImg)}}</div></dd><dt><span data-translate="jmrsignApp.party.initialImg">Initial Img</span></dt><dd><div ng-if="vm.party.initialImg"><a ng-click="vm.openFile(vm.party.initialImgContentType, vm.party.initialImg)"><img data-ng-src="{{\'data:\' + vm.party.initialImgContentType + \';base64,\' + vm.party.initialImg}}" style="max-width: 100%"> </a>{{vm.party.initialImgContentType}}, {{vm.byteSize(vm.party.initialImg)}}</div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="my-party.edit({id:vm.party.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div></div></div><!-- <div class="col-md-2">\n        <div class="panel panel-border panel-info">\n            <div class="panel-heading">\n                <h3 class="panel-title"><i class="fa fa-info-circle"></i> Information</h3>\n            </div>\n            <div class="panel-body">\n                <p>Why do I have seperate user details and signature details? Elaborate... </p>\n            </div>\n        </div>\n    </div> --></div>');
$templateCache.put('app/account/party/party-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPartyLabel" data-translate="jmrsignApp.party.home.createOrEditLabel">Create or edit a Party</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.email" for="field_email">Email</label><input readonly="readonly" type="text" class="form-control" name="email" id="field_email" ng-model="vm.party.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.party.firstName" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.party.lastName" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.cellNumber" for="field_cellNumber">Cell Number</label><input type="tel" class="form-control" id="field_cellNumber" name="CellNumber" ng-model="vm.party.cellNumber"></div><div class="form-group" ngf-drop ngf-change="vm.setSignatureImg($file, vm.party)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.party.signatureImg" for="field_signatureImg">Signature Img</label><div><div class="cropArea pull-left" ng-if="vm.uncroppedSignatureImg" title="Drag and crop to select signature"><ui-cropper image="vm.uncroppedSignatureImg" canvas-scalemode="full-width" area-type="rectangle" aspect-ratio="3.5" result-image="vm.party.signatureImg" result-image-size="{w: 350,h: 100}" init-max-area="true"></ui-cropper></div><div ng-if="vm.party.signatureImg" class="help-block clearfix"><button type="button" ng-click="vm.party.signatureImg=null;vm.party.signatureImgContentType=null;vm.uncroppedSignatureImg=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button><div ng-if="vm.party.signatureImg"><img ng-src="{{vm.party.signatureImg}}" style="max-height: 200px" ng-if="vm.uncroppedSignatureImg"> <img data-ng-src="{{\'data:\' + vm.party.signatureImgContentType + \';base64,\' + vm.party.signatureImg}}" style="max-height: 100px" ng-if="!vm.uncroppedSignatureImg"></div><span class="pull-left">{{vm.party.signatureImgContentType}}, {{vm.byteSize(vm.party.signatureImg)}}</span></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignatureImg($file, vm.party)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="signatureImg" id="field_signatureImg" ng-model="vm.party.signatureImg"> <input type="hidden" class="form-control" name="signatureImgContentType" id="field_signatureImgContentType" ng-model="vm.party.signatureImgContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setInitialImg($file, vm.party)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.party.initialImg" for="field_initialImg">Initial Img</label><div><div class="cropArea pull-left" ng-if="vm.uncroppedInitialImg" title="Drag and crop to select signature"><ui-cropper image="vm.uncroppedInitialImg" canvas-scalemode="full-width" area-type="rectangle" aspect-ratio="1.0" result-image="vm.party.initialImg" result-image-size="{w: 50,h: 50}" init-max-area="true"></ui-cropper></div><div ng-if="vm.party.initialImg" class="help-block clearfix"><button type="button" ng-click="vm.party.initialImg=null;vm.party.initialImgContentType=null;vm.uncroppedInitialImg=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button><div ng-if="vm.party.initialImg"><img ng-src="{{vm.party.initialImg}}" style="max-height: 200px" ng-if="vm.uncroppedInitialImg"> <img data-ng-src="{{\'data:\' + vm.party.initialImgContentType + \';base64,\' + vm.party.initialImg}}" style="max-height: 100px" ng-if="!vm.uncroppedInitialImg"></div><span class="pull-left">{{vm.party.initialImgContentType}}, {{vm.byteSize(vm.party.initialImg)}}</span></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setInitialImg($file, vm.party)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="initialImg" id="field_initialImg" ng-model="vm.party.initialImg"> <input type="hidden" class="form-control" name="initialImgContentType" id="field_initialImgContentType" ng-model="vm.party.initialImgContentType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/account/password/password.html','<div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-border panel-primary"><div class="panel-heading"><h3 class="panel-title" data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h3></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="col-md-8 col-md-offset-2"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title" data-translate="register.title">Registration</h3></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation autocomplete="off"><!-- <div class="form-group">\n                        <label class="control-label" for="login" data-translate="global.form.username">Username</label>\n                        <input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}"\n                        ng-model="vm.registerAccount.login" ng-minlength=1 ng-maxlength=50 ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required>\n                        <div ng-show="form.login.$dirty && form.login.$invalid">\n                            <p class="help-block"\n                                ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">\n                                Your username is required.\n                            </p>\n                            <p class="help-block"\n                                ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">\n                                Your username is required to be at least 1 character.\n                            </p>\n                            <p class="help-block"\n                                ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">\n                                Your username cannot be longer than 50 characters.\n                            </p>\n                            <p class="help-block"\n                                ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">\n                                Your username can only contain lower-case letters and digits.\n                            </p>\n                        </div>\n                    </div> --><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.registerAccount.firstName" autocomplete="off" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.registerAccount.lastName" autocomplete="off" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.cellNumber" for="field_cellNumber">Cell Number</label><input ng-intl-tel-input type="text" class="form-control" name="cellNumber" id="field_cellNumber" ng-model="vm.registerAccount.cellNumber" autocomplete="off"></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" autocomplete="off" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" autocomplete="off" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><br><!-- <jh-social ng-provider="google"></jh-social>\n            <jh-social ng-provider="facebook"></jh-social>\n            <jh-social ng-provider="twitter"></jh-social> --><!-- jhipster-needle-add-social-button --></div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-border panel-primary"><div class="panel-heading"><h3 class="panel-title" data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h3></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title" data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h3></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input readonly="readonly" type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div></div>');
$templateCache.put('app/account/social/social-register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 ng-show="success" data-translate="social.register.title" translate-values="{ label: vm.providerLabel }">Registration with</h1><h1 ng-show="error" data-translate="social.register.errorTitle">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="social.register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="social.register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><jh-social ng-if="vm.success" ng-provider="{{ vm.provider }}"></jh-social><br><div class="alert alert-warning" data-translate="global.messages.info.authenticated">If you want to <a class="alert-link" href="#/login">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/app-account/party-management/party-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.party.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.party.delete.question" translate-values="{id: \'{{vm.party.id}}\'}">Are you sure you want to delete this Party?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/app-account/party-management/party-management-detail.html','<div><h2><span data-translate="jmrsignApp.party.detail.title">Party</span> {{vm.party.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.party.internalSystemRef">Internal System Ref</span></dt><dd><span>{{vm.party.internalSystemRef}}</span></dd><dt><span data-translate="jmrsignApp.party.email">Email</span></dt><dd><span>{{vm.party.email}}</span></dd><dt><span data-translate="jmrsignApp.party.firstName">First Name</span></dt><dd><span>{{vm.party.firstName}}</span></dd><dt><span data-translate="jmrsignApp.party.lastName">Last Name</span></dt><dd><span>{{vm.party.lastName}}</span></dd><dt><span data-translate="jmrsignApp.party.cellNumber">Cell Number</span></dt><dd><span>{{vm.party.cellNumber}}</span></dd><dt><span data-translate="jmrsignApp.party.newCellNumber">New Cell Number</span></dt><dd><span>{{vm.party.newCellNumber}}</span></dd><dt><span data-translate="jmrsignApp.party.validationCode">Validation Code</span></dt><dd><span>{{vm.party.validationCode}}</span></dd><dt><span data-translate="jmrsignApp.party.signature">Signature</span></dt><dd><div ng-if="vm.party.signature"><a ng-click="vm.openFile(vm.party.signatureContentType, vm.party.signature)" data-translate="entity.action.open">open</a> {{vm.party.signatureContentType}}, {{vm.byteSize(vm.party.signature)}}</div></dd><dt><span data-translate="jmrsignApp.party.signatureImg">Signature Img</span></dt><dd><div ng-if="vm.party.signatureImg"><a ng-click="vm.openFile(vm.party.signatureImgContentType, vm.party.signatureImg)"><img data-ng-src="{{\'data:\' + vm.party.signatureImgContentType + \';base64,\' + vm.party.signatureImg}}" style="max-width: 100%"> </a>{{vm.party.signatureImgContentType}}, {{vm.byteSize(vm.party.signatureImg)}}</div></dd><dt><span data-translate="jmrsignApp.party.initialImg">Initial Img</span></dt><dd><div ng-if="vm.party.initialImg"><a ng-click="vm.openFile(vm.party.initialImgContentType, vm.party.initialImg)"><img data-ng-src="{{\'data:\' + vm.party.initialImgContentType + \';base64,\' + vm.party.initialImg}}" style="max-width: 100%"> </a>{{vm.party.initialImgContentType}}, {{vm.byteSize(vm.party.initialImg)}}</div></dd><dt><span data-translate="jmrsignApp.party.allowUserUpdate">Allow User Update</span></dt><dd><span>{{vm.party.allowUserUpdate}}</span></dd><dt><span data-translate="jmrsignApp.party.type">Type</span></dt><dd><span data-translate="{{\'jmrsignApp.PartyType.\' + vm.party.type}}">{{vm.party.type}}</span></dd><dt><span data-translate="jmrsignApp.party.user">User</span></dt><dd>{{vm.party.userId}}</dd><dt><span data-translate="jmrsignApp.party.account">Account</span></dt><dd><a ui-sref="app-account-detail({id:vm.party.accountId})">{{vm.party.accountId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="party-management-detail.edit({id:vm.party.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/app-account/party-management/party-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPartyLabel" data-translate="jmrsignApp.party.home.createOrEditLabel">Create or edit a Party</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.internalSystemRef" for="field_internalSystemRef">Internal System Ref</label><input type="text" class="form-control" name="internalSystemRef" id="field_internalSystemRef" ng-model="vm.party.internalSystemRef" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.party.email" required ng-readonly="vm.party.id"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">This e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.party.firstName" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.party.lastName" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.cellNumber" for="field_cellNumber">Cell Number</label><input ng-intl-tel-input type="text" class="form-control" name="cellNumber" id="field_cellNumber" ng-model="vm.party.cellNumber" onfocus="this.value=\'\'"></div><!-- <div class="form-group">\n            <label class="control-label" data-translate="jmrsignApp.party.newCellNumber" for="field_newCellNumber">New Cell Number</label>\n            <input ng-intl-tel-input data-initial-country="za" type="text" class="form-control" name="newCellNumber" id="field_newCellNumber"\n                    ng-model="vm.party.newCellNumber"\n                     />\n        </div> --><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.allowUserUpdate" for="field_allowUserUpdate">Allow User Update</label><input type="checkbox" class="form-control" name="allowUserUpdate" id="field_allowUserUpdate" ng-model="vm.party.allowUserUpdate"><div ng-show="editForm.allowUserUpdate.$invalid"><p class="help-block" ng-show="editForm.allowUserUpdate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.party.id == null"><label class="control-label" for="field_createUser">Send Account Activation Email</label><input type="checkbox" class="form-control" name="createUser" id="field_createUser" ng-model="vm.party.createUser"><div ng-show="editForm.createUser.$invalid"><p class="help-block" ng-show="editForm.createUser.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.party.type" id="field_type" required><option value="EXTERNAL_USER" data-translate="jmrsignApp.PartyType.EXTERNAL_USER">EXTERNAL_USER</option><option value="INTERNAL_USER" data-translate="jmrsignApp.PartyType.INTERNAL_USER">INTERNAL_USER</option><option value="ACCOUNT_USER" data-translate="jmrsignApp.PartyType.ACCOUNT_USER">ACCOUNT_USER</option><option value="ADMIN" data-translate="jmrsignApp.PartyType.ADMIN">ADMIN</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.party.status" id="field_status" required><option value="RESTRICTED" data-translate="jmrsignApp.PartyStatus.RESTRICTED">RESTRICTED</option><option value="ENABLED" data-translate="jmrsignApp.PartyStatus.ENABLED">ENABLED</option><option value="DISABLED" data-translate="jmrsignApp.PartyStatus.DISABLED">DISABLED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/app-account/party-management/party-management-upload-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentLabel">Upload Party File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group">\n            <label class="control-label" data-translate="jmrsignApp.document.externalSystemRef" for="field_externalSystemRef">External System Ref</label>\n            <input type="text" class="form-control" name="externalSystemRef" id="field_externalSystemRef"\n                    ng-model="vm.document.externalSystemRef"\n                    required />\n            <div ng-show="editForm.externalSystemRef.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.externalSystemRef.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div> --><div class="form-group" ngf-drop ngf-change="vm.setData($file, vm.document)"><label class="control-label" for="field_data">Data</label><div><div ng-if="vm.document.data" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.document.dataContentType, vm.document.data)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.document.dataContentType}}, {{vm.byteSize(vm.document.data)}}</span> <button type="button" ng-click="vm.document.data=null;vm.document.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setData($file, vm.document)">Add PDF Document</button></div><input type="hidden" class="form-control" name="data" id="field_data" ng-model="vm.document.data" required> <input type="hidden" class="form-control" name="dataContentType" id="field_dataContentType" ng-model="vm.document.dataContentType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/app-account/party-management/party-management.html','<div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="panel panel-border panel-primary"><div class="panel-heading"><div class="panel-body"><div class="btn-toolbar"><div class="btn-group pull-right"><button class="btn btn-danger" ui-sref="party-management.upload"><span class="glyphicon glyphicon-cog"></span> <span>Bulk Import</span></button> <button class="btn btn-primary" ui-sref="party-management.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.party.home.createLabel">Create new Party</span></button></div><div class="btn-group pull-right"><input ng-model="vm.searchText" id="search" class="form-control" placeholder="Search for Party" ng-change="vm.search()" ng-minlength="3"></div></div><h3 class="panel-title">User Management</h3></div></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="jmrsignApp.party.email">Email</span></th><th><span data-translate="jmrsignApp.party.firstName">First Name</span></th><th><span data-translate="jmrsignApp.party.lastName">Last Name</span></th><th><span data-translate="jmrsignApp.party.cellNumber">Cell Number</span></th><th><span data-translate="jmrsignApp.party.allowUserUpdate">Allow User Update</span></th><th><span data-translate="jmrsignApp.party.type">Type</span></th><th><span data-translate="jmrsignApp.party.status">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="party in vm.parties track by party.id"><td>{{party.email}}</td><td>{{party.firstName}}</td><td>{{party.lastName}}</td><td>{{party.cellNumber}}</td><td>{{party.allowUserUpdate}}</td><td data-translate="{{\'jmrsignApp.PartyType.\' + party.type}}">{{party.type}}</td><td data-translate="{{\'jmrsignApp.PartyStatus.\' + party.status}}">{{party.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!-- <button type="submit"\n                                        ui-sref="party-management-detail({id:party.id})"\n                                        class="btn btn-info btn-sm">\n                                        <span class="glyphicon glyphicon-eye-open"></span>\n                                        <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span>\n                                        </button> --> <button type="submit" ui-sref="party-management.edit({id:party.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="party-management.delete({id:party.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div style="width: 300px; margin: 0 auto"><uib-pagination style="width:300px; margin:0 auto" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination><!--  <pre>You are currently on page {{vm.page}}</pre> --></div></div></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-12"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.email">Email</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary btn-block" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div can-register="true" class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div><!--<div class="col-md-6"> \n\n            \n             <br/>\n            <jh-social ng-provider="google"></jh-social>\n            <jh-social ng-provider="facebook"></jh-social>\n            <jh-social ng-provider="twitter"></jh-social> --><!-- jhipster-needle-add-social-button --><!-- </div> --></div></div>');
$templateCache.put('app/components/party/party-new.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="myPartyLabel" data-translate="jmrsignApp.party.home.createOrEditLabel">Create or edit a Party</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.party.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">This e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.party.firstName" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.party.lastName" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.cellNumber" for="field_cellNumber">Cell Number</label><input ng-intl-tel-input data-initial-country="za" type="text" class="form-control" name="cellNumber" id="field_cellNumber" ng-model="vm.party.cellNumber" onfocus="this.value=\'\'"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.party.type" id="field_type" required><option value="EXTERNAL_USER" data-translate="jmrsignApp.PartyType.EXTERNAL_USER">EXTERNAL_USER</option><option value="INTERNAL_USER" data-translate="jmrsignApp.PartyType.INTERNAL_USER">INTERNAL_USER</option><option value="ACCOUNT_USER" data-translate="jmrsignApp.PartyType.ACCOUNT_USER">ACCOUNT_USER</option><!-- <option value="ADMIN" data-translate="jmrsignApp.PartyType.ADMIN">ADMIN</option> --></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/components/party/party-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Search for Party</h4></div><div class="modal-body"><div class="row"><div class="alert alert-info fade in"><i class="fa fa-info fa-2x pull-left"></i><p>For registered parties, you may enter Name, Surname, Email, Cell number (or any combination thereof), If the party is not previously captured, you will need at least the email, cell number, first and last name, the system will request and attempt to verify that the email address and cell number, belongs to the requested party.</p></div><div class="col-md-12"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="field_party">Party</label><input id="field_party" type="text" ng-model="vm.party" placeholder="FirstName, Lastname, Email, CellNumber" uib-typeahead="party as party.displayName for party in vm.getAllPartiesSearch($viewValue)" typeahead-loading="loadingParties" typeahead-no-results="vm.noResults" typeahead-min-length="3" class="form-control"> <i ng-show="loadingParties" class="glyphicon glyphicon-refresh"></i><div ng-show="vm.noResults"><i class="glyphicon glyphicon-remove"></i> No Results Found</div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.type" id="field_type" required><option value="EDITOR" data-translate="jmrsignApp.WorkItemType.EDITOR">EDITOR</option><option value="SIGNER" data-translate="jmrsignApp.WorkItemType.SIGNER">SIGNER</option><option value="CARBON_COPY" data-translate="jmrsignApp.WorkItemType.CARBON_COPY">CARBON_COPY</option><option value="SIGNED_COPY" data-translate="jmrsignApp.WorkItemType.SIGNED_COPY">SIGNED_COPY</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-12" ng-if="vm.noResults"><br><div class="alert alert-warning fade in"><i class="fa fa-warning fa-2x pull-left"></i><p>No party found using the information supplied above. Would you like to create a new party?</p><button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.newParty()">Create new party</button></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.selectCurrent()"><span class="glyphicon glyphicon-user"></span>&nbsp;<span>Me</span></button> <button type="button" ng-click="vm.select()" ng-disabled="vm.party === undefined || vm.party === null" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Select</span></button></div>');
$templateCache.put('app/entities/document/document-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.document.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.document.delete.question" translate-values="{id: \'{{vm.document.id}}\'}">Are you sure you want to delete this Document?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/document/document-detail.html','<div><h2><span data-translate="jmrsignApp.document.detail.title">Document</span> {{vm.document.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.document.internalSystemRef">Internal System Ref</span></dt><dd><span>{{vm.document.internalSystemRef}}</span></dd><dt><span data-translate="jmrsignApp.document.externalSystemRef">External System Ref</span></dt><dd><span>{{vm.document.externalSystemRef}}</span></dd><dt><span data-translate="jmrsignApp.document.previewImg">Preview Img</span></dt><dd><div ng-if="vm.document.previewImg"><a ng-click="vm.openFile(vm.document.previewImgContentType, vm.document.previewImg)"><img data-ng-src="{{\'data:\' + vm.document.previewImgContentType + \';base64,\' + vm.document.previewImg}}" style="max-width: 100%"> </a>{{vm.document.previewImgContentType}}, {{vm.byteSize(vm.document.previewImg)}}</div></dd><dt><span data-translate="jmrsignApp.document.fileRef">File Ref</span></dt><dd><span>{{vm.document.fileRef}}</span></dd><dt><span data-translate="jmrsignApp.document.data">Data</span></dt><dd><div ng-if="vm.document.data"><a ng-click="vm.openFile(vm.document.dataContentType, vm.document.data)" data-translate="entity.action.open">open</a> {{vm.document.dataContentType}}, {{vm.byteSize(vm.document.data)}}</div></dd><dt><span data-translate="jmrsignApp.document.dataComplete">Data Complete</span></dt><dd><div ng-if="vm.document.dataComplete"><a ng-click="vm.openFile(vm.document.dataCompleteContentType, vm.document.dataComplete)" data-translate="entity.action.open">open</a> {{vm.document.dataCompleteContentType}}, {{vm.byteSize(vm.document.dataComplete)}}</div></dd><dt><span data-translate="jmrsignApp.document.dataAudit">Data Audit</span></dt><dd><div ng-if="vm.document.dataAudit"><a ng-click="vm.openFile(vm.document.dataAuditContentType, vm.document.dataAudit)" data-translate="entity.action.open">open</a> {{vm.document.dataAuditContentType}}, {{vm.byteSize(vm.document.dataAudit)}}</div></dd><dt><span data-translate="jmrsignApp.document.createDate">Create Date</span></dt><dd><span>{{vm.document.createDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.document.expireDate">Expire Date</span></dt><dd><span>{{vm.document.expireDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.document.title">Title</span></dt><dd><span>{{vm.document.title}}</span></dd><dt><span data-translate="jmrsignApp.document.description">Description</span></dt><dd><span>{{vm.document.description}}</span></dd><dt><span data-translate="jmrsignApp.document.digitallySigned">Digitally Signed</span></dt><dd><span>{{vm.document.digitallySigned}}</span></dd><dt><span data-translate="jmrsignApp.document.barcoded">Barcoded</span></dt><dd><span>{{vm.document.barcoded}}</span></dd><dt><span data-translate="jmrsignApp.document.currentVersionNo">Current Version No</span></dt><dd><span>{{vm.document.currentVersionNo}}</span></dd><dt><span data-translate="jmrsignApp.document.status">Status</span></dt><dd><span data-translate="{{\'jmrsignApp.DocumentStatus.\' + vm.document.status}}">{{vm.document.status}}</span></dd><dt><span data-translate="jmrsignApp.document.currentVersion">Current Version</span></dt><dd><a ui-sref="document-version-detail({id:vm.document.currentVersionId})">{{vm.document.currentVersionId}}</a></dd><dt><span data-translate="jmrsignApp.document.account">Account</span></dt><dd><a ui-sref="app-account-detail({id:vm.document.accountId})">{{vm.document.accountId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="document-detail.edit({id:vm.document.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/document/document-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentLabel" data-translate="jmrsignApp.document.home.createOrEditLabel">Create or edit a Document</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.document.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.document.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.internalSystemRef" for="field_internalSystemRef">Internal System Ref</label><input type="text" class="form-control" name="internalSystemRef" id="field_internalSystemRef" ng-model="vm.document.internalSystemRef" required><div ng-show="editForm.internalSystemRef.$invalid"><p class="help-block" ng-show="editForm.internalSystemRef.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.externalSystemRef" for="field_externalSystemRef">External System Ref</label><input type="text" class="form-control" name="externalSystemRef" id="field_externalSystemRef" ng-model="vm.document.externalSystemRef" required><div ng-show="editForm.externalSystemRef.$invalid"><p class="help-block" ng-show="editForm.externalSystemRef.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setPreviewImg($file, vm.document)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.document.previewImg" for="field_previewImg">Preview Img</label><div><img data-ng-src="{{\'data:\' + vm.document.previewImgContentType + \';base64,\' + vm.document.previewImg}}" style="max-height: 100px" ng-if="vm.document.previewImg"><div ng-if="vm.document.previewImg" class="help-block clearfix"><span class="pull-left">{{vm.document.previewImgContentType}}, {{vm.byteSize(vm.document.previewImg)}}</span> <button type="button" ng-click="vm.document.previewImg=null;vm.document.previewImgContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPreviewImg($file, vm.document)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="previewImg" id="field_previewImg" ng-model="vm.document.previewImg"> <input type="hidden" class="form-control" name="previewImgContentType" id="field_previewImgContentType" ng-model="vm.document.previewImgContentType"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.fileRef" for="field_fileRef">File Ref</label><input type="text" class="form-control" name="fileRef" id="field_fileRef" ng-model="vm.document.fileRef"></div><div class="form-group" ngf-drop ngf-change="vm.setData($file, vm.document)"><label class="control-label" data-translate="jmrsignApp.document.data" for="field_data">Data</label><div><div ng-if="vm.document.data" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.document.dataContentType, vm.document.data)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.document.dataContentType}}, {{vm.byteSize(vm.document.data)}}</span> <button type="button" ng-click="vm.document.data=null;vm.document.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setData($file, vm.document)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="data" id="field_data" ng-model="vm.document.data"> <input type="hidden" class="form-control" name="dataContentType" id="field_dataContentType" ng-model="vm.document.dataContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setDataComplete($file, vm.document)"><label class="control-label" data-translate="jmrsignApp.document.dataComplete" for="field_dataComplete">Data Complete</label><div><div ng-if="vm.document.dataComplete" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.document.dataCompleteContentType, vm.document.dataComplete)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.document.dataCompleteContentType}}, {{vm.byteSize(vm.document.dataComplete)}}</span> <button type="button" ng-click="vm.document.dataComplete=null;vm.document.dataCompleteContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setDataComplete($file, vm.document)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="dataComplete" id="field_dataComplete" ng-model="vm.document.dataComplete"> <input type="hidden" class="form-control" name="dataCompleteContentType" id="field_dataCompleteContentType" ng-model="vm.document.dataCompleteContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setDataAudit($file, vm.document)"><label class="control-label" data-translate="jmrsignApp.document.dataAudit" for="field_dataAudit">Data Audit</label><div><div ng-if="vm.document.dataAudit" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.document.dataAuditContentType, vm.document.dataAudit)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.document.dataAuditContentType}}, {{vm.byteSize(vm.document.dataAudit)}}</span> <button type="button" ng-click="vm.document.dataAudit=null;vm.document.dataAuditContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setDataAudit($file, vm.document)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="dataAudit" id="field_dataAudit" ng-model="vm.document.dataAudit"> <input type="hidden" class="form-control" name="dataAuditContentType" id="field_dataAuditContentType" ng-model="vm.document.dataAuditContentType"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.createDate" for="field_createDate">Create Date</label><div class="input-group"><input id="field_createDate" type="text" class="form-control" name="createDate" datetime-picker="{{dateformat}}" ng-model="vm.document.createDate" is-open="vm.datePickerOpenStatus.createDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.createDate.$invalid"><p class="help-block" ng-show="editForm.createDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.createDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.expireDate" for="field_expireDate">Expire Date</label><div class="input-group"><input id="field_expireDate" type="text" class="form-control" name="expireDate" datetime-picker="{{dateformat}}" ng-model="vm.document.expireDate" is-open="vm.datePickerOpenStatus.expireDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expireDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.document.title"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.document.description"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.digitallySigned" for="field_digitallySigned">Digitally Signed</label><input type="checkbox" class="form-control" name="digitallySigned" id="field_digitallySigned" ng-model="vm.document.digitallySigned"><div ng-show="editForm.digitallySigned.$invalid"><p class="help-block" ng-show="editForm.digitallySigned.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.barcoded" for="field_barcoded">Barcoded</label><input type="checkbox" class="form-control" name="barcoded" id="field_barcoded" ng-model="vm.document.barcoded"><div ng-show="editForm.barcoded.$invalid"><p class="help-block" ng-show="editForm.barcoded.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.currentVersionNo" for="field_currentVersionNo">Current Version No</label><input type="number" class="form-control" name="currentVersionNo" id="field_currentVersionNo" ng-model="vm.document.currentVersionNo"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.document.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.document.status" id="field_status" required><option value="DRAFT" data-translate="jmrsignApp.DocumentStatus.DRAFT">DRAFT</option><option value="IN_PROGRESS" data-translate="jmrsignApp.DocumentStatus.IN_PROGRESS">IN_PROGRESS</option><option value="REJECTED" data-translate="jmrsignApp.DocumentStatus.REJECTED">REJECTED</option><option value="COMPLETED" data-translate="jmrsignApp.DocumentStatus.COMPLETED">COMPLETED</option><option value="TRASH" data-translate="jmrsignApp.DocumentStatus.TRASH">TRASH</option><option value="FAILED" data-translate="jmrsignApp.DocumentStatus.FAILED">FAILED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="jmrsignApp.document.currentVersion" for="field_currentVersion">Current Version</label><select class="form-control" id="field_currentVersion" name="currentVersion" ng-model="vm.document.currentVersionId" ng-options="documentVersion.id as documentVersion.id for documentVersion in vm.currentversions | orderBy:\'id\'"><option value=""></option></select></div><div class="form-group"><label data-translate="jmrsignApp.document.account" for="field_account">Account</label><select class="form-control" id="field_account" name="account" ng-model="vm.document.accountId" ng-options="appAccount.id as appAccount.id for appAccount in vm.appaccounts"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/document/documents.html','<div><h2 data-translate="jmrsignApp.document.home.title">Documents</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="document.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.document.home.createLabel">Create new Document</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.document.internalSystemRef">Internal System Ref</span></th><th><span data-translate="jmrsignApp.document.externalSystemRef">External System Ref</span></th><th><span data-translate="jmrsignApp.document.previewImg">Preview Img</span></th><th><span data-translate="jmrsignApp.document.fileRef">File Ref</span></th><th><span data-translate="jmrsignApp.document.data">Data</span></th><th><span data-translate="jmrsignApp.document.dataComplete">Data Complete</span></th><th><span data-translate="jmrsignApp.document.dataAudit">Data Audit</span></th><th><span data-translate="jmrsignApp.document.createDate">Create Date</span></th><th><span data-translate="jmrsignApp.document.expireDate">Expire Date</span></th><th><span data-translate="jmrsignApp.document.title">Title</span></th><th><span data-translate="jmrsignApp.document.description">Description</span></th><th><span data-translate="jmrsignApp.document.digitallySigned">Digitally Signed</span></th><th><span data-translate="jmrsignApp.document.barcoded">Barcoded</span></th><th><span data-translate="jmrsignApp.document.currentVersionNo">Current Version No</span></th><th><span data-translate="jmrsignApp.document.status">Status</span></th><th><span data-translate="jmrsignApp.document.currentVersion">Current Version</span></th><th><span data-translate="jmrsignApp.document.account">Account</span></th><th></th></tr></thead><tbody><tr ng-repeat="document in vm.documents track by document.id"><td><a ui-sref="document-detail({id:document.id})">{{document.id}}</a></td><td>{{document.internalSystemRef}}</td><td>{{document.externalSystemRef}}</td><td><a ng-if="document.previewImg" ng-click="vm.openFile(document.previewImgContentType, document.previewImg)"><img data-ng-src="{{\'data:\' + document.previewImgContentType + \';base64,\' + document.previewImg}}" style="max-height: 30px"> </a><span ng-if="document.previewImg">{{document.previewImgContentType}}, {{vm.byteSize(document.previewImg)}}</span></td><td>{{document.fileRef}}</td><td><a ng-if="document.data" ng-click="vm.openFile(document.dataContentType, document.data)" data-translate="entity.action.open">open</a> <span ng-if="document.data">{{document.dataContentType}}, {{vm.byteSize(document.data)}}</span></td><td><a ng-if="document.dataComplete" ng-click="vm.openFile(document.dataCompleteContentType, document.dataComplete)" data-translate="entity.action.open">open</a> <span ng-if="document.dataComplete">{{document.dataCompleteContentType}}, {{vm.byteSize(document.dataComplete)}}</span></td><td><a ng-if="document.dataAudit" ng-click="vm.openFile(document.dataAuditContentType, document.dataAudit)" data-translate="entity.action.open">open</a> <span ng-if="document.dataAudit">{{document.dataAuditContentType}}, {{vm.byteSize(document.dataAudit)}}</span></td><td>{{document.createDate | date:\'medium\'}}</td><td>{{document.expireDate | date:\'medium\'}}</td><td>{{document.title}}</td><td>{{document.description}}</td><td>{{document.digitallySigned}}</td><td>{{document.barcoded}}</td><td>{{document.currentVersionNo}}</td><td data-translate="{{\'jmrsignApp.DocumentStatus.\' + document.status}}">{{document.status}}</td><td><a ui-sref="document-version-detail({id:document.currentVersionId})">{{document.currentVersionId}}</a></td><td><a ui-sref="app-account-detail({id:document.accountId})">{{document.accountId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="document-detail({id:document.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="document.edit({id:document.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="document.delete({id:document.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/app-account/app-account-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.appAccount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.appAccount.delete.question" translate-values="{id: \'{{vm.appAccount.id}}\'}">Are you sure you want to delete this App Account?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/app-account/app-account-detail.html','<div><h2><span data-translate="jmrsignApp.appAccount.detail.title">App Account</span> {{vm.appAccount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.appAccount.title">Title</span></dt><dd><span>{{vm.appAccount.title}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.domain">Domain</span></dt><dd><span>{{vm.appAccount.domain}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.allowUserRegistration">Allow User Registration</span></dt><dd><span>{{vm.appAccount.allowUserRegistration}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.allowDigitalSig">Allow Digital Sig</span></dt><dd><span>{{vm.appAccount.allowDigitalSig}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.allowTwoStepAuth">Allow Two Step Auth</span></dt><dd><span>{{vm.appAccount.allowTwoStepAuth}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.logoImg">Logo Img</span></dt><dd><div ng-if="vm.appAccount.logoImg"><a ng-click="vm.openFile(vm.appAccount.logoImgContentType, vm.appAccount.logoImg)"><img data-ng-src="{{\'data:\' + vm.appAccount.logoImgContentType + \';base64,\' + vm.appAccount.logoImg}}" style="max-width: 100%"> </a>{{vm.appAccount.logoImgContentType}}, {{vm.byteSize(vm.appAccount.logoImg)}}</div></dd><dt><span data-translate="jmrsignApp.appAccount.watermarkImg">Watermark Img</span></dt><dd><div ng-if="vm.appAccount.watermarkImg"><a ng-click="vm.openFile(vm.appAccount.watermarkImgContentType, vm.appAccount.watermarkImg)"><img data-ng-src="{{\'data:\' + vm.appAccount.watermarkImgContentType + \';base64,\' + vm.appAccount.watermarkImg}}" style="max-width: 100%"> </a>{{vm.appAccount.watermarkImgContentType}}, {{vm.byteSize(vm.appAccount.watermarkImg)}}</div></dd><dt><span data-translate="jmrsignApp.appAccount.terms">Terms</span></dt><dd><span>{{vm.appAccount.terms}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocToSign">Tpl Doc To Sign</span></dt><dd><span>{{vm.appAccount.tplDocToSign}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocComplete">Tpl Doc Complete</span></dt><dd><span>{{vm.appAccount.tplDocComplete}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocReject">Tpl Doc Reject</span></dt><dd><span>{{vm.appAccount.tplDocReject}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.tplDocRemind">Tpl Doc Remind</span></dt><dd><span>{{vm.appAccount.tplDocRemind}}</span></dd><dt><span data-translate="jmrsignApp.appAccount.publicUse">Public Use</span></dt><dd><span>{{vm.appAccount.publicUse}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="app-account-detail.edit({id:vm.appAccount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/app-account/app-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAppAccountLabel" data-translate="jmrsignApp.appAccount.home.createOrEditLabel">Create or edit a App Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.appAccount.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.appAccount.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.appAccount.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.domain" for="field_domain">Domain</label><input type="text" class="form-control" name="domain" id="field_domain" ng-model="vm.appAccount.domain" required><div ng-show="editForm.domain.$invalid"><p class="help-block" ng-show="editForm.domain.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.allowUserRegistration" for="field_allowUserRegistration">Allow User Registration</label><input type="checkbox" class="form-control" name="allowUserRegistration" id="field_allowUserRegistration" ng-model="vm.appAccount.allowUserRegistration"><div ng-show="editForm.allowUserRegistration.$invalid"><p class="help-block" ng-show="editForm.allowUserRegistration.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.allowDigitalSig" for="field_allowDigitalSig">Allow Digital Sig</label><input type="checkbox" class="form-control" name="allowDigitalSig" id="field_allowDigitalSig" ng-model="vm.appAccount.allowDigitalSig"><div ng-show="editForm.allowDigitalSig.$invalid"><p class="help-block" ng-show="editForm.allowDigitalSig.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.allowTwoStepAuth" for="field_allowTwoStepAuth">Allow Two Step Auth</label><input type="checkbox" class="form-control" name="allowTwoStepAuth" id="field_allowTwoStepAuth" ng-model="vm.appAccount.allowTwoStepAuth"><div ng-show="editForm.allowTwoStepAuth.$invalid"><p class="help-block" ng-show="editForm.allowTwoStepAuth.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setLogoImg($file, vm.appAccount)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.appAccount.logoImg" for="field_logoImg">Logo Img</label><div><img data-ng-src="{{\'data:\' + vm.appAccount.logoImgContentType + \';base64,\' + vm.appAccount.logoImg}}" style="max-height: 100px" ng-if="vm.appAccount.logoImg"><div ng-if="vm.appAccount.logoImg" class="help-block clearfix"><span class="pull-left">{{vm.appAccount.logoImgContentType}}, {{vm.byteSize(vm.appAccount.logoImg)}}</span> <button type="button" ng-click="vm.appAccount.logoImg=null;vm.appAccount.logoImgContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setLogoImg($file, vm.appAccount)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="logoImg" id="field_logoImg" ng-model="vm.appAccount.logoImg"> <input type="hidden" class="form-control" name="logoImgContentType" id="field_logoImgContentType" ng-model="vm.appAccount.logoImgContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setWatermarkImg($file, vm.appAccount)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.appAccount.watermarkImg" for="field_watermarkImg">Watermark Img</label><div><img data-ng-src="{{\'data:\' + vm.appAccount.watermarkImgContentType + \';base64,\' + vm.appAccount.watermarkImg}}" style="max-height: 100px" ng-if="vm.appAccount.watermarkImg"><div ng-if="vm.appAccount.watermarkImg" class="help-block clearfix"><span class="pull-left">{{vm.appAccount.watermarkImgContentType}}, {{vm.byteSize(vm.appAccount.watermarkImg)}}</span> <button type="button" ng-click="vm.appAccount.watermarkImg=null;vm.appAccount.watermarkImgContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setWatermarkImg($file, vm.appAccount)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="watermarkImg" id="field_watermarkImg" ng-model="vm.appAccount.watermarkImg"> <input type="hidden" class="form-control" name="watermarkImgContentType" id="field_watermarkImgContentType" ng-model="vm.appAccount.watermarkImgContentType"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.terms" for="field_terms">Terms</label><input type="text" class="form-control" name="terms" id="field_terms" ng-model="vm.appAccount.terms"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.tplDocToSign" for="field_tplDocToSign">Tpl Doc To Sign</label><input type="text" class="form-control" name="tplDocToSign" id="field_tplDocToSign" ng-model="vm.appAccount.tplDocToSign"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.tplDocComplete" for="field_tplDocComplete">Tpl Doc Complete</label><input type="text" class="form-control" name="tplDocComplete" id="field_tplDocComplete" ng-model="vm.appAccount.tplDocComplete"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.tplDocReject" for="field_tplDocReject">Tpl Doc Reject</label><input type="text" class="form-control" name="tplDocReject" id="field_tplDocReject" ng-model="vm.appAccount.tplDocReject"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.tplDocRemind" for="field_tplDocRemind">Tpl Doc Remind</label><input type="text" class="form-control" name="tplDocRemind" id="field_tplDocRemind" ng-model="vm.appAccount.tplDocRemind"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.appAccount.publicUse" for="field_publicUse">Public Use</label><input type="checkbox" class="form-control" name="publicUse" id="field_publicUse" ng-model="vm.appAccount.publicUse"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/app-account/app-accounts.html','<div><h2 data-translate="jmrsignApp.appAccount.home.title">App Accounts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="app-account.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.appAccount.home.createLabel">Create new App Account</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.appAccount.title">Title</span></th><th><span data-translate="jmrsignApp.appAccount.domain">Domain</span></th><th><span data-translate="jmrsignApp.appAccount.allowUserRegistration">Allow User Registration</span></th><th><span data-translate="jmrsignApp.appAccount.allowDigitalSig">Allow Digital Sig</span></th><th><span data-translate="jmrsignApp.appAccount.allowTwoStepAuth">Allow Two Step Auth</span></th><th><span data-translate="jmrsignApp.appAccount.allowInitialPages">Allow Initial Pages</span></th><th><span data-translate="jmrsignApp.appAccount.logoImg">Logo Img</span></th><!-- <th><span data-translate="jmrsignApp.appAccount.watermarkImg">Watermark Img</span></th>\n                    <th><span data-translate="jmrsignApp.appAccount.terms">Terms</span></th>\n                    <th><span data-translate="jmrsignApp.appAccount.tplDocToSign">Tpl Doc To Sign</span></th>\n                    <th><span data-translate="jmrsignApp.appAccount.tplDocComplete">Tpl Doc Complete</span></th>\n                    <th><span data-translate="jmrsignApp.appAccount.tplDocReject">Tpl Doc Reject</span></th>\n                    <th><span data-translate="jmrsignApp.appAccount.tplDocRemind">Tpl Doc Remind</span></th>\n                    <th><span data-translate="jmrsignApp.appAccount.publicUse">Public Use</span></th> --><th></th></tr></thead><tbody><tr ng-repeat="appAccount in vm.appAccounts track by appAccount.id"><td><a ui-sref="app-account-detail({id:appAccount.id})">{{appAccount.id}}</a></td><td>{{appAccount.title}}</td><td>{{appAccount.domain}}</td><td>{{appAccount.allowUserRegistration}}</td><td>{{appAccount.allowDigitalSig}}</td><td>{{appAccount.allowTwoStepAuth}}</td><td>{{appAccount.allowInitialPages}}</td><td><a ng-if="appAccount.logoImg" ng-click="vm.openFile(appAccount.logoImgContentType, appAccount.logoImg)"><img data-ng-src="{{\'data:\' + appAccount.logoImgContentType + \';base64,\' + appAccount.logoImg}}" style="max-height: 30px"> </a><span ng-if="appAccount.logoImg">{{appAccount.logoImgContentType}}, {{vm.byteSize(appAccount.logoImg)}}</span></td><!--<td>\n                        <a ng-if="appAccount.watermarkImg" ng-click="vm.openFile(appAccount.watermarkImgContentType, appAccount.watermarkImg)">\n                            <img data-ng-src="{{\'data:\' + appAccount.watermarkImgContentType + \';base64,\' + appAccount.watermarkImg}}" style="max-height: 30px;"/>\n                        </a>\n                        <span ng-if="appAccount.watermarkImg">{{appAccount.watermarkImgContentType}}, {{vm.byteSize(appAccount.watermarkImg)}}</span>\n                    </td>\n                    <td>{{appAccount.terms}}</td>\n                    <td>{{appAccount.tplDocToSign}}</td>\n                    <td>{{appAccount.tplDocComplete}}</td>\n                    <td>{{appAccount.tplDocReject}}</td>\n                    <td>{{appAccount.tplDocRemind}}</td>\n                    <td>{{appAccount.publicUse}}</td>  --><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="app-account-detail({id:appAccount.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="app-account.edit({id:appAccount.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="app-account.delete({id:appAccount.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/document-version/document-version-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentVersion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.documentVersion.delete.question" translate-values="{id: \'{{vm.documentVersion.id}}\'}">Are you sure you want to delete this Document Version?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/document-version/document-version-detail.html','<div><h2><span data-translate="jmrsignApp.documentVersion.detail.title">Document Version</span> {{vm.documentVersion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.documentVersion.versionNo">Version No</span></dt><dd><span>{{vm.documentVersion.versionNo}}</span></dd><dt><span data-translate="jmrsignApp.documentVersion.fileRef">File Ref</span></dt><dd><span>{{vm.documentVersion.fileRef}}</span></dd><dt><span data-translate="jmrsignApp.documentVersion.data">Data</span></dt><dd><div ng-if="vm.documentVersion.data"><a ng-click="vm.openFile(vm.documentVersion.dataContentType, vm.documentVersion.data)" data-translate="entity.action.open">open</a> {{vm.documentVersion.dataContentType}}, {{vm.byteSize(vm.documentVersion.data)}}</div></dd><dt><span data-translate="jmrsignApp.documentVersion.document">Document</span></dt><dd><a ui-sref="document-detail({id:vm.documentVersion.documentId})">{{vm.documentVersion.documentId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="document-version-detail.edit({id:vm.documentVersion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/document-version/document-version-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentVersionLabel" data-translate="jmrsignApp.documentVersion.home.createOrEditLabel">Create or edit a Document Version</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documentVersion.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documentVersion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentVersion.versionNo" for="field_versionNo">Version No</label><input type="number" class="form-control" name="versionNo" id="field_versionNo" ng-model="vm.documentVersion.versionNo" required><div ng-show="editForm.versionNo.$invalid"><p class="help-block" ng-show="editForm.versionNo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.versionNo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentVersion.fileRef" for="field_fileRef">File Ref</label><input type="text" class="form-control" name="fileRef" id="field_fileRef" ng-model="vm.documentVersion.fileRef" required><div ng-show="editForm.fileRef.$invalid"><p class="help-block" ng-show="editForm.fileRef.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setData($file, vm.documentVersion)"><label class="control-label" data-translate="jmrsignApp.documentVersion.data" for="field_data">Data</label><div><div ng-if="vm.documentVersion.data" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.documentVersion.dataContentType, vm.documentVersion.data)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.documentVersion.dataContentType}}, {{vm.byteSize(vm.documentVersion.data)}}</span> <button type="button" ng-click="vm.documentVersion.data=null;vm.documentVersion.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setData($file, vm.documentVersion)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="data" id="field_data" ng-model="vm.documentVersion.data"> <input type="hidden" class="form-control" name="dataContentType" id="field_dataContentType" ng-model="vm.documentVersion.dataContentType"></div><div class="form-group"><label data-translate="jmrsignApp.documentVersion.document" for="field_document">Document</label><select class="form-control" id="field_document" name="document" ng-model="vm.documentVersion.documentId" ng-options="document.id as document.id for document in vm.documents"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/document-version/document-versions.html','<div><h2 data-translate="jmrsignApp.documentVersion.home.title">Document Versions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="document-version.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.documentVersion.home.createLabel">Create new Document Version</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.documentVersion.versionNo">Version No</span></th><th><span data-translate="jmrsignApp.documentVersion.fileRef">File Ref</span></th><th><span data-translate="jmrsignApp.documentVersion.data">Data</span></th><th><span data-translate="jmrsignApp.documentVersion.document">Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="documentVersion in vm.documentVersions track by documentVersion.id"><td><a ui-sref="document-version-detail({id:documentVersion.id})">{{documentVersion.id}}</a></td><td>{{documentVersion.versionNo}}</td><td>{{documentVersion.fileRef}}</td><td><a ng-if="documentVersion.data" ng-click="vm.openFile(documentVersion.dataContentType, documentVersion.data)" data-translate="entity.action.open">open</a> <span ng-if="documentVersion.data">{{documentVersion.dataContentType}}, {{vm.byteSize(documentVersion.data)}}</span></td><td><a ui-sref="document-detail({id:documentVersion.documentId})">{{documentVersion.documentId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="document-version-detail({id:documentVersion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="document-version.edit({id:documentVersion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="document-version.delete({id:documentVersion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/document-event/document-event-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentEvent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.documentEvent.delete.question" translate-values="{id: \'{{vm.documentEvent.id}}\'}">Are you sure you want to delete this Document Event?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/document-event/document-event-detail.html','<div><h2><span data-translate="jmrsignApp.documentEvent.detail.title">Document Event</span> {{vm.documentEvent.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.documentEvent.eventTimestamp">Event Timestamp</span></dt><dd><span>{{vm.documentEvent.eventTimestamp | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.documentEvent.eventGroup">Event Group</span></dt><dd><span>{{vm.documentEvent.eventGroup}}</span></dd><dt><span data-translate="jmrsignApp.documentEvent.description">Description</span></dt><dd><span>{{vm.documentEvent.description}}</span></dd><dt><span data-translate="jmrsignApp.documentEvent.restricted">Restricted</span></dt><dd><span>{{vm.documentEvent.restricted}}</span></dd><dt><span data-translate="jmrsignApp.documentEvent.type">Type</span></dt><dd><span data-translate="{{\'jmrsignApp.EventType.\' + vm.documentEvent.type}}">{{vm.documentEvent.type}}</span></dd><dt><span data-translate="jmrsignApp.documentEvent.document">Document</span></dt><dd><a ui-sref="document-detail({id:vm.documentEvent.documentId})">{{vm.documentEvent.documentId}}</a></dd><dt><span data-translate="jmrsignApp.documentEvent.workItem">Work Item</span></dt><dd><a ui-sref="document-work-item-detail({id:vm.documentEvent.workItemId})">{{vm.documentEvent.workItemId}}</a></dd><dt><span data-translate="jmrsignApp.documentEvent.party">Party</span></dt><dd><a ui-sref="party-detail({id:vm.documentEvent.partyId})">{{vm.documentEvent.partyId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="document-event-detail.edit({id:vm.documentEvent.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/document-event/document-event-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentEventLabel" data-translate="jmrsignApp.documentEvent.home.createOrEditLabel">Create or edit a Document Event</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documentEvent.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documentEvent.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentEvent.eventTimestamp" for="field_eventTimestamp">Event Timestamp</label><div class="input-group"><input id="field_eventTimestamp" type="text" class="form-control" name="eventTimestamp" datetime-picker="{{dateformat}}" ng-model="vm.documentEvent.eventTimestamp" is-open="vm.datePickerOpenStatus.eventTimestamp" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'eventTimestamp\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.eventTimestamp.$invalid"><p class="help-block" ng-show="editForm.eventTimestamp.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.eventTimestamp.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentEvent.eventGroup" for="field_eventGroup">Event Group</label><input type="text" class="form-control" name="eventGroup" id="field_eventGroup" ng-model="vm.documentEvent.eventGroup" required><div ng-show="editForm.eventGroup.$invalid"><p class="help-block" ng-show="editForm.eventGroup.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentEvent.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.documentEvent.description" required><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentEvent.restricted" for="field_restricted">Restricted</label><input type="checkbox" class="form-control" name="restricted" id="field_restricted" ng-model="vm.documentEvent.restricted"><div ng-show="editForm.restricted.$invalid"><p class="help-block" ng-show="editForm.restricted.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentEvent.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.documentEvent.type" id="field_type" required><option value="INFO" data-translate="jmrsignApp.EventType.INFO">INFO</option><option value="SUCCESS" data-translate="jmrsignApp.EventType.SUCCESS">SUCCESS</option><option value="FAILURE" data-translate="jmrsignApp.EventType.FAILURE">FAILURE</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="jmrsignApp.documentEvent.document" for="field_document">Document</label><select class="form-control" id="field_document" name="document" ng-model="vm.documentEvent.documentId" ng-options="document.id as document.id for document in vm.documents"><option value=""></option></select></div><div class="form-group"><label data-translate="jmrsignApp.documentEvent.workItem" for="field_workItem">Work Item</label><select class="form-control" id="field_workItem" name="workItem" ng-model="vm.documentEvent.workItemId" ng-options="documentWorkItem.id as documentWorkItem.id for documentWorkItem in vm.documentworkitems"><option value=""></option></select></div><div class="form-group"><label data-translate="jmrsignApp.documentEvent.party" for="field_party">Party</label><select class="form-control" id="field_party" name="party" ng-model="vm.documentEvent.partyId" ng-options="party.id as party.id for party in vm.parties"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/document-event/document-events.html','<div><h2 data-translate="jmrsignApp.documentEvent.home.title">Document Events</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="document-event.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.documentEvent.home.createLabel">Create new Document Event</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.documentEvent.eventTimestamp">Event Timestamp</span></th><th><span data-translate="jmrsignApp.documentEvent.eventGroup">Event Group</span></th><th><span data-translate="jmrsignApp.documentEvent.description">Description</span></th><th><span data-translate="jmrsignApp.documentEvent.restricted">Restricted</span></th><th><span data-translate="jmrsignApp.documentEvent.type">Type</span></th><th><span data-translate="jmrsignApp.documentEvent.document">Document</span></th><th><span data-translate="jmrsignApp.documentEvent.workItem">Work Item</span></th><th><span data-translate="jmrsignApp.documentEvent.party">Party</span></th><th></th></tr></thead><tbody><tr ng-repeat="documentEvent in vm.documentEvents track by documentEvent.id"><td><a ui-sref="document-event-detail({id:documentEvent.id})">{{documentEvent.id}}</a></td><td>{{documentEvent.eventTimestamp | date:\'medium\'}}</td><td>{{documentEvent.eventGroup}}</td><td>{{documentEvent.description}}</td><td>{{documentEvent.restricted}}</td><td data-translate="{{\'jmrsignApp.EventType.\' + documentEvent.type}}">{{documentEvent.type}}</td><td><a ui-sref="document-detail({id:documentEvent.documentId})">{{documentEvent.documentId}}</a></td><td><a ui-sref="document-work-item-detail({id:documentEvent.workItemId})">{{documentEvent.workItemId}}</a></td><td><a ui-sref="party-detail({id:documentEvent.partyId})">{{documentEvent.partyId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="document-event-detail({id:documentEvent.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="document-event.edit({id:documentEvent.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="document-event.delete({id:documentEvent.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/document-version-page/document-version-page-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentVersionPage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.documentVersionPage.delete.question" translate-values="{id: \'{{vm.documentVersionPage.id}}\'}">Are you sure you want to delete this Document Version Page?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/document-version-page/document-version-page-detail.html','<div><h2><span data-translate="jmrsignApp.documentVersionPage.detail.title">Document Version Page</span> {{vm.documentVersionPage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.documentVersionPage.pageNo">Page No</span></dt><dd><span>{{vm.documentVersionPage.pageNo}}</span></dd><dt><span data-translate="jmrsignApp.documentVersionPage.fileRef">File Ref</span></dt><dd><span>{{vm.documentVersionPage.fileRef}}</span></dd><dt><span data-translate="jmrsignApp.documentVersionPage.data">Data</span></dt><dd><div ng-if="vm.documentVersionPage.data"><a ng-click="vm.openFile(vm.documentVersionPage.dataContentType, vm.documentVersionPage.data)"><img data-ng-src="{{\'data:\' + vm.documentVersionPage.dataContentType + \';base64,\' + vm.documentVersionPage.data}}" style="max-width: 100%"> </a>{{vm.documentVersionPage.dataContentType}}, {{vm.byteSize(vm.documentVersionPage.data)}}</div></dd><dt><span data-translate="jmrsignApp.documentVersionPage.imageHeight">Image Height</span></dt><dd><span>{{vm.documentVersionPage.imageHeight}}</span></dd><dt><span data-translate="jmrsignApp.documentVersionPage.imageWidth">Image Width</span></dt><dd><span>{{vm.documentVersionPage.imageWidth}}</span></dd><dt><span data-translate="jmrsignApp.documentVersionPage.documentVersion">Document Version</span></dt><dd><a ui-sref="document-version-detail({id:vm.documentVersionPage.documentVersionId})">{{vm.documentVersionPage.documentVersionId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="document-version-page-detail.edit({id:vm.documentVersionPage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/document-version-page/document-version-page-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentVersionPageLabel" data-translate="jmrsignApp.documentVersionPage.home.createOrEditLabel">Create or edit a Document Version Page</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documentVersionPage.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documentVersionPage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentVersionPage.pageNo" for="field_pageNo">Page No</label><input type="number" class="form-control" name="pageNo" id="field_pageNo" ng-model="vm.documentVersionPage.pageNo" required><div ng-show="editForm.pageNo.$invalid"><p class="help-block" ng-show="editForm.pageNo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pageNo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentVersionPage.fileRef" for="field_fileRef">File Ref</label><input type="text" class="form-control" name="fileRef" id="field_fileRef" ng-model="vm.documentVersionPage.fileRef" required><div ng-show="editForm.fileRef.$invalid"><p class="help-block" ng-show="editForm.fileRef.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setData($file, vm.documentVersionPage)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.documentVersionPage.data" for="field_data">Data</label><div><img data-ng-src="{{\'data:\' + vm.documentVersionPage.dataContentType + \';base64,\' + vm.documentVersionPage.data}}" style="max-height: 100px" ng-if="vm.documentVersionPage.data"><div ng-if="vm.documentVersionPage.data" class="help-block clearfix"><span class="pull-left">{{vm.documentVersionPage.dataContentType}}, {{vm.byteSize(vm.documentVersionPage.data)}}</span> <button type="button" ng-click="vm.documentVersionPage.data=null;vm.documentVersionPage.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setData($file, vm.documentVersionPage)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="data" id="field_data" ng-model="vm.documentVersionPage.data"> <input type="hidden" class="form-control" name="dataContentType" id="field_dataContentType" ng-model="vm.documentVersionPage.dataContentType"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentVersionPage.imageHeight" for="field_imageHeight">Image Height</label><input type="number" class="form-control" name="imageHeight" id="field_imageHeight" ng-model="vm.documentVersionPage.imageHeight"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentVersionPage.imageWidth" for="field_imageWidth">Image Width</label><input type="number" class="form-control" name="imageWidth" id="field_imageWidth" ng-model="vm.documentVersionPage.imageWidth"></div><div class="form-group"><label data-translate="jmrsignApp.documentVersionPage.documentVersion" for="field_documentVersion">Document Version</label><select class="form-control" id="field_documentVersion" name="documentVersion" ng-model="vm.documentVersionPage.documentVersionId" ng-options="documentVersion.id as documentVersion.id for documentVersion in vm.documentversions"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/document-version-page/document-version-pages.html','<div><h2 data-translate="jmrsignApp.documentVersionPage.home.title">Document Version Pages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="document-version-page.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.documentVersionPage.home.createLabel">Create new Document Version Page</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.documentVersionPage.pageNo">Page No</span></th><th><span data-translate="jmrsignApp.documentVersionPage.fileRef">File Ref</span></th><th><span data-translate="jmrsignApp.documentVersionPage.data">Data</span></th><th><span data-translate="jmrsignApp.documentVersionPage.imageHeight">Image Height</span></th><th><span data-translate="jmrsignApp.documentVersionPage.imageWidth">Image Width</span></th><th><span data-translate="jmrsignApp.documentVersionPage.documentVersion">Document Version</span></th><th></th></tr></thead><tbody><tr ng-repeat="documentVersionPage in vm.documentVersionPages track by documentVersionPage.id"><td><a ui-sref="document-version-page-detail({id:documentVersionPage.id})">{{documentVersionPage.id}}</a></td><td>{{documentVersionPage.pageNo}}</td><td>{{documentVersionPage.fileRef}}</td><td><a ng-if="documentVersionPage.data" ng-click="vm.openFile(documentVersionPage.dataContentType, documentVersionPage.data)"><img data-ng-src="{{\'data:\' + documentVersionPage.dataContentType + \';base64,\' + documentVersionPage.data}}" style="max-height: 30px"> </a><span ng-if="documentVersionPage.data">{{documentVersionPage.dataContentType}}, {{vm.byteSize(documentVersionPage.data)}}</span></td><td>{{documentVersionPage.imageHeight}}</td><td>{{documentVersionPage.imageWidth}}</td><td><a ui-sref="document-version-detail({id:documentVersionPage.documentVersionId})">{{documentVersionPage.documentVersionId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="document-version-page-detail({id:documentVersionPage.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="document-version-page.edit({id:documentVersionPage.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="document-version-page.delete({id:documentVersionPage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/document-work-item/document-work-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentWorkItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.documentWorkItem.delete.question" translate-values="{id: \'{{vm.documentWorkItem.id}}\'}">Are you sure you want to delete this Document Work Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/document-work-item/document-work-item-detail.html','<div><h2><span data-translate="jmrsignApp.documentWorkItem.detail.title">Document Work Item</span> {{vm.documentWorkItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.documentWorkItem.seqNo">Seq No</span></dt><dd><span>{{vm.documentWorkItem.seqNo}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.startDate">Start Date</span></dt><dd><span>{{vm.documentWorkItem.startDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.endDate">End Date</span></dt><dd><span>{{vm.documentWorkItem.endDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.email">Email</span></dt><dd><span>{{vm.documentWorkItem.email}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.legalName">Legal Name</span></dt><dd><span>{{vm.documentWorkItem.legalName}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.accessCode">Access Code</span></dt><dd><span>{{vm.documentWorkItem.accessCode}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.note">Note</span></dt><dd><span>{{vm.documentWorkItem.note}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.roleName">Role Name</span></dt><dd><span>{{vm.documentWorkItem.roleName}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.signature">Signature</span></dt><dd><div ng-if="vm.documentWorkItem.signature"><a ng-click="vm.openFile(vm.documentWorkItem.signatureContentType, vm.documentWorkItem.signature)" data-translate="entity.action.open">open</a> {{vm.documentWorkItem.signatureContentType}}, {{vm.byteSize(vm.documentWorkItem.signature)}}</div></dd><dt><span data-translate="jmrsignApp.documentWorkItem.signatureImg">Signature Img</span></dt><dd><div ng-if="vm.documentWorkItem.signatureImg"><a ng-click="vm.openFile(vm.documentWorkItem.signatureImgContentType, vm.documentWorkItem.signatureImg)"><img data-ng-src="{{\'data:\' + vm.documentWorkItem.signatureImgContentType + \';base64,\' + vm.documentWorkItem.signatureImg}}" style="max-width: 100%"> </a>{{vm.documentWorkItem.signatureImgContentType}}, {{vm.byteSize(vm.documentWorkItem.signatureImg)}}</div></dd><dt><span data-translate="jmrsignApp.documentWorkItem.initialImg">Initial Img</span></dt><dd><div ng-if="vm.documentWorkItem.initialImg"><a ng-click="vm.openFile(vm.documentWorkItem.initialImgContentType, vm.documentWorkItem.initialImg)"><img data-ng-src="{{\'data:\' + vm.documentWorkItem.initialImgContentType + \';base64,\' + vm.documentWorkItem.initialImg}}" style="max-width: 100%"> </a>{{vm.documentWorkItem.initialImgContentType}}, {{vm.byteSize(vm.documentWorkItem.initialImg)}}</div></dd><dt><span data-translate="jmrsignApp.documentWorkItem.pageNo">Page No</span></dt><dd><span>{{vm.documentWorkItem.pageNo}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.xPos">X Pos</span></dt><dd><span>{{vm.documentWorkItem.xPos}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.yPos">Y Pos</span></dt><dd><span>{{vm.documentWorkItem.yPos}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.requireTwoStepAuth">Require Two Step Auth</span></dt><dd><span>{{vm.documentWorkItem.requireTwoStepAuth}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.requireSignedCopy">Require Signed Copy</span></dt><dd><span>{{vm.documentWorkItem.requireSignedCopy}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.type">Type</span></dt><dd><span data-translate="{{\'jmrsignApp.WorkItemType.\' + vm.documentWorkItem.type}}">{{vm.documentWorkItem.type}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.status">Status</span></dt><dd><span data-translate="{{\'jmrsignApp.WorkItemStatus.\' + vm.documentWorkItem.status}}">{{vm.documentWorkItem.status}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItem.party">Party</span></dt><dd><a ui-sref="party-detail({id:vm.documentWorkItem.partyId})">{{vm.documentWorkItem.partyId}}</a></dd><dt><span data-translate="jmrsignApp.documentWorkItem.document">Document</span></dt><dd><a ui-sref="document-detail({id:vm.documentWorkItem.documentId})">{{vm.documentWorkItem.documentId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="document-work-item-detail.edit({id:vm.documentWorkItem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/document-work-item/document-work-item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentWorkItemLabel" data-translate="jmrsignApp.documentWorkItem.home.createOrEditLabel">Create or edit a Document Work Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documentWorkItem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documentWorkItem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.seqNo" for="field_seqNo">Seq No</label><input type="number" class="form-control" name="seqNo" id="field_seqNo" ng-model="vm.documentWorkItem.seqNo" required><div ng-show="editForm.seqNo.$invalid"><p class="help-block" ng-show="editForm.seqNo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.seqNo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.startDate" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.documentWorkItem.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.endDate" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datetime-picker="{{dateformat}}" ng-model="vm.documentWorkItem.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.documentWorkItem.email"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.legalName" for="field_legalName">Legal Name</label><input type="text" class="form-control" name="legalName" id="field_legalName" ng-model="vm.documentWorkItem.legalName"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.accessCode" for="field_accessCode">Access Code</label><input type="text" class="form-control" name="accessCode" id="field_accessCode" ng-model="vm.documentWorkItem.accessCode"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.note" for="field_note">Note</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.documentWorkItem.note"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.roleName" for="field_roleName">Role Name</label><input type="text" class="form-control" name="roleName" id="field_roleName" ng-model="vm.documentWorkItem.roleName"></div><div class="form-group" ngf-drop ngf-change="vm.setSignature($file, vm.documentWorkItem)"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.signature" for="field_signature">Signature</label><div><div ng-if="vm.documentWorkItem.signature" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.documentWorkItem.signatureContentType, vm.documentWorkItem.signature)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.documentWorkItem.signatureContentType}}, {{vm.byteSize(vm.documentWorkItem.signature)}}</span> <button type="button" ng-click="vm.documentWorkItem.signature=null;vm.documentWorkItem.signatureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignature($file, vm.documentWorkItem)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="signature" id="field_signature" ng-model="vm.documentWorkItem.signature"> <input type="hidden" class="form-control" name="signatureContentType" id="field_signatureContentType" ng-model="vm.documentWorkItem.signatureContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setSignatureImg($file, vm.documentWorkItem)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.signatureImg" for="field_signatureImg">Signature Img</label><div><img data-ng-src="{{\'data:\' + vm.documentWorkItem.signatureImgContentType + \';base64,\' + vm.documentWorkItem.signatureImg}}" style="max-height: 100px" ng-if="vm.documentWorkItem.signatureImg"><div ng-if="vm.documentWorkItem.signatureImg" class="help-block clearfix"><span class="pull-left">{{vm.documentWorkItem.signatureImgContentType}}, {{vm.byteSize(vm.documentWorkItem.signatureImg)}}</span> <button type="button" ng-click="vm.documentWorkItem.signatureImg=null;vm.documentWorkItem.signatureImgContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignatureImg($file, vm.documentWorkItem)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="signatureImg" id="field_signatureImg" ng-model="vm.documentWorkItem.signatureImg"> <input type="hidden" class="form-control" name="signatureImgContentType" id="field_signatureImgContentType" ng-model="vm.documentWorkItem.signatureImgContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setInitialImg($file, vm.documentWorkItem)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.initialImg" for="field_initialImg">Initial Img</label><div><img data-ng-src="{{\'data:\' + vm.documentWorkItem.initialImgContentType + \';base64,\' + vm.documentWorkItem.initialImg}}" style="max-height: 100px" ng-if="vm.documentWorkItem.initialImg"><div ng-if="vm.documentWorkItem.initialImg" class="help-block clearfix"><span class="pull-left">{{vm.documentWorkItem.initialImgContentType}}, {{vm.byteSize(vm.documentWorkItem.initialImg)}}</span> <button type="button" ng-click="vm.documentWorkItem.initialImg=null;vm.documentWorkItem.initialImgContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setInitialImg($file, vm.documentWorkItem)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="initialImg" id="field_initialImg" ng-model="vm.documentWorkItem.initialImg"> <input type="hidden" class="form-control" name="initialImgContentType" id="field_initialImgContentType" ng-model="vm.documentWorkItem.initialImgContentType"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.pageNo" for="field_pageNo">Page No</label><input type="number" class="form-control" name="pageNo" id="field_pageNo" ng-model="vm.documentWorkItem.pageNo"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.xPos" for="field_xPos">X Pos</label><input type="number" class="form-control" name="xPos" id="field_xPos" ng-model="vm.documentWorkItem.xPos"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.yPos" for="field_yPos">Y Pos</label><input type="number" class="form-control" name="yPos" id="field_yPos" ng-model="vm.documentWorkItem.yPos"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.requireTwoStepAuth" for="field_requireTwoStepAuth">Require Two Step Auth</label><input type="checkbox" class="form-control" name="requireTwoStepAuth" id="field_requireTwoStepAuth" ng-model="vm.documentWorkItem.requireTwoStepAuth"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.requireSignedCopy" for="field_requireSignedCopy">Require Signed Copy</label><input type="checkbox" class="form-control" name="requireSignedCopy" id="field_requireSignedCopy" ng-model="vm.documentWorkItem.requireSignedCopy"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.documentWorkItem.type" id="field_type" required><option value="EDITOR" data-translate="jmrsignApp.WorkItemType.EDITOR">EDITOR</option><option value="AGENT" data-translate="jmrsignApp.WorkItemType.AGENT">AGENT</option><option value="SIGNER" data-translate="jmrsignApp.WorkItemType.SIGNER">SIGNER</option><option value="INPERSON_SIGN" data-translate="jmrsignApp.WorkItemType.INPERSON_SIGN">INPERSON_SIGN</option><option value="CARBON_COPY" data-translate="jmrsignApp.WorkItemType.CARBON_COPY">CARBON_COPY</option><option value="SIGNED_COPY" data-translate="jmrsignApp.WorkItemType.SIGNED_COPY">SIGNED_COPY</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.documentWorkItem.status" id="field_status" required><option value="UNASSIGNED" data-translate="jmrsignApp.WorkItemStatus.UNASSIGNED">UNASSIGNED</option><option value="PENDING" data-translate="jmrsignApp.WorkItemStatus.PENDING">PENDING</option><option value="NOTIFIED" data-translate="jmrsignApp.WorkItemStatus.NOTIFIED">NOTIFIED</option><option value="COMPLETED" data-translate="jmrsignApp.WorkItemStatus.COMPLETED">COMPLETED</option><option value="REJECTED" data-translate="jmrsignApp.WorkItemStatus.REJECTED">REJECTED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="jmrsignApp.documentWorkItem.party" for="field_party">Party</label><select class="form-control" id="field_party" name="party" ng-model="vm.documentWorkItem.partyId" ng-options="party.id as party.id for party in vm.parties"><option value=""></option></select></div><div class="form-group"><label data-translate="jmrsignApp.documentWorkItem.document" for="field_document">Document</label><select class="form-control" id="field_document" name="document" ng-model="vm.documentWorkItem.documentId" ng-options="document.id as document.id for document in vm.documents"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/document-work-item/document-work-items.html','<div><h2 data-translate="jmrsignApp.documentWorkItem.home.title">Document Work Items</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="document-work-item.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.documentWorkItem.home.createLabel">Create new Document Work Item</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.documentWorkItem.seqNo">Seq No</span></th><th><span data-translate="jmrsignApp.documentWorkItem.startDate">Start Date</span></th><th><span data-translate="jmrsignApp.documentWorkItem.endDate">End Date</span></th><th><span data-translate="jmrsignApp.documentWorkItem.email">Email</span></th><th><span data-translate="jmrsignApp.documentWorkItem.legalName">Legal Name</span></th><th><span data-translate="jmrsignApp.documentWorkItem.accessCode">Access Code</span></th><th><span data-translate="jmrsignApp.documentWorkItem.note">Note</span></th><th><span data-translate="jmrsignApp.documentWorkItem.roleName">Role Name</span></th><th><span data-translate="jmrsignApp.documentWorkItem.signature">Signature</span></th><th><span data-translate="jmrsignApp.documentWorkItem.signatureImg">Signature Img</span></th><th><span data-translate="jmrsignApp.documentWorkItem.initialImg">Initial Img</span></th><th><span data-translate="jmrsignApp.documentWorkItem.pageNo">Page No</span></th><th><span data-translate="jmrsignApp.documentWorkItem.xPos">X Pos</span></th><th><span data-translate="jmrsignApp.documentWorkItem.yPos">Y Pos</span></th><th><span data-translate="jmrsignApp.documentWorkItem.requireTwoStepAuth">Require Two Step Auth</span></th><th><span data-translate="jmrsignApp.documentWorkItem.requireSignedCopy">Require Signed Copy</span></th><th><span data-translate="jmrsignApp.documentWorkItem.type">Type</span></th><th><span data-translate="jmrsignApp.documentWorkItem.status">Status</span></th><th><span data-translate="jmrsignApp.documentWorkItem.party">Party</span></th><th><span data-translate="jmrsignApp.documentWorkItem.document">Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="documentWorkItem in vm.documentWorkItems track by documentWorkItem.id"><td><a ui-sref="document-work-item-detail({id:documentWorkItem.id})">{{documentWorkItem.id}}</a></td><td>{{documentWorkItem.seqNo}}</td><td>{{documentWorkItem.startDate | date:\'medium\'}}</td><td>{{documentWorkItem.endDate | date:\'medium\'}}</td><td>{{documentWorkItem.email}}</td><td>{{documentWorkItem.legalName}}</td><td>{{documentWorkItem.accessCode}}</td><td>{{documentWorkItem.note}}</td><td>{{documentWorkItem.roleName}}</td><td><a ng-if="documentWorkItem.signature" ng-click="vm.openFile(documentWorkItem.signatureContentType, documentWorkItem.signature)" data-translate="entity.action.open">open</a> <span ng-if="documentWorkItem.signature">{{documentWorkItem.signatureContentType}}, {{vm.byteSize(documentWorkItem.signature)}}</span></td><td><a ng-if="documentWorkItem.signatureImg" ng-click="vm.openFile(documentWorkItem.signatureImgContentType, documentWorkItem.signatureImg)"><img data-ng-src="{{\'data:\' + documentWorkItem.signatureImgContentType + \';base64,\' + documentWorkItem.signatureImg}}" style="max-height: 30px"> </a><span ng-if="documentWorkItem.signatureImg">{{documentWorkItem.signatureImgContentType}}, {{vm.byteSize(documentWorkItem.signatureImg)}}</span></td><td><a ng-if="documentWorkItem.initialImg" ng-click="vm.openFile(documentWorkItem.initialImgContentType, documentWorkItem.initialImg)"><img data-ng-src="{{\'data:\' + documentWorkItem.initialImgContentType + \';base64,\' + documentWorkItem.initialImg}}" style="max-height: 30px"> </a><span ng-if="documentWorkItem.initialImg">{{documentWorkItem.initialImgContentType}}, {{vm.byteSize(documentWorkItem.initialImg)}}</span></td><td>{{documentWorkItem.pageNo}}</td><td>{{documentWorkItem.xPos}}</td><td>{{documentWorkItem.yPos}}</td><td>{{documentWorkItem.requireTwoStepAuth}}</td><td>{{documentWorkItem.requireSignedCopy}}</td><td data-translate="{{\'jmrsignApp.WorkItemType.\' + documentWorkItem.type}}">{{documentWorkItem.type}}</td><td data-translate="{{\'jmrsignApp.WorkItemStatus.\' + documentWorkItem.status}}">{{documentWorkItem.status}}</td><td><a ui-sref="party-detail({id:documentWorkItem.partyId})">{{documentWorkItem.partyId}}</a></td><td><a ui-sref="document-detail({id:documentWorkItem.documentId})">{{documentWorkItem.documentId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="document-work-item-detail({id:documentWorkItem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="document-work-item.edit({id:documentWorkItem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="document-work-item.delete({id:documentWorkItem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/document-work-item-action/document-work-item-action-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentWorkItemAction.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.documentWorkItemAction.delete.question" translate-values="{id: \'{{vm.documentWorkItemAction.id}}\'}">Are you sure you want to delete this Document Work Item Action?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/document-work-item-action/document-work-item-action-detail.html','<div><h2><span data-translate="jmrsignApp.documentWorkItemAction.detail.title">Document Work Item Action</span> {{vm.documentWorkItemAction.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.documentWorkItemAction.seqNo">Seq No</span></dt><dd><span>{{vm.documentWorkItemAction.seqNo}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.startDate">Start Date</span></dt><dd><span>{{vm.documentWorkItemAction.startDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.endDate">End Date</span></dt><dd><span>{{vm.documentWorkItemAction.endDate | date:\'medium\'}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.textData">Text Data</span></dt><dd><span>{{vm.documentWorkItemAction.textData}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.imageData">Image Data</span></dt><dd><div ng-if="vm.documentWorkItemAction.imageData"><a ng-click="vm.openFile(vm.documentWorkItemAction.imageDataContentType, vm.documentWorkItemAction.imageData)"><img data-ng-src="{{\'data:\' + vm.documentWorkItemAction.imageDataContentType + \';base64,\' + vm.documentWorkItemAction.imageData}}" style="max-width: 100%"> </a>{{vm.documentWorkItemAction.imageDataContentType}}, {{vm.byteSize(vm.documentWorkItemAction.imageData)}}</div></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.pageNo">Page No</span></dt><dd><span>{{vm.documentWorkItemAction.pageNo}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.xPos">X Pos</span></dt><dd><span>{{vm.documentWorkItemAction.xPos}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.yPos">Y Pos</span></dt><dd><span>{{vm.documentWorkItemAction.yPos}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.type">Type</span></dt><dd><span data-translate="{{\'jmrsignApp.WorkItemActionType.\' + vm.documentWorkItemAction.type}}">{{vm.documentWorkItemAction.type}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.status">Status</span></dt><dd><span data-translate="{{\'jmrsignApp.WorkItemActionStatus.\' + vm.documentWorkItemAction.status}}">{{vm.documentWorkItemAction.status}}</span></dd><dt><span data-translate="jmrsignApp.documentWorkItemAction.workItem">Work Item</span></dt><dd><a ui-sref="document-work-item-detail({id:vm.documentWorkItemAction.workItemId})">{{vm.documentWorkItemAction.workItemId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="document-work-item-action-detail.edit({id:vm.documentWorkItemAction.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/document-work-item-action/document-work-item-action-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentWorkItemActionLabel" data-translate="jmrsignApp.documentWorkItemAction.home.createOrEditLabel">Create or edit a Document Work Item Action</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documentWorkItemAction.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documentWorkItemAction.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.seqNo" for="field_seqNo">Seq No</label><input type="number" class="form-control" name="seqNo" id="field_seqNo" ng-model="vm.documentWorkItemAction.seqNo" required><div ng-show="editForm.seqNo.$invalid"><p class="help-block" ng-show="editForm.seqNo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.seqNo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.startDate" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.documentWorkItemAction.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.endDate" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datetime-picker="{{dateformat}}" ng-model="vm.documentWorkItemAction.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.textData" for="field_textData">Text Data</label><input type="text" class="form-control" name="textData" id="field_textData" ng-model="vm.documentWorkItemAction.textData"></div><div class="form-group" ngf-drop ngf-change="vm.setImageData($file, vm.documentWorkItemAction)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.imageData" for="field_imageData">Image Data</label><div><img data-ng-src="{{\'data:\' + vm.documentWorkItemAction.imageDataContentType + \';base64,\' + vm.documentWorkItemAction.imageData}}" style="max-height: 100px" ng-if="vm.documentWorkItemAction.imageData"><div ng-if="vm.documentWorkItemAction.imageData" class="help-block clearfix"><span class="pull-left">{{vm.documentWorkItemAction.imageDataContentType}}, {{vm.byteSize(vm.documentWorkItemAction.imageData)}}</span> <button type="button" ng-click="vm.documentWorkItemAction.imageData=null;vm.documentWorkItemAction.imageDataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImageData($file, vm.documentWorkItemAction)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imageData" id="field_imageData" ng-model="vm.documentWorkItemAction.imageData"> <input type="hidden" class="form-control" name="imageDataContentType" id="field_imageDataContentType" ng-model="vm.documentWorkItemAction.imageDataContentType"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.pageNo" for="field_pageNo">Page No</label><input type="number" class="form-control" name="pageNo" id="field_pageNo" ng-model="vm.documentWorkItemAction.pageNo"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.xPos" for="field_xPos">X Pos</label><input type="number" class="form-control" name="xPos" id="field_xPos" ng-model="vm.documentWorkItemAction.xPos"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.yPos" for="field_yPos">Y Pos</label><input type="number" class="form-control" name="yPos" id="field_yPos" ng-model="vm.documentWorkItemAction.yPos"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.documentWorkItemAction.type" id="field_type" required><option value="VIEW_DOCUMENT" data-translate="jmrsignApp.WorkItemActionType.VIEW_DOCUMENT">VIEW_DOCUMENT</option><option value="AGREE_TERMS" data-translate="jmrsignApp.WorkItemActionType.AGREE_TERMS">AGREE_TERMS</option><option value="TWO_STEP_AUTH" data-translate="jmrsignApp.WorkItemActionType.TWO_STEP_AUTH">TWO_STEP_AUTH</option><option value="VALIDATE_CODE" data-translate="jmrsignApp.WorkItemActionType.VALIDATE_CODE">VALIDATE_CODE</option><option value="INITIAL_HERE" data-translate="jmrsignApp.WorkItemActionType.INITIAL_HERE">INITIAL_HERE</option><option value="SIGN_HERE" data-translate="jmrsignApp.WorkItemActionType.SIGN_HERE">SIGN_HERE</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItemAction.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.documentWorkItemAction.status" id="field_status" required><option value="TODO" data-translate="jmrsignApp.WorkItemActionStatus.TODO">TODO</option><option value="COMPLETED" data-translate="jmrsignApp.WorkItemActionStatus.COMPLETED">COMPLETED</option><option value="REJECTED" data-translate="jmrsignApp.WorkItemActionStatus.REJECTED">REJECTED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="jmrsignApp.documentWorkItemAction.workItem" for="field_workItem">Work Item</label><select class="form-control" id="field_workItem" name="workItem" ng-model="vm.documentWorkItemAction.workItemId" ng-options="documentWorkItem.id as documentWorkItem.id for documentWorkItem in vm.documentworkitems"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/document-work-item-action/document-work-item-actions.html','<div><h2 data-translate="jmrsignApp.documentWorkItemAction.home.title">Document Work Item Actions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="document-work-item-action.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.documentWorkItemAction.home.createLabel">Create new Document Work Item Action</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.seqNo">Seq No</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.startDate">Start Date</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.endDate">End Date</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.textData">Text Data</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.imageData">Image Data</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.pageNo">Page No</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.xPos">X Pos</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.yPos">Y Pos</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.type">Type</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.status">Status</span></th><th><span data-translate="jmrsignApp.documentWorkItemAction.workItem">Work Item</span></th><th></th></tr></thead><tbody><tr ng-repeat="documentWorkItemAction in vm.documentWorkItemActions track by documentWorkItemAction.id"><td><a ui-sref="document-work-item-action-detail({id:documentWorkItemAction.id})">{{documentWorkItemAction.id}}</a></td><td>{{documentWorkItemAction.seqNo}}</td><td>{{documentWorkItemAction.startDate | date:\'medium\'}}</td><td>{{documentWorkItemAction.endDate | date:\'medium\'}}</td><td>{{documentWorkItemAction.textData}}</td><td><a ng-if="documentWorkItemAction.imageData" ng-click="vm.openFile(documentWorkItemAction.imageDataContentType, documentWorkItemAction.imageData)"><img data-ng-src="{{\'data:\' + documentWorkItemAction.imageDataContentType + \';base64,\' + documentWorkItemAction.imageData}}" style="max-height: 30px"> </a><span ng-if="documentWorkItemAction.imageData">{{documentWorkItemAction.imageDataContentType}}, {{vm.byteSize(documentWorkItemAction.imageData)}}</span></td><td>{{documentWorkItemAction.pageNo}}</td><td>{{documentWorkItemAction.xPos}}</td><td>{{documentWorkItemAction.yPos}}</td><td data-translate="{{\'jmrsignApp.WorkItemActionType.\' + documentWorkItemAction.type}}">{{documentWorkItemAction.type}}</td><td data-translate="{{\'jmrsignApp.WorkItemActionStatus.\' + documentWorkItemAction.status}}">{{documentWorkItemAction.status}}</td><td><a ui-sref="document-work-item-detail({id:documentWorkItemAction.workItemId})">{{documentWorkItemAction.workItemId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="document-work-item-action-detail({id:documentWorkItemAction.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="document-work-item-action.edit({id:documentWorkItemAction.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="document-work-item-action.delete({id:documentWorkItemAction.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/party/parties.html','<div><h2 data-translate="jmrsignApp.party.home.title">Parties</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="party.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="jmrsignApp.party.home.createLabel">Create new Party</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="jmrsignApp.party.internalSystemRef">Internal System Ref</span></th><th><span data-translate="jmrsignApp.party.email">Email</span></th><th><span data-translate="jmrsignApp.party.firstName">First Name</span></th><th><span data-translate="jmrsignApp.party.lastName">Last Name</span></th><th><span data-translate="jmrsignApp.party.cellNumber">Cell Number</span></th><th><span data-translate="jmrsignApp.party.newCellNumber">New Cell Number</span></th><th><span data-translate="jmrsignApp.party.validationCode">Validation Code</span></th><th><span data-translate="jmrsignApp.party.signature">Signature</span></th><th><span data-translate="jmrsignApp.party.signatureImg">Signature Img</span></th><th><span data-translate="jmrsignApp.party.initialImg">Initial Img</span></th><th><span data-translate="jmrsignApp.party.allowUserUpdate">Allow User Update</span></th><th><span data-translate="jmrsignApp.party.type">Type</span></th><th><span data-translate="jmrsignApp.party.status">Status</span></th><th><span data-translate="jmrsignApp.party.user">User</span></th><th><span data-translate="jmrsignApp.party.account">Account</span></th><th></th></tr></thead><tbody><tr ng-repeat="party in vm.parties track by party.id"><td><a ui-sref="party-detail({id:party.id})">{{party.id}}</a></td><td>{{party.internalSystemRef}}</td><td>{{party.email}}</td><td>{{party.firstName}}</td><td>{{party.lastName}}</td><td>{{party.cellNumber}}</td><td>{{party.newCellNumber}}</td><td>{{party.validationCode}}</td><td><a ng-if="party.signature" ng-click="vm.openFile(party.signatureContentType, party.signature)" data-translate="entity.action.open">open</a> <span ng-if="party.signature">{{party.signatureContentType}}, {{vm.byteSize(party.signature)}}</span></td><td><a ng-if="party.signatureImg" ng-click="vm.openFile(party.signatureImgContentType, party.signatureImg)"><img data-ng-src="{{\'data:\' + party.signatureImgContentType + \';base64,\' + party.signatureImg}}" style="max-height: 30px"> </a><span ng-if="party.signatureImg">{{party.signatureImgContentType}}, {{vm.byteSize(party.signatureImg)}}</span></td><td><a ng-if="party.initialImg" ng-click="vm.openFile(party.initialImgContentType, party.initialImg)"><img data-ng-src="{{\'data:\' + party.initialImgContentType + \';base64,\' + party.initialImg}}" style="max-height: 30px"> </a><span ng-if="party.initialImg">{{party.initialImgContentType}}, {{vm.byteSize(party.initialImg)}}</span></td><td>{{party.allowUserUpdate}}</td><td data-translate="{{\'jmrsignApp.PartyType.\' + party.type}}">{{party.type}}</td><td data-translate="{{\'jmrsignApp.PartyStatus.\' + party.status}}">{{party.status}}</td><td>{{party.userId}}</td><td><a ui-sref="app-account-detail({id:party.accountId})">{{party.accountId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="party-detail({id:party.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="party.edit({id:party.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="party.delete({id:party.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/party/party-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.party.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.party.delete.question" translate-values="{id: \'{{vm.party.id}}\'}">Are you sure you want to delete this Party?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/party/party-detail.html','<div><h2><span data-translate="jmrsignApp.party.detail.title">Party</span> {{vm.party.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="jmrsignApp.party.internalSystemRef">Internal System Ref</span></dt><dd><span>{{vm.party.internalSystemRef}}</span></dd><dt><span data-translate="jmrsignApp.party.email">Email</span></dt><dd><span>{{vm.party.email}}</span></dd><dt><span data-translate="jmrsignApp.party.firstName">First Name</span></dt><dd><span>{{vm.party.firstName}}</span></dd><dt><span data-translate="jmrsignApp.party.lastName">Last Name</span></dt><dd><span>{{vm.party.lastName}}</span></dd><dt><span data-translate="jmrsignApp.party.cellNumber">Cell Number</span></dt><dd><span>{{vm.party.cellNumber}}</span></dd><dt><span data-translate="jmrsignApp.party.newCellNumber">New Cell Number</span></dt><dd><span>{{vm.party.newCellNumber}}</span></dd><dt><span data-translate="jmrsignApp.party.validationCode">Validation Code</span></dt><dd><span>{{vm.party.validationCode}}</span></dd><dt><span data-translate="jmrsignApp.party.signature">Signature</span></dt><dd><div ng-if="vm.party.signature"><a ng-click="vm.openFile(vm.party.signatureContentType, vm.party.signature)" data-translate="entity.action.open">open</a> {{vm.party.signatureContentType}}, {{vm.byteSize(vm.party.signature)}}</div></dd><dt><span data-translate="jmrsignApp.party.signatureImg">Signature Img</span></dt><dd><div ng-if="vm.party.signatureImg"><a ng-click="vm.openFile(vm.party.signatureImgContentType, vm.party.signatureImg)"><img data-ng-src="{{\'data:\' + vm.party.signatureImgContentType + \';base64,\' + vm.party.signatureImg}}" style="max-width: 100%"> </a>{{vm.party.signatureImgContentType}}, {{vm.byteSize(vm.party.signatureImg)}}</div></dd><dt><span data-translate="jmrsignApp.party.initialImg">Initial Img</span></dt><dd><div ng-if="vm.party.initialImg"><a ng-click="vm.openFile(vm.party.initialImgContentType, vm.party.initialImg)"><img data-ng-src="{{\'data:\' + vm.party.initialImgContentType + \';base64,\' + vm.party.initialImg}}" style="max-width: 100%"> </a>{{vm.party.initialImgContentType}}, {{vm.byteSize(vm.party.initialImg)}}</div></dd><dt><span data-translate="jmrsignApp.party.allowUserUpdate">Allow User Update</span></dt><dd><span>{{vm.party.allowUserUpdate}}</span></dd><dt><span data-translate="jmrsignApp.party.type">Type</span></dt><dd><span data-translate="{{\'jmrsignApp.PartyType.\' + vm.party.type}}">{{vm.party.type}}</span></dd><dt><span data-translate="jmrsignApp.party.status">Status</span></dt><dd><span data-translate="{{\'jmrsignApp.PartyStatus.\' + vm.party.status}}">{{vm.party.status}}</span></dd><dt><span data-translate="jmrsignApp.party.user">User</span></dt><dd>{{vm.party.userId}}</dd><dt><span data-translate="jmrsignApp.party.account">Account</span></dt><dd><a ui-sref="app-account-detail({id:vm.party.accountId})">{{vm.party.accountId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="party-detail.edit({id:vm.party.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/party/party-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPartyLabel" data-translate="jmrsignApp.party.home.createOrEditLabel">Create or edit a Party</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.party.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.party.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.internalSystemRef" for="field_internalSystemRef">Internal System Ref</label><input type="text" class="form-control" name="internalSystemRef" id="field_internalSystemRef" ng-model="vm.party.internalSystemRef" required><div ng-show="editForm.internalSystemRef.$invalid"><p class="help-block" ng-show="editForm.internalSystemRef.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.party.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.party.firstName" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.party.lastName" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.cellNumber" for="field_cellNumber">Cell Number</label><input type="text" class="form-control" name="cellNumber" id="field_cellNumber" ng-model="vm.party.cellNumber"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.newCellNumber" for="field_newCellNumber">New Cell Number</label><input type="text" class="form-control" name="newCellNumber" id="field_newCellNumber" ng-model="vm.party.newCellNumber"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.validationCode" for="field_validationCode">Validation Code</label><input type="text" class="form-control" name="validationCode" id="field_validationCode" ng-model="vm.party.validationCode"></div><div class="form-group" ngf-drop ngf-change="vm.setSignature($file, vm.party)"><label class="control-label" data-translate="jmrsignApp.party.signature" for="field_signature">Signature</label><div><div ng-if="vm.party.signature" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.party.signatureContentType, vm.party.signature)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.party.signatureContentType}}, {{vm.byteSize(vm.party.signature)}}</span> <button type="button" ng-click="vm.party.signature=null;vm.party.signatureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignature($file, vm.party)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="signature" id="field_signature" ng-model="vm.party.signature"> <input type="hidden" class="form-control" name="signatureContentType" id="field_signatureContentType" ng-model="vm.party.signatureContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setSignatureImg($file, vm.party)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.party.signatureImg" for="field_signatureImg">Signature Img</label><div><img data-ng-src="{{\'data:\' + vm.party.signatureImgContentType + \';base64,\' + vm.party.signatureImg}}" style="max-height: 100px" ng-if="vm.party.signatureImg"><div ng-if="vm.party.signatureImg" class="help-block clearfix"><span class="pull-left">{{vm.party.signatureImgContentType}}, {{vm.byteSize(vm.party.signatureImg)}}</span> <button type="button" ng-click="vm.party.signatureImg=null;vm.party.signatureImgContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignatureImg($file, vm.party)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="signatureImg" id="field_signatureImg" ng-model="vm.party.signatureImg"> <input type="hidden" class="form-control" name="signatureImgContentType" id="field_signatureImgContentType" ng-model="vm.party.signatureImgContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setInitialImg($file, vm.party)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="jmrsignApp.party.initialImg" for="field_initialImg">Initial Img</label><div><img data-ng-src="{{\'data:\' + vm.party.initialImgContentType + \';base64,\' + vm.party.initialImg}}" style="max-height: 100px" ng-if="vm.party.initialImg"><div ng-if="vm.party.initialImg" class="help-block clearfix"><span class="pull-left">{{vm.party.initialImgContentType}}, {{vm.byteSize(vm.party.initialImg)}}</span> <button type="button" ng-click="vm.party.initialImg=null;vm.party.initialImgContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setInitialImg($file, vm.party)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="initialImg" id="field_initialImg" ng-model="vm.party.initialImg"> <input type="hidden" class="form-control" name="initialImgContentType" id="field_initialImgContentType" ng-model="vm.party.initialImgContentType"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.allowUserUpdate" for="field_allowUserUpdate">Allow User Update</label><input type="checkbox" class="form-control" name="allowUserUpdate" id="field_allowUserUpdate" ng-model="vm.party.allowUserUpdate"><div ng-show="editForm.allowUserUpdate.$invalid"><p class="help-block" ng-show="editForm.allowUserUpdate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.party.type" id="field_type" required><option value="EXTERNAL_USER" data-translate="jmrsignApp.PartyType.EXTERNAL_USER">EXTERNAL_USER</option><option value="INTERNAL_USER" data-translate="jmrsignApp.PartyType.INTERNAL_USER">INTERNAL_USER</option><option value="ACCOUNT_USER" data-translate="jmrsignApp.PartyType.ACCOUNT_USER">ACCOUNT_USER</option><option value="ADMIN" data-translate="jmrsignApp.PartyType.ADMIN">ADMIN</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.party.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.party.status" id="field_status" required><option value="RESTRICTED" data-translate="jmrsignApp.PartyStatus.RESTRICTED">RESTRICTED</option><option value="ENABLED" data-translate="jmrsignApp.PartyStatus.ENABLED">ENABLED</option><option value="DISABLED" data-translate="jmrsignApp.PartyStatus.DISABLED">DISABLED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="jmrsignApp.party.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.party.userId" ng-options="user.id as user.id for user in vm.users"><option value=""></option></select></div><div class="form-group"><label data-translate="jmrsignApp.party.account" for="field_account">Account</label><select class="form-control" id="field_account" name="account" ng-model="vm.party.accountId" ng-options="appAccount.id as appAccount.id for appAccount in vm.appaccounts"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/documents/workitems/documents-work-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentWorkItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="jmrsignApp.documentWorkItem.delete.question" translate-values="{id: \'{{vm.documentWorkItem.id}}\'}">Are you sure you want to delete this Document Work Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/documents/workitems/documents-work-item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentWorkItemLabel" data-translate="jmrsignApp.documentWorkItem.home.createOrEditLabel">Create or edit a Document Work Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documentWorkItem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documentWorkItem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.documentWorkItem.type" id="field_type" required><option value="EDITOR" data-translate="jmrsignApp.WorkItemType.EDITOR">EDITOR</option><option value="AGENT" data-translate="jmrsignApp.WorkItemType.AGENT">AGENT</option><option value="SIGNER" data-translate="jmrsignApp.WorkItemType.SIGNER">SIGNER</option><option value="INPERSON_SIGN" data-translate="jmrsignApp.WorkItemType.INPERSON_SIGN">INPERSON_SIGN</option><option value="CARBON_COPY" data-translate="jmrsignApp.WorkItemType.CARBON_COPY">CARBON_COPY</option><option value="SIGNED_COPY" data-translate="jmrsignApp.WorkItemType.SIGNED_COPY">SIGNED_COPY</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.seqNo" for="field_seqNo">Seq No</label><input type="number" class="form-control" name="seqNo" id="field_seqNo" ng-model="vm.documentWorkItem.seqNo" required><div ng-show="editForm.seqNo.$invalid"><p class="help-block" ng-show="editForm.seqNo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.seqNo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="jmrsignApp.documentWorkItem.party" for="field_party">Party</label><select class="form-control" id="field_party" name="party" ng-model="vm.documentWorkItem.partyId" ng-options="party.id as party.id for party in vm.parties"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.documentWorkItem.email"></div><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.legalName" for="field_legalName">Legal Name</label><input type="text" class="form-control" name="legalName" id="field_legalName" ng-model="vm.documentWorkItem.legalName"></div><!-- <div class="form-group">\n            <label class="control-label" data-translate="jmrsignApp.documentWorkItem.accessCode" for="field_accessCode">Access Code</label>\n            <input type="text" class="form-control" name="accessCode" id="field_accessCode"\n                    ng-model="vm.documentWorkItem.accessCode"\n                     />\n        </div> --><!-- <div class="form-group">\n            <label class="control-label" data-translate="jmrsignApp.documentWorkItem.note" for="field_note">Note</label>\n            <input type="text" class="form-control" name="note" id="field_note"\n                    ng-model="vm.documentWorkItem.note"\n                     />\n        </div> --><div class="form-group"><label class="control-label" data-translate="jmrsignApp.documentWorkItem.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.documentWorkItem.status" id="field_status" required><option value="PENDING" data-translate="jmrsignApp.WorkItemStatus.PENDING">PENDING</option><option value="NOTIFIED" data-translate="jmrsignApp.WorkItemStatus.NOTIFIED">NOTIFIED</option><option value="COMPLETED" data-translate="jmrsignApp.WorkItemStatus.COMPLETED">COMPLETED</option><option value="REJECTED" data-translate="jmrsignApp.WorkItemStatus.REJECTED">REJECTED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/layouts/navbar/navbar.html','<div class="topbar"><!-- LOGO --><div class="topbar-left"><div class="text-center"><a href="#/" class="logo"><img id="logo-image" ng-src="/api/accounts/{{vm.accountId}}/logo" style="width: 50%;max-height: 60px"><!-- <span>{{vm.info.siteTitle}}</span> --></a></div></div><!-- Button mobile view to collapse sidebar menu --><div class="navbar navbar-default" role="navigation"><div class="container"><div class=""><!-- <div class="pull-left">\n                    <button type="button" class="button-menu-mobile open-left">\n                    <i class="fa fa-bars"></i>\n                    </button>\n                    <span class="clearfix"></span>\n                </div> --><div id="navigation"><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><!-- Navigation Menu--><ul class="nav navbar-nav navbar-left pull-left"><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="inbox" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="global.menu.inbox">Inbox</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="vm.minRole(\'INTERNAL_USER\')"><a ui-sref="documents" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-folder-open"></span> <span class="hidden-sm" data-translate="global.menu.documents">Documents</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN2" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="document" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.document">Document</span></a></li><li ui-sref-active="active"><a ui-sref="document-version" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documentVersion">Document Version</span></a></li><li ui-sref-active="active"><a ui-sref="document-version-page" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documentVersionPage">Document Version Page</span></a></li><li ui-sref-active="active"><a ui-sref="app-account" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.appAccount">App Account</span></a></li><li ui-sref-active="active"><a ui-sref="document-work-item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documentWorkItem">Document Work Item</span></a></li><li ui-sref-active="active"><a ui-sref="document-work-item-action" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documentWorkItemAction">Document Work Item Action</span></a></li><li ui-sref-active="active"><a ui-sref="party" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.party">Party</span></a></li><li ui-sref-active="active"><a ui-sref="document-event" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documentEvent">Document Event</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" ng-if="vm.minRole(\'ADMIN\')" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="app-admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="app-account-profile" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cog"></span>&nbsp; <span>Company Profile</span></a></li><li ui-sref-active="active"><a ui-sref="party-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!-- <li ui-sref-active="active" ng-switch-when="true">\n                                <a ui-sref="settings" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-wrench"></span>&nbsp;\n                                    <span data-translate="global.menu.account.settings">Settings</span>\n                                </a>\n                            </li> --><li ui-sref-active="active" ng-switch-when="true" ng-if="!vm.disabled"><a ui-sref="my-party" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.account.signature">Signature</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="root-cert" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span> <span class="hidden-sm">Root Certificate</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="app-account" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Tenant management</span></a></li><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul><!-- End navigation menu  --></div></div></div><!--/.nav-collapse --></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="wrapper-page" ng-cloak><div class="ex-page-content text-center"><h1 data-translate="error.title">Error!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div><!-- end wrapper page --></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="col-md-8 col-md-offset-2"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title" data-translate="reset.finish.title">Reset password</h3></div><div class="panel-body"><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default panel-fill"><div class="panel-heading"><h3 class="panel-title" data-translate="reset.request.title">Reset your password</h3></div><div class="panel-body"><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div></div>');
$templateCache.put('app/account/social/directive/social.html','<form action="{{ providerURL }}" method="POST"><button type="submit" class="btn btn-block jh-btn-social jh-btn-{{ provider }}"><span data-translate="social.btnLabel" translate-values="{ label: label }">Sign in with {{ label }}</span></button> <input name="scope" type="hidden" value="{{\xA0providerSetting }}"> <input name="_csrf" type="hidden" value="{{\xA0csrf }}"></form>');}]);})();